import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  API_URL,
  MESSAGE_ENDPOINTS,
  AI_ENDPOINTS,
  PROFILE_ENDPOINTS,
  WS_ENDPOINT,
} from "../config";
import { useThemeCssVars } from "../styles/commonHooks";
import ai from "../assets/chat_page/ai.png";
import support from "../assets/chat_page/support.png";

import PdfToTextModal from "../components/PdfToTextModal";
import useToast from "../hooks/useToast";
import Avatar from "../components/Avatar";

import { LH, LAVENDER_HAZE } from "../styles/chatPageLightTheme";

// import иконок для share'инга
import telegramIcon from "../assets/chat_page/Frame_telegram.svg"
import instagramIcon from "../assets/chat_page/Frame_instagram.svg"
import facebookIcon from "../assets/chat_page/Frame_facebook.svg"
import outlookIcon from "../assets/chat_page/Frame_outlook.svg"
import whatsappIcon from "../assets/chat_page/Frame_whatsapp.svg"

import linkedinIcon from "../assets/chat_page/Frame_linkedin.svg";
import emailIcon from "../assets/chat_page/Frame_email.svg";
import phoneIcon from "../assets/chat_page/Frame_phone.svg";

const MessageAnimations = ({ theme }) => {
  const isLight = theme !== "dark";
  return (
  <style>{`
    .attachment-menu-container {
  position: relative;
  isolation: isolate;
  overflow: visible;
  color: ${isLight ? LH.attachmentText : "#f0f4ff"};
  transition: all 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.attachment-menu-btn {
  background: ${isLight ? LH.attachmentBtnBg : "rgba(40, 50, 90, 0.28)"};
  border: 1px solid ${isLight ? LH.attachmentBtnBorder : "rgba(120, 140, 255, 0.16)"};
  color: ${isLight ? LH.attachmentText : "#f0f4ff"};
  font-size: 14px;
  border-radius: 14px;
  padding: 10px 14px;
  flex: 1;
  font-weight: 500;
  transition: all 0.24s ease;
}

.attachment-menu-btn:hover {
  background: ${isLight ? LH.attachmentBtnHover : "rgba(50, 60, 110, 0.45)"};
  transform: translateY(-1px);
  box-shadow: 0 6px 20px ${isLight ? LH.attachmentBtnShadow : "rgba(0,0,0,0.30)"};
}

    @keyframes matchReasonIn {
      from { opacity: 0; transform: translateY(-6px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    .match-reason-body {
      overflow: hidden;
      transition:
        max-height 0.32s cubic-bezier(0,0,0.2,1),
        opacity    0.24s ease,
        transform  0.28s cubic-bezier(0,0,0.2,1);
    }
    .match-reason-body.collapsed {
      max-height: 0 !important;
      opacity: 0;
      transform: translateY(-6px);
      transition:
        max-height 0.26s cubic-bezier(0.4,0,1,1),
        opacity    0.18s ease,
        transform  0.22s ease;
    }
    .match-reason-toggle {
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      opacity: 0.6;
      padding: 2px 6px;
      border-radius: 6px;
      transition: opacity 0.15s ease, background 0.15s ease;
      color: inherit;
    }
    .match-reason-toggle:hover { opacity: 1; background: rgba(128,128,255,0.10); }
    .match-reason-chevron {
      transition: transform 0.26s cubic-bezier(0.22,1,0.36,1);
    }
    .match-reason-chevron.collapsed { transform: rotate(-90deg); }

    /* Table slot compact bar */
    @keyframes slotBarIn {
      from { opacity: 0; transform: translateY(-8px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    @keyframes yellowPulse {
      0%, 100% { box-shadow: 0 0 0 0 rgba(254,202,87,0); background: transparent; }
      50%       { box-shadow: 0 0 0 6px rgba(254,202,87,0.18); background: rgba(254,202,87,0.08); }
    }
    .searching-pulse {
      animation: yellowPulse 1.4s ease-in-out infinite;
    }

    @keyframes starPop {
      0%   { transform: scale(1); }
      35%  { transform: scale(0.72) rotate(-8deg); }
      65%  { transform: scale(1.38) rotate(6deg); }
      85%  { transform: scale(0.92) rotate(-2deg); }
      100% { transform: scale(1) rotate(0deg); }
    }
    @keyframes ratingBadgePulse {
      0%   { opacity: 0; transform: translateY(4px) scale(0.85); }
      60%  { opacity: 1; transform: translateY(-2px) scale(1.06); }
      100% { opacity: 1; transform: translateY(0) scale(1); }
    }
    .star-btn {
      background: none;
      border: none;
      padding: 0 2px;
      cursor: pointer;
      line-height: 1;
      transition: filter 0.14s ease;
    }
    .star-btn:hover { filter: brightness(1.25); }
    .star-btn.star-active svg { animation: starPop 0.38s cubic-bezier(0.22,1,0.36,1); }
    .profile-section-divider {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 4px 0 10px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      opacity: 0.45;
      color: ${isLight ? LH.profileDividerText : "#c8d4ff"};
    }
    .profile-section-divider::before,
    .profile-section-divider::after {
      content: "";
      flex: 1;
      height: 1px;
      background: currentColor;
      opacity: 0.35;
    }

    @keyframes messageInLeft {
      from { opacity: 0; transform: translateX(-12px) translateY(6px) scale(0.96); }
      to   { opacity: 1; transform: translateX(0) translateY(0) scale(1); }
    }
    @keyframes messageInRight {
      from { opacity: 0; transform: translateX(12px) translateY(6px) scale(0.96); }
      to   { opacity: 1; transform: translateX(0) translateY(0) scale(1); }
    }
    @keyframes bubbleMorph {
      from { opacity: 0; transform: scaleY(0.75); }
      to   { opacity: 1; transform: scaleY(1); }
    }
    @keyframes sendPulse {
      0%   { transform: scale(1); }
      50%  { transform: scale(1.05); }
      100% { transform: scale(1); }
    }
    @keyframes typingDots {
      0%, 100% { opacity: 0.4; }
      50%      { opacity: 1; }
    }
    @keyframes gearRotate {
      from { transform: rotate(0deg); }
      to   { transform: rotate(90deg); }
    }

    @keyframes rainbowRotate {
      0%   { background-position: 0% 50%; }
      50%  { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .table-rainbow-border {
      position: relative;
      border-radius: 14px;
    }
    .table-rainbow-border::before {
      content: '';
      position: absolute;
      inset: -2px;
      border-radius: 15px;
      background: linear-gradient(
        270deg,
        #ff6b6b, #feca57, #48dbfb, #ff9ff3, #54a0ff, #5f27cd, #ff6b6b
      );
      background-size: 400% 400%;
      animation: rainbowRotate 2.5s linear infinite;
      z-index: 0;
      opacity: 0.9;
    }
    .table-rainbow-border > * {
      position: relative;
      z-index: 1;
    }

    .liquid-glass {
      position: relative;
      isolation: isolate;
      overflow: visible;
      backdrop-filter: blur(16px) saturate(180%);
      -webkit-backdrop-filter: blur(16px) saturate(180%);
      background: ${isLight ? LH.liquidGlassBg : "rgba(30, 40, 70, 0.38)"};
      border: 1px solid ${isLight ? LH.liquidGlassBorder : "rgba(120, 140, 255, 0.18)"};
      border-radius: 24px;
      box-shadow: ${isLight ? LH.liquidGlassShadow : "0 8px 32px rgba(0,0,0, 0.38), inset 0 1px 1px rgba(255,255,255,0.07), inset 0 -1px 1px rgba(0,0,0,0.18)"};
      color: ${isLight ? LH.liquidGlassText : "#f0f4ff"};
      transition: all 0.28s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .liquid-glass button:hover,
    .liquid-glass button:focus-within {
      background: ${isLight ? LH.liquidGlassHoverBg : "rgba(35, 45, 80, 0.48)"};
      border-color: ${isLight ? LH.liquidGlassHoverBorder : "rgba(140, 160, 255, 0.28)"};
      box-shadow: ${isLight ? LH.liquidGlassHoverShadow : "0 12px 40px rgba(0,0,0,0.45), inset 0 1px 2px rgba(255,255,255,0.10), inset 0 -1px 2px rgba(0,0,0,0.22)"};
      transform: translateY(-1px);
    }

    .ai-glass-button {
      border-radius: 999px;
      padding: 4px;
      backdrop-filter: blur(14px) saturate(160%);
      -webkit-backdrop-filter: blur(14px) saturate(160%);
      background: ${isLight ? LH.aiGlassBg : "rgba(255, 255, 255, 0.08)"};
      border: 1px solid ${isLight ? LH.aiGlassBorder : "rgba(255, 255, 255, 0.18)"};
      box-shadow: 0 6px 20px ${isLight ? LH.aiGlassShadow : "rgba(0,0,0,0.35)"}, inset 0 1px 1px ${isLight ? LH.aiGlassInset : "rgba(255,255,255,0.08)"};
      transition: all 0.25s ease;
    }

    .ai-glass-button:hover { background: ${isLight ? LH.aiGlassHoverBg : "rgba(255, 255, 255, 0.12)"}; }

    .attachment-btn:disabled {
      opacity: 0.38 !important;
      cursor: not-allowed !important;
      transform: none !important;
      box-shadow: none !important;
    }

    .chat-messages > div:last-child { margin-bottom: 60px !important; }

    .typing-dot {
      animation: typingDots 1.4s infinite;
      display: inline-block;
      width: 6px;
    }
    .typing-dot:nth-child(2) { animation-delay: 0.2s; }
    .typing-dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes iconPop {
      0%   { transform: scale(1); }
      40%  { transform: scale(0.82); }
      70%  { transform: scale(1.18); }
      100% { transform: scale(1); }
    }
    @keyframes sendFly {
      0%   { transform: scale(1) translateX(0); opacity: 1; }
      40%  { transform: scale(0.85) translateX(4px); opacity: 0.7; }
      70%  { transform: scale(1.15) translateX(-2px); opacity: 1; }
      100% { transform: scale(1) translateX(0); opacity: 1; }
    }
    .icon-btn-pop:active img {
      animation: iconPop 0.32s cubic-bezier(0.22, 1, 0.36, 1);
    }
    .icon-btn-send:active img {
      animation: sendFly 0.36s cubic-bezier(0.22, 1, 0.36, 1);
    }

    /* ── Chat list item animations ── */
    @keyframes chatItemIn {
      from { opacity: 0; transform: translateX(-8px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    @keyframes ripple {
      0%   { transform: scale(0); opacity: 0.5; }
      100% { transform: scale(3); opacity: 0; }
    }
    @keyframes selectPop {
      0%   { transform: scale(1); }
      35%  { transform: scale(0.97); }
      70%  { transform: scale(1.015); }
      100% { transform: scale(1); }
    }

    /* Chat list item */
    .chat-list-item {
      position: relative;
      overflow: hidden;
      transition: background 0.18s ease, transform 0.16s cubic-bezier(0.22,1,0.36,1), box-shadow 0.18s ease, border-left-color 0.18s ease !important;
    }
    .chat-list-item:hover {
      background: ${isLight ? LH.chatItemHoverBg : "rgba(140,160,255,0.07)"} !important;
      transform: translateX(2px);
      box-shadow: inset 3px 0 0 ${isLight ? LH.chatItemHoverEdge : "rgba(140,160,255,0.28)"};
    }
    .chat-list-item:active {
      animation: selectPop 0.28s cubic-bezier(0.22,1,0.36,1);
      background: ${isLight ? LH.chatItemActiveBg : "rgba(140,160,255,0.13)"} !important;
    }
    .chat-list-item .chat-ripple {
      position: absolute;
      border-radius: 50%;
      background: ${isLight ? LH.chatItemRipple : "rgba(140,160,255,0.18)"};
      pointer-events: none;
      width: 40px; height: 40px;
      margin-top: -20px; margin-left: -20px;
      animation: ripple 0.5s ease-out forwards;
    }
    .chat-list-item .chat-avatar {
      transition: transform 0.2s cubic-bezier(0.22,1,0.36,1);
    }
    .chat-list-item:hover .chat-avatar {
      transform: scale(1.08);
    }

    /* ───────────────── Mobile layout fixes (no double scroll) ───────────────── */
    @media (max-width: 767px) {
      html, body, #root {
        overflow: hidden !important;
        overscroll-behavior: none;
        height: 100%;
        max-height: 100%;
        position: relative;
        /* Блокируем нативный double-tap-zoom, оставляем обычный тап/скролл */
        touch-action: manipulation;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
      }
      .chat-page-root,
      .chat-page-root * {
        touch-action: manipulation;
      }
      /* Полю ввода и текстовым областям нужен pan-y чтобы курсор работал нормально */
      .chat-page-root textarea,
      .chat-page-root input {
        touch-action: pan-y;
      }
      .chat-page-root {
        height: auto !important;
        max-height: none !important;
        bottom: 0 !important;
        top: 50px !important;
        left: 0 !important;
        right: 0 !important;
      }
      .chat-page-root .chat-sidebar {
        height: 100% !important;
        max-height: 100% !important;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
      }
      .chat-page-root .chat-main {
        height: 100% !important;
        max-height: 100% !important;
        min-height: 0 !important;
      }
      .chat-page-root .chat-messages-container {
        height: 100% !important;
        max-height: 100% !important;
        min-height: 0 !important;
      }
      .chat-page-root .chat-messages {
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
        height: 100% !important;
        max-height: 100% !important;
        min-height: 0 !important;
      }
      .chat-page-root .chat-messages > div:last-child {
        margin-bottom: 0 !important;
      }
      /* Prevent rogue children from forcing horizontal overflow */
      .chat-page-root .chat-messages > div {
        max-width: 100%;
      }
      .chat-page-root .chat-messages-container {
        overflow-x: hidden !important;
      }
      .chat-page-root .chat-input-wrapper {
        max-width: 100vw !important;
      }
    }
  `}</style>
  );
};

const ChatBackground = ({ theme }) => {
  const isDark = theme === "dark";
  const iconColor = isDark ? "rgba(120,140,255,0.13)" : LH.bgIconFill;
  const strokeColor = isDark ? "rgba(120,140,255,0.18)" : LH.bgIconStroke;

  // Icon shapes: type, x, y, size, rotation
  const icons = [
    // Row 1
    { t: "robot",   x: 42,  y: 28,  s: 22, r: -12 },
    { t: "gear",    x: 130, y: 18,  s: 18, r: 15  },
    { t: "monitor", x: 218, y: 30,  s: 20, r: -8  },
    { t: "person",  x: 310, y: 22,  s: 16, r: 10  },
    { t: "robot",   x: 395, y: 35,  s: 18, r: 20  },
    { t: "gear",    x: 480, y: 18,  s: 14, r: -15 },
    { t: "chart",   x: 560, y: 28,  s: 20, r: 8   },
    { t: "robot",   x: 650, y: 15,  s: 16, r: -20 },
    { t: "globe",   x: 730, y: 30,  s: 18, r: 12  },
    { t: "gear",    x: 810, y: 20,  s: 16, r: -10 },
    { t: "monitor", x: 890, y: 32,  s: 18, r: 15  },
    { t: "person",  x: 970, y: 18,  s: 14, r: -8  },
    // Row 2
    { t: "globe",   x: 18,  y: 90,  s: 18, r: 8   },
    { t: "chart",   x: 95,  y: 82,  s: 20, r: -15 },
    { t: "gear",    x: 180, y: 95,  s: 16, r: 20  },
    { t: "robot",   x: 260, y: 85,  s: 22, r: -10 },
    { t: "monitor", x: 350, y: 90,  s: 18, r: 12  },
    { t: "globe",   x: 435, y: 80,  s: 16, r: -18 },
    { t: "person",  x: 510, y: 92,  s: 18, r: 8   },
    { t: "gear",    x: 600, y: 85,  s: 22, r: -12 },
    { t: "chart",   x: 685, y: 92,  s: 16, r: 15  },
    { t: "robot",   x: 760, y: 80,  s: 20, r: -20 },
    { t: "monitor", x: 845, y: 90,  s: 16, r: 10  },
    { t: "globe",   x: 930, y: 82,  s: 18, r: -8  },
    // Row 3
    { t: "person",  x: 55,  y: 155, s: 16, r: -12 },
    { t: "robot",   x: 140, y: 148, s: 20, r: 18  },
    { t: "chart",   x: 225, y: 158, s: 18, r: -8  },
    { t: "gear",    x: 305, y: 145, s: 22, r: 10  },
    { t: "globe",   x: 390, y: 155, s: 16, r: -20 },
    { t: "monitor", x: 468, y: 148, s: 20, r: 12  },
    { t: "robot",   x: 545, y: 158, s: 16, r: -10 },
    { t: "chart",   x: 628, y: 145, s: 18, r: 20  },
    { t: "gear",    x: 712, y: 155, s: 16, r: -15 },
    { t: "person",  x: 795, y: 148, s: 20, r: 8   },
    { t: "globe",   x: 878, y: 158, s: 16, r: -12 },
    { t: "robot",   x: 958, y: 145, s: 18, r: 15  },
    // Row 4
    { t: "monitor", x: 28,  y: 220, s: 18, r: 10  },
    { t: "gear",    x: 110, y: 212, s: 16, r: -18 },
    { t: "globe",   x: 192, y: 222, s: 20, r: 8   },
    { t: "robot",   x: 278, y: 215, s: 16, r: -12 },
    { t: "chart",   x: 358, y: 224, s: 18, r: 15  },
    { t: "person",  x: 440, y: 212, s: 22, r: -8  },
    { t: "gear",    x: 522, y: 222, s: 16, r: 20  },
    { t: "monitor", x: 602, y: 215, s: 20, r: -15 },
    { t: "globe",   x: 688, y: 222, s: 16, r: 10  },
    { t: "robot",   x: 768, y: 212, s: 18, r: -20 },
    { t: "chart",   x: 852, y: 222, s: 16, r: 12  },
    { t: "gear",    x: 938, y: 215, s: 20, r: -8  },
    // Row 5
    { t: "robot",   x: 65,  y: 285, s: 20, r: -15 },
    { t: "person",  x: 148, y: 278, s: 16, r: 10  },
    { t: "chart",   x: 230, y: 288, s: 18, r: -8  },
    { t: "gear",    x: 315, y: 278, s: 22, r: 18  },
    { t: "monitor", x: 400, y: 288, s: 16, r: -12 },
    { t: "globe",   x: 482, y: 278, s: 20, r: 8   },
    { t: "robot",   x: 565, y: 288, s: 16, r: -20 },
    { t: "chart",   x: 648, y: 278, s: 18, r: 15  },
    { t: "person",  x: 730, y: 288, s: 16, r: -10 },
    { t: "gear",    x: 812, y: 278, s: 20, r: 12  },
    { t: "monitor", x: 895, y: 285, s: 16, r: -15 },
    { t: "globe",   x: 975, y: 278, s: 18, r: 8   },
    // Row 6
    { t: "gear",    x: 35,  y: 350, s: 16, r: 12  },
    { t: "monitor", x: 118, y: 342, s: 20, r: -10 },
    { t: "robot",   x: 202, y: 352, s: 18, r: 18  },
    { t: "globe",   x: 285, y: 342, s: 16, r: -8  },
    { t: "chart",   x: 365, y: 352, s: 20, r: 10  },
    { t: "gear",    x: 448, y: 342, s: 16, r: -20 },
    { t: "person",  x: 528, y: 352, s: 18, r: 15  },
    { t: "robot",   x: 612, y: 342, s: 22, r: -12 },
    { t: "monitor", x: 698, y: 352, s: 16, r: 8   },
    { t: "globe",   x: 780, y: 342, s: 18, r: -15 },
    { t: "chart",   x: 862, y: 352, s: 16, r: 12  },
    { t: "gear",    x: 945, y: 342, s: 20, r: -8  },
    // Row 7
    { t: "person",  x: 50,  y: 415, s: 18, r: -10 },
    { t: "chart",   x: 135, y: 408, s: 16, r: 15  },
    { t: "gear",    x: 218, y: 418, s: 20, r: -18 },
    { t: "robot",   x: 300, y: 408, s: 16, r: 8   },
    { t: "globe",   x: 382, y: 418, s: 18, r: -12 },
    { t: "monitor", x: 462, y: 408, s: 22, r: 10  },
    { t: "chart",   x: 548, y: 418, s: 16, r: -8  },
    { t: "person",  x: 630, y: 408, s: 20, r: 18  },
    { t: "gear",    x: 715, y: 418, s: 16, r: -15 },
    { t: "robot",   x: 798, y: 408, s: 18, r: 10  },
    { t: "monitor", x: 880, y: 418, s: 16, r: -20 },
    { t: "globe",   x: 962, y: 408, s: 20, r: 12  },
    // Row 8
    { t: "chart",   x: 20,  y: 480, s: 16, r: 8   },
    { t: "robot",   x: 102, y: 472, s: 20, r: -12 },
    { t: "monitor", x: 185, y: 482, s: 16, r: 15  },
    { t: "person",  x: 268, y: 472, s: 18, r: -8  },
    { t: "gear",    x: 350, y: 482, s: 22, r: 12  },
    { t: "globe",   x: 435, y: 472, s: 16, r: -18 },
    { t: "robot",   x: 518, y: 482, s: 20, r: 8   },
    { t: "chart",   x: 600, y: 472, s: 16, r: -15 },
    { t: "monitor", x: 682, y: 482, s: 18, r: 10  },
    { t: "gear",    x: 765, y: 472, s: 16, r: -10 },
    { t: "person",  x: 848, y: 472, s: 20, r: 18  },
    { t: "globe",   x: 930, y: 482, s: 16, r: -12 },
  ];

  const renderIcon = (type, cx, cy, size, fill, stroke) => {
    const h = size * 0.9;
    switch (type) {
      case "robot":
        return (
          <g>
            {/* head */}
            <rect x={cx - size*0.38} y={cy - h*0.42} width={size*0.76} height={size*0.52} rx={size*0.1} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            {/* eyes */}
            <circle cx={cx - size*0.13} cy={cy - h*0.18} r={size*0.07} fill={stroke}/>
            <circle cx={cx + size*0.13} cy={cy - h*0.18} r={size*0.07} fill={stroke}/>
            {/* mouth */}
            <rect x={cx - size*0.16} y={cy + h*0.04} width={size*0.32} height={size*0.07} rx={size*0.035} fill={stroke}/>
            {/* antenna */}
            <line x1={cx} y1={cy - h*0.42} x2={cx} y2={cy - h*0.58} stroke={stroke} strokeWidth="1.2"/>
            <circle cx={cx} cy={cy - h*0.62} r={size*0.06} fill={stroke}/>
            {/* body */}
            <rect x={cx - size*0.30} y={cy + h*0.12} width={size*0.60} height={size*0.38} rx={size*0.08} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            {/* legs */}
            <rect x={cx - size*0.22} y={cy + h*0.50} width={size*0.16} height={size*0.18} rx={size*0.05} fill={fill} stroke={stroke} strokeWidth="1.1"/>
            <rect x={cx + size*0.06} y={cy + h*0.50} width={size*0.16} height={size*0.18} rx={size*0.05} fill={fill} stroke={stroke} strokeWidth="1.1"/>
          </g>
        );
      case "gear":
        return (
          <g>
            <circle cx={cx} cy={cy} r={size*0.28} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            <circle cx={cx} cy={cy} r={size*0.13} fill={stroke} opacity="0.5"/>
            {[0,45,90,135,180,225,270,315].map((a, i) => {
              const rad = (a * Math.PI) / 180;
              const tx = cx + Math.cos(rad) * size * 0.30;
              const ty = cy + Math.sin(rad) * size * 0.30;
              return <rect key={i} x={tx - size*0.06} y={ty - size*0.06} width={size*0.12} height={size*0.12} rx={size*0.02} fill={fill} stroke={stroke} strokeWidth="1" transform={`rotate(${a},${tx},${ty})`}/>;
            })}
          </g>
        );
      case "monitor":
        return (
          <g>
            <rect x={cx - size*0.40} y={cy - h*0.35} width={size*0.80} height={size*0.55} rx={size*0.08} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            <rect x={cx - size*0.22} y={cy - h*0.28} width={size*0.44} height={size*0.30} rx={size*0.04} fill={stroke} opacity="0.18"/>
            <line x1={cx} y1={cy + h*0.20} x2={cx} y2={cy + h*0.38} stroke={stroke} strokeWidth="1.2"/>
            <line x1={cx - size*0.20} y1={cy + h*0.38} x2={cx + size*0.20} y2={cy + h*0.38} stroke={stroke} strokeWidth="1.2"/>
            <circle cx={cx} cy={cy + h*0.12} r={size*0.04} fill={stroke} opacity="0.6"/>
          </g>
        );
      case "chart":
        return (
          <g>
            <rect x={cx - size*0.38} y={cy - h*0.45} width={size*0.76} height={size*0.90} rx={size*0.08} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            <line x1={cx - size*0.22} y1={cy + h*0.30} x2={cx - size*0.22} y2={cy - h*0.28} stroke={stroke} strokeWidth="1.1"/>
            <line x1={cx - size*0.22} y1={cy + h*0.30} x2={cx + size*0.28} y2={cy + h*0.30} stroke={stroke} strokeWidth="1.1"/>
            <polyline points={`${cx - size*0.14},${cy + h*0.10} ${cx},${cy - h*0.08} ${cx + size*0.14},${cy + h*0.18}`} fill="none" stroke={stroke} strokeWidth="1.1"/>
          </g>
        );
      case "globe":
        return (
          <g>
            <circle cx={cx} cy={cy} r={size*0.35} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            <ellipse cx={cx} cy={cy} rx={size*0.16} ry={size*0.35} fill="none" stroke={stroke} strokeWidth="0.9"/>
            <line x1={cx - size*0.35} y1={cy} x2={cx + size*0.35} y2={cy} stroke={stroke} strokeWidth="0.9"/>
            <line x1={cx - size*0.28} y1={cy - size*0.18} x2={cx + size*0.28} y2={cy - size*0.18} stroke={stroke} strokeWidth="0.8"/>
            <line x1={cx - size*0.28} y1={cy + size*0.18} x2={cx + size*0.28} y2={cy + size*0.18} stroke={stroke} strokeWidth="0.8"/>
          </g>
        );
      case "person":
        return (
          <g>
            <circle cx={cx} cy={cy - h*0.30} r={size*0.18} fill={fill} stroke={stroke} strokeWidth="1.2"/>
            <path d={`M ${cx - size*0.28} ${cy + h*0.42} Q ${cx - size*0.20} ${cy + h*0.10} ${cx} ${cy + h*0.05} Q ${cx + size*0.20} ${cy + h*0.10} ${cx + size*0.28} ${cy + h*0.42}`} fill={fill} stroke={stroke} strokeWidth="1.2"/>
          </g>
        );
      default:
        return null;
    }
  };

  return (
    <div style={{
      position: "absolute",
      inset: 0,
      zIndex: 0,
      overflow: "hidden",
      background: isDark ? "#1a1a2e" : LH.bgPlate,
      pointerEvents: "none",
    }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 520"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        {icons.map((icon, i) => (
          <g key={i} transform={`rotate(${icon.r}, ${icon.x}, ${icon.y})`}>
            {renderIcon(icon.t, icon.x, icon.y, icon.s, iconColor, strokeColor)}
          </g>
        ))}
      </svg>
    </div>
  );
};

// ✅ ЛОКАЛИЗОВАННЫЕ ПЕРВЫЕ СООБЩЕНИЯ ИИ
const getFirstAiMessage = (username, lang) => {
  const name = username || (lang === "fr" ? "Utilisateur" : "User");
  if (lang === "fr") {
    return `Bonjour ${name} ! 👋
Je suis là pour vous aider à trouver les bonnes connexions. Pour cela, j'ai besoin de comprendre ce que vous recherchez.
Avec qui essayez-vous de vous connecter ?
Pensez à :
Quel type de personne ou d'opportunité ? (partenaire commercial, investisseur, mentor, partenaire romantique, ami, etc.)
Quelles qualités ou critères spécifiques sont importants pour vous ?
Quel est votre objectif ?
Dites-moi simplement avec vos propres mots - nous affinerons ensemble au fur et à mesure.`;
  }
  return `Hi ${name}! 👋
I'm here to help you find the right connections. To do that, I need to understand what you're looking for.
Who are you trying to connect with?
Think about:
What type of person or opportunity? (business partner, investor, mentor, romantic partner, friend, etc.)
What specific qualities or criteria matter to you?
What's your goal?
Just tell me in your own words - we'll refine it together as we go.`;
};

// Бек присылает приветственное сообщение всегда на английском
// ("Hello {name}! Welcome to our intelligent matching platform!..."). Когда
// в UI выбран французский, подменяем его клиентским переводом на лету.
// Кешируем оригинал — перевод применяется только при показе, чтобы смена
// языка не оставляла пользователя со «застрявшей» версией.
//
// Несколько маркеров — ловим письмо при любых правках промпта на беке.
// Достаточно одного совпадения, чтобы считать это приветствием. Главный
// маркер — название платформы; артикль "the/our" не требуем, потому что бек
// иногда шлёт длинный вариант ("our"), иногда короткий ("the").
const WELCOME_EN_MARKERS = [
  /intelligent matching platform/i,
  /matching platform/i,                                            // на случай, если "intelligent" уберут
  /(?:I'?m|I am)\s+your\s+(?:specialized\s+)?AI\s+assistant/i,
  /your specialized AI assistant designed to help you find/i,
  /Ready (?:to start|when you are)/i,
  /I'?ll guide you through the matching/i,
  /Here'?s how (?:I work|it works)/i,
  /(?:Two|2)\s+quick questions/i,
  /Welcome to (?:the|our|this)\s+\w+/i,                            // обобщённый "Welcome to <...>"
  /tell me (?:who|what kind of) (?:you|connection)/i,              // финальный CTA приветствия
];
const isEnglishWelcome = (s) =>
  typeof s === "string" && WELCOME_EN_MARKERS.some((re) => re.test(s));
const WELCOME_EN_MARKER = WELCOME_EN_MARKERS[0]; // оставлено для обратной совместимости

// Эвристика «английский ли это текст». Применяется ТОЛЬКО как fallback
// для приветствия, если ни один из основных маркеров не сработал — например
// бек поменял формулировку до неузнаваемости. Считаем строку «английской»,
// если в ней встречаются как минимум 3 стоп-слова, типичных для en-промпта,
// и НЕ встречаются явные FR-маркеры — чтобы не перевести уже переведённое.
const EN_HINTS = [
  /\bI'?ll\b/i, /\bI'?m\b/i, /\byou'?re\b/i, /\byou'?ll\b/i,
  /\bWelcome\b/i, /\bHello\b/i, /\bHi\b/i, /\bHey\b/i,
  /\bhelp you\b/i, /\blooking for\b/i, /\bconnections?\b/i,
  /\bprofile\b/i, /\bmatching\b/i, /\bAI assistant\b/i,
  /\bReady\b/i, /\bplease tell me\b/i,
];
const FR_HINTS = [
  /\bBonjour\b/i, /\bBienvenue\b/i, /\bSalut\b/i,
  /\bvous\b/i, /\bje suis\b/i, /\bvotre\b/i, /\bplateforme\b/i,
  /\bmise en relation\b/i, /\bje vais\b/i,
];
const isProbablyEnglishWelcomeText = (s) => {
  if (typeof s !== "string" || s.length < 40) return false;
  if (FR_HINTS.some((re) => re.test(s))) return false;
  let hits = 0;
  for (const re of EN_HINTS) {
    if (re.test(s)) hits++;
    if (hits >= 3) return true;
  }
  return false;
};

// Слова, которые НЕ являются именем — "Hi there!" → имя "there" не нужно
// подставлять во французский шаблон, лучше уйти на безличный вариант.
const NAME_STOPLIST = new Set([
  "there", "everyone", "everybody", "all", "guys", "you", "user", "friend",
]);
const extractWelcomeName = (content) => {
  const m = content.match(/^\s*(?:Hello|Hi|Hey|Dear)[, ]+\s*([^!,\n.]+?)\s*[!,.]/i);
  if (!m) return null;
  const candidate = m[1].trim();
  if (!candidate || NAME_STOPLIST.has(candidate.toLowerCase())) return null;
  // Если кандидат содержит пробелы (например "everyone reading this") — это
  // фраза, а не имя. Имя обычно — одно слово или короткое имя+фамилия.
  if (/\s/.test(candidate) && candidate.split(/\s+/).length > 2) return null;
  return candidate;
};

// Длинный FR-вариант — для длинного EN-приветствия ("Welcome to our intelligent
// matching platform! ... I'm your specialized AI assistant designed to help...").
const buildFrenchWelcomeLong = (name) => {
  const salutation = name ? `Bonjour ${name} !` : "Bonjour !";
  return `${salutation} Bienvenue sur notre plateforme intelligente de mise en relation !

Je suis votre assistant IA spécialisé, conçu pour vous aider à trouver les connexions parfaites. Ma mission principale est de créer un profil convaincant qui attirera exactement les bonnes personnes vers vous.

Voici comment je travaille :
• Je vous poserai seulement deux questions clés pour comprendre vos besoins
• Je vous aiderai à élaborer un profil qui met en valeur vos atouts et ce que vous offrez
• Je vous guiderai à travers le processus de mise en relation pour trouver vos connexions idéales

Je peux vous aider à trouver :
- Des partenaires romantiques pour des relations sérieuses
- Des partenaires commerciaux et collaborateurs
- Des investisseurs et opportunités de financement
- Des mentors et conseillers
- Des collègues professionnels et contacts de réseautage
- Ou tout autre type de connexion significative

Prêt à commencer ? Dites-moi qui vous recherchez et quel type de relation ou de connexion vous souhaitez établir.`;
};

// Короткий FR-вариант — для нового короткого EN-приветствия ("Hi there!
// Welcome to the intelligent matching platform. ... Ready when you are...").
const buildFrenchWelcomeShort = (name) => {
  const salutation = name ? `Salut ${name} !` : "Salut !";
  return `${salutation} Bienvenue sur la plateforme intelligente de mise en relation.

Je suis votre assistant IA — je vais vous aider à trouver les bonnes personnes selon ce que vous recherchez. Voici comment ça marche :

• Deux questions rapides pour comprendre vos besoins
• Je vous aiderai à créer un profil qui met en valeur vos atouts
• Puis je vous guiderai à travers le processus de mise en relation

Prêt quand vous l'êtes — dites-moi quel type de connexion vous souhaitez trouver.`;
};

// Совместимость со старым кодом, если где-то импортируется `buildFrenchWelcome`.
const buildFrenchWelcome = buildFrenchWelcomeLong;

// `opts.isFirstAiBubble=true` разрешает срабатывание fallback-эвристики
// (isProbablyEnglishWelcomeText) — её опасно применять к произвольным
// AI-сообщениям, но безопасно к самой первой AI-реплике в диалоге,
// которая всегда является приветствием.
const translateWelcomeIfNeeded = (content, lang, opts = {}) => {
  if (lang !== "fr" || typeof content !== "string") return content;
  const looksLikeWelcome =
    isEnglishWelcome(content) ||
    (opts.isFirstAiBubble && isProbablyEnglishWelcomeText(content));
  if (!looksLikeWelcome) return content;
  const name = extractWelcomeName(content);
  // Длинная версия EN однозначно опознаётся по фразам, которых нет в короткой:
  // "specialized AI assistant designed", "My core mission", или маркированному
  // блоку "I can help you find: - Romantic partners..."
  const isLong =
    /specialized AI assistant designed/i.test(content) ||
    /My core mission/i.test(content) ||
    /I can help you find\s*:/i.test(content);
  return isLong
    ? buildFrenchWelcomeLong(name)
    : buildFrenchWelcomeShort(name);
};
// Применяет перевод сразу ко всем элементам — пометив самое первое AI-сообщение
// как «первый бабл», чтобы fallback-эвристика могла сработать только на нём.
const localizeMessages = (msgs, lang) => {
  let firstAiSeen = false;
  return msgs.map((m) => {
    const isFirstAi = !firstAiSeen && m && m.sender_id === 0;
    if (isFirstAi) firstAiSeen = true;
    return {
      ...m,
      content: translateWelcomeIfNeeded(m.content, lang, { isFirstAiBubble: isFirstAi }),
    };
  });
};

// Маппинг ответа /api/ai_conversation (узлы дерева) в формат сообщений фронта.
// role 'assistant' → sender_id 0 (как раньше для AI), 'user' → sender_id 1.
const mapAiServerMessages = (serverMsgs) =>
  (serverMsgs || []).map((m) => ({
    id: m.id,
    sender_id: m.role === "assistant" ? 0 : 1,
    recipient_id: m.role === "assistant" ? 1 : 0,
    content: m.content,
    timestamp: m.created_at,
    edited_at: m.edited_at,
    branch_index: m.branch_index,
    branch_count: m.branch_count,
    sibling_ids: m.sibling_ids || [],
    can_edit: !!m.can_edit,
  }));

// Стили для inline-контролов редактирования/веток AI-сообщений.
const AI_BRANCH_BTN_STYLE = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: "14px",
  lineHeight: 1,
  padding: "0 2px",
  opacity: 0.75,
};
const AI_EDIT_BTN_STYLE = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: "13px",
  lineHeight: 1,
  padding: "0 4px",
  marginLeft: "6px",
  opacity: 0.7,
};
const AI_EDIT_SAVE_STYLE = {
  border: "none",
  borderRadius: "8px",
  padding: "6px 14px",
  background: "rgba(102,126,234,0.9)",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: "13px",
};
const AI_EDIT_CANCEL_STYLE = {
  border: "1px solid rgba(0,0,0,0.15)",
  borderRadius: "8px",
  padding: "6px 14px",
  background: "transparent",
  cursor: "pointer",
  fontSize: "13px",
};

// ── Хук: закрытие по клику снаружи ──────────────────────────────────────────
function useClickOutside(ref, isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [isOpen]);
}

// ── Константы ────────────────────────────────────────────────────────────────
// Названия action-кнопок, на которые AI ссылается в тексте. Сопоставление
// устойчиво к: кавычкам (« » " ' ’ ‘), markdown-обёрткам (**...**),
// языку призыва (Click / Cliquez / Нажмите), регистру и лишним пробелам.
const BUTTON_LABELS = [
  "Start Matching",
  "Find Another Match",
  "Change 'About me'",
  "Change 'À propos de moi'",
];
// Универсальный матчер: AI может написать "Click \"Start Matching\"",
// "Cliquez sur «Start Matching»", "Нажмите Start Matching", и т.п.
const messageHasButtonTrigger = (text) => {
  if (!text) return false;
  // Нормализуем кавычки и убираем markdown bold/italic
  const normalized = text
    .replace(/[«»“”„‟"‘’‚‛']+/g, '"')
    .replace(/\*+/g, "");
  return BUTTON_LABELS.some(label => normalized.includes(label));
};

// Multi-lang распознавание "профиль показан в сообщении AI".
// EN: User profile / Looking for / About
// RU: Кого ищу / О себе
// FR: Profil utilisateur / Recherche / À propos
const PROFILE_HEADER_RE = /(user\s*profile|profil\s*utilisateur)\s*:/i;
const PROFILE_LOOKING_RE = /(looking\s*for|кого\s*ищу|recherche)\s*:/i;
const PROFILE_ABOUT_RE   = /(about|о\s*себе|à\s*propos)\s*:/i;
const messageHasProfile = (text) => {
  if (!text) return false;
  return PROFILE_HEADER_RE.test(text) &&
         PROFILE_LOOKING_RE.test(text) &&
         PROFILE_ABOUT_RE.test(text);
};

// ── Единый компонент для трёх AI-action кнопок ───────────────────────────────
// До рефакторинга было два разных JSX-блока (4536 и 6788) с разным текстом
// ("Change profile" vs "Change 'About me'"), разными классами и стилями.
// Изменение в одном месте не попадало в другое — отсюда визуальный разнобой.
// Single context-aware button:
//   matchingDone=false → "Start Matching"
//   matchingDone=true  → "New request"
// "Edit profile" has been removed from chat; profile editing is on ProfilePage.
function AiActionButtons({
  lang,
  onStartMatch,
  onFindAnother,
  startDisabled,
  loading,
  matchingDone = false,
  variant = "compact",   // "compact" — лёгкий ряд; "glass" — pill-ряд с эмодзи
  isMobile = false,
  themeVars = null,
}) {
  const startLabel = startDisabled
    ? (lang === "fr" ? "En cours..." : "In progress...")
    : (lang === "fr" ? "Lancer la recherche" : "Start Matching");
  const newReqLabel = lang === "fr" ? "Nouvelle demande" : "New request";
  const startTitle = lang === "fr"
    ? "Lancer la recherche de correspondances pour la demande actuelle"
    : "Start matching for the current request";
  const newReqTitle = lang === "fr"
    ? "Créer une demande de recherche supplémentaire (l'actuelle est conservée)"
    : "Create an additional search request (the current one is kept)";

  if (variant === "compact") {
    return (
      <div className="na-ai-actions">
        {!matchingDone ? (
          <button type="button" className="ai-action-btn"
            onClick={onStartMatch} disabled={startDisabled || loading} title={startTitle}>
            {lang === "fr" ? "" : ""}{startLabel}
          </button>
        ) : (
          <button type="button" className="ai-action-btn match-new"
            onClick={onFindAnother} disabled={loading} title={newReqTitle}>
            {newReqLabel}
          </button>
        )}
      </div>
    );
  }

  // variant === "glass"
  const baseBtn = {
    padding: isMobile ? "11px 14px" : "13px 20px",
    borderRadius: "9999px",
    border: "none",
    color: "#ffffff",
    fontWeight: 700,
    fontSize: isMobile ? "13px" : "14.5px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.15), 0 2px 6px rgba(0,0,0,0.1)",
    backdropFilter: "blur(12px)",
    whiteSpace: "nowrap",
    minWidth: isMobile ? "auto" : "160px",
  };
  return (
    <div
      style={{
        padding: isMobile ? "12px 14px" : "14px 20px",
        borderRadius: isMobile ? "22px" : "9999px",
        gap: isMobile ? "8px" : "12px",
        flexWrap: "wrap",
        justifyContent: "center",
        maxWidth: isMobile ? "100%" : "min(92%, 920px)",
        margin: "0 auto",
        display: "flex",
        pointerEvents: "auto",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        background: themeVars?.glassPanel,
        border: themeVars ? `1px solid ${themeVars.glassBorder}` : undefined,
        boxShadow: themeVars?.glassShadow,
        color: themeVars?.glassText,
      }}
    >
      {!matchingDone ? (
        <button
          className="ai-action-btn"
          onClick={onStartMatch}
          disabled={startDisabled || loading}
          title={startTitle}
          onTouchStart={(e) => e.currentTarget.classList.add("touching")}
          onTouchEnd={(e) => e.currentTarget.classList.remove("touching")}
          style={{
            ...baseBtn,
            flex: "1 1 160px",
            background: startDisabled ? "rgba(102,126,234,0.14)" : "rgba(102,126,234,0.35)",
            opacity: startDisabled || loading ? 0.6 : 1,
          }}
        >
          {startDisabled ? "↻ " : "🔍 "}{startLabel}
        </button>
      ) : (
        <button
          className="ai-action-btn"
          onClick={onFindAnother}
          disabled={loading}
          title={newReqTitle}
          onTouchStart={(e) => e.currentTarget.classList.add("touching")}
          onTouchEnd={(e) => e.currentTarget.classList.remove("touching")}
          style={{
            ...baseBtn,
            flex: "1 1 160px",
            background: "rgba(16,185,129,0.35)",
            opacity: loading ? 0.6 : 1,
          }}
        >
          ✨ {newReqLabel}
        </button>
      )}
    </div>
  );
}

const SOCIAL_BUTTONS_CONFIG = [
  { network: "Telegram",  icon: telegramIcon,  placeholder: "https://t.me/username" },
  { network: "Instagram", icon: instagramIcon, placeholder: "https://instagram.com/username" },
  { network: "Facebook",  icon: facebookIcon,  placeholder: "https://facebook.com/username" },
  { network: "Outlook",   icon: outlookIcon,   placeholder: "https://outlook.com/username" },
  { network: "LinkedIn",  icon: linkedinIcon,  placeholder: "https://linkedin.com/in/username" },
  { network: "Phone",     icon: phoneIcon,     placeholder: "+1 234 567 8900", labelFr: "Téléphone" },
  { network: "Email",     icon: emailIcon,     placeholder: "example@email.com" },
  { network: "WhatsApp",  icon: whatsappIcon,  placeholder: "https://wa.me/1234567890" },
];

// ── Кеш-утилита (localStorage без куков) ─────────────────────────────────────
const cache = {
  get(key) {
    try {
      const item = localStorage.getItem(`cf_cache_${key}`);
      if (!item) return null;
      const { data, ts, ttl } = JSON.parse(item);
      if (ttl && Date.now() - ts > ttl) { localStorage.removeItem(`cf_cache_${key}`); return null; }
      return data;
    } catch { return null; }
  },
  set(key, data, ttlMs = 0) {
    try { localStorage.setItem(`cf_cache_${key}`, JSON.stringify({ data, ts: Date.now(), ttl: ttlMs })); }
    catch { /* quota exceeded — ignore */ }
  },
  del(key) { try { localStorage.removeItem(`cf_cache_${key}`); } catch {} },
};

// Хук: stale-while-revalidate — мгновенно возвращает кеш, потом обновляет
function useCachedState(key, defaultValue, ttlMs = 0) {
  const [state, setState] = useState(() => cache.get(key) ?? defaultValue);
  const set = useCallback((val) => {
    setState(prev => {
      const resolved = typeof val === 'function' ? val(prev) : val;
      cache.set(key, resolved, ttlMs);
      return resolved;
    });
  }, [key, ttlMs]);
  return [state, set];
}

// ── Инлайн SVG иконки — не затрагиваются браузерными фильтрами ───────────────
const IconAttach = ({ size = 24, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59723 21.9983 8.005 21.9983C6.41277 21.9983 4.88584 21.3658 3.76 20.24C2.63416 19.1142 2.00166 17.5872 2.00166 15.995C2.00166 14.4028 2.63416 12.8758 3.76 11.75L12.33 3.18C13.0806 2.42975 14.0991 2.00705 15.1609 2.00587C16.2228 2.00469 17.2422 2.42512 17.9947 3.17372C18.7471 3.92232 19.174 4.93969 19.1786 6.00153C19.1832 7.06337 18.7653 8.08437 18.02 8.84L9.45 17.41C9.07498 17.7881 8.56622 18.0009 8.035 18.0009C7.50378 18.0009 6.99502 17.7881 6.62 17.41C6.24498 17.0349 6.03213 16.5262 6.03213 15.995C6.03213 15.4638 6.24498 14.9551 6.62 14.58L15.07 6.14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconSend = ({ size = 24, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.4 2.1L21.7 11.3C22.1 11.5 22.1 12.5 21.7 12.7L3.4 21.9C2.9 22.1 2.4 21.7 2.5 21.2L4.2 14.5C4.3 14.1 4.6 13.8 5 13.7L14 12L5 10.3C4.6 10.2 4.3 9.9 4.2 9.5L2.5 2.8C2.4 2.3 2.9 1.9 3.4 2.1Z" fill={color}/>
  </svg>
);

const IconBack = ({ size = 20, color = "#1e1450" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 19L5 12L12 5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function ChatPage({ lang, theme, translations, isSamsungBrowser: isSamsungProp }) {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  const toast = useToast();
  const prevStartMatchingDisabledRef = useRef(false);
  // ── Состояния с кешированием (stale-while-revalidate) ──────────────────────
  // Показываются мгновенно из localStorage, потом тихо обновляются с бека
  const [dialogs, setDialogs] = useCachedState("dialogs", [], 10 * 60 * 1000); // TTL 10 мин
  const [dialogsLoaded, setDialogsLoaded] = useState(() => cache.get("dialogs") !== null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);

  // ── Table slots live map: {match_id_str: {table_number, seconds_left}} ───
  const [allTableSlots, setAllTableSlots] = useState({});
  const tableSlotsIntervalRef = useRef(null);

  useEffect(() => {
    if (!token) return;
    let timeoutId = null;
    let stopped = false;

    const tick = async () => {
      if (stopped) return;
      // Не дёргаем сеть, если вкладка скрыта — просто ставим повторную проверку.
      if (document.hidden) {
        timeoutId = setTimeout(tick, 5000);
        return;
      }
      try {
        const res = await axios.get(`${API_URL}/api/table-slots/active`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const slots = res.data?.slots || {};
        setAllTableSlots(slots);
        // 1с пока есть «горячие» слоты (active/searching), иначе 5с.
        const hasHot = Object.values(slots).some(
          s => s?.status === "active" || s?.status === "searching"
        );
        if (!stopped) timeoutId = setTimeout(tick, hasHot ? 1000 : 5000);
      } catch {
        if (!stopped) timeoutId = setTimeout(tick, 5000);
      }
    };

    tick();

    const onVisibility = () => {
      if (!document.hidden && !stopped) {
        if (timeoutId) clearTimeout(timeoutId);
        tick();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);

    tableSlotsIntervalRef.current = { stop: () => {
      stopped = true;
      if (timeoutId) clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", onVisibility);
    }};

    return () => tableSlotsIntervalRef.current.stop();
  }, [token]);

  // tableSlot для текущего открытого чата
  const tableSlot = selectedUser?.match_id
    ? (allTableSlots[String(selectedUser.match_id)] ?? null)
    : null;
  const tableSlotStatus = tableSlot?.status ?? null; // "active"|"searching"|"queued"|"expired"|null

  // ── Table slot actions panel ──────────────────────────────────────────────
  const [slotActionsOpen, setSlotActionsOpen] = useState(false);
  const [slotActionLoading, setSlotActionLoading] = useState(null); // "extend5"|"extend10"|"cancel"|"restart"
  const [slotActionFeedback, setSlotActionFeedback] = useState(null); // { ok: bool, msg: string }
  const slotActionInFlight = useRef(false);

  const extractApiError = (err) => {
    const status = err?.response?.status;
    const data = err?.response?.data;
    const detail = typeof data === "string" ? data : (data?.detail || data?.message);
    if (status === 429) return lang === "fr" ? "Trop de requêtes, réessayez plus tard" : "Too many requests, try again later";
    if (status === 403) return detail || (lang === "fr" ? "Action interdite" : "Action not allowed");
    if (status === 404) return lang === "fr" ? "Table introuvable" : "Table not found";
    if (detail) return String(detail);
    return lang === "fr" ? "Erreur" : "Error";
  };

  const handleSlotAction = async (action) => {
    if (!selectedUser?.match_id) return;
    if (slotActionInFlight.current) return;
    slotActionInFlight.current = true;
    setSlotActionLoading(action);
    setSlotActionFeedback(null);
    try {
      if (action === "extend5" || action === "extend10") {
        const minutes = action === "extend5" ? 5 : 10;
        await axios.post(
          `${API_URL}/api/table-slots/${selectedUser.match_id}/extend`,
          { minutes },
          { headers: authHeaders }
        );
        setSlotActionFeedback({ ok: true, msg: lang === "fr" ? `+${minutes} min ajoutées` : `+${minutes} min added` });
      } else if (action === "cancel") {
        await axios.delete(
          `${API_URL}/api/table-slots/${selectedUser.match_id}`,
          { headers: authHeaders }
        );
        setSlotActionFeedback({ ok: true, msg: lang === "fr" ? "Table annulée" : "Table cancelled" });
        setSlotActionsOpen(false);
      } else if (action === "restart") {
        await axios.post(
          `${API_URL}/api/table-slots/${selectedUser.match_id}/restart`,
          {},
          { headers: authHeaders }
        );
        setSlotActionFeedback({ ok: true, msg: lang === "fr" ? "Redémarrage demandé" : "Restart requested" });
      }
    } catch (err) {
      setSlotActionFeedback({ ok: false, msg: extractApiError(err) });
    } finally {
      slotActionInFlight.current = false;
      setSlotActionLoading(null);
      setTimeout(() => setSlotActionFeedback(null), 3500);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  const [text, setText] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  // showAiButtons persisted in sessionStorage so page reload doesn't re-derive
  // it from message text (which can falsely match "Start Matching" in mid-conversation).
  const [showAiButtons, setShowAiButtons] = useState(() => {
    try { return sessionStorage.getItem("chatShowAiButtons") === "true"; }
    catch { return false; }
  });
  const [startMatchingDisabled, setStartMatchingDisabled] = useState(false);
  // Редактирование AI-сообщений (ChatGPT-стиль: правка создаёт новую ветку).
  const [editingMsgId, setEditingMsgId] = useState(null);
  const [editingText, setEditingText] = useState("");
  // aiMode/editRequestId сохраняются в sessionStorage, чтобы пережить перезагрузку
  // вкладки — без этого edit_about / edit_request режим терялся и следующее
  // сообщение уходило с mode:"profile", ломая редактирование.
  const [aiMode, setAiMode] = useState(() => {
    try { return sessionStorage.getItem("chatAiMode") || "profile"; }
    catch { return "profile"; }
  });
  const [editRequestId, setEditRequestId] = useState(() => {
    try {
      const v = sessionStorage.getItem("chatEditRequestId");
      return v ? Number(v) : null;
    } catch { return null; }
  });
  // Активный SearchRequest, для которого юзер хочет запустить матчинг.
  // Передаётся в /api/start_match, чтобы бек не угадывал «последний по дате».
  const [activeSearchRequestId, setActiveSearchRequestId] = useState(() => {
    try {
      const v = sessionStorage.getItem("chatActiveSearchRequestId");
      return v ? Number(v) : null;
    } catch { return null; }
  });
  useEffect(() => {
    try {
      if (aiMode) sessionStorage.setItem("chatAiMode", aiMode);
      else sessionStorage.removeItem("chatAiMode");
    } catch {}
  }, [aiMode]);
  useEffect(() => {
    try {
      if (editRequestId != null) sessionStorage.setItem("chatEditRequestId", String(editRequestId));
      else sessionStorage.removeItem("chatEditRequestId");
    } catch {}
  }, [editRequestId]);
  useEffect(() => {
    try {
      if (activeSearchRequestId != null) sessionStorage.setItem("chatActiveSearchRequestId", String(activeSearchRequestId));
      else sessionStorage.removeItem("chatActiveSearchRequestId");
    } catch {}
  }, [activeSearchRequestId]);
  // matchingDone: true → matched at least once for current request → show "New request"
  // false → show "Start Matching". Reset to false whenever a new request is being created.
  const [matchingDone, setMatchingDone] = useState(() => {
    try { return sessionStorage.getItem("chatMatchingDone") === "true"; }
    catch { return false; }
  });
  useEffect(() => {
    try { sessionStorage.setItem("chatMatchingDone", String(matchingDone)); }
    catch {}
  }, [matchingDone]);
  useEffect(() => {
    try { sessionStorage.setItem("chatShowAiButtons", String(showAiButtons)); }
    catch {}
  }, [showAiButtons]);
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = localStorage.getItem("chatSidebarWidth");
    return saved ? parseFloat(saved) : 40;
  });
  const [showAttachmentMenu, setShowAttachmentMenu] = useState(false);
  const attachmentMenuRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const ws = useRef(null);
  const selectedUserRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [searchQuery, setSearchQuery] = useState("");
  const menuRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(() => {
    try {
      const saved = localStorage.getItem("chatRightPanelOpen");
      if (saved !== null) return saved === "true";
    } catch {}
    return window.innerWidth > 767;
  });
  const textareaRef = useRef(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [inputHeight, setInputHeight] = useState(isMobile ? 60 : 80);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // ── Свёрнутые группы событий (сохраняется в localStorage) ────────────────
  const [collapsedGroups, setCollapsedGroups] = useState(() => {
    try {
      const saved = localStorage.getItem("chatCollapsedGroups");
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });
  const toggleGroup = useCallback((key) => {
    setCollapsedGroups(prev => {
      const next = { ...prev, [key]: !prev[key] };
      try { localStorage.setItem("chatCollapsedGroups", JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  const [, setProfileCheckComplete] = useState(false);
  const [, setProfileIncomplete] = useCachedState("profileIncomplete", false, 30 * 60 * 1000);
  const [currentUsername, setCurrentUsername] = useState(() => localStorage.getItem("username") || null);

  // ── Кеш сообщений по chatId ──────────────────────────────────────────────
  const getCachedMessages = useCallback((id) => cache.get(`messages_${id}`) || [], []);
  const setCachedMessages = useCallback((id, msgs) => {
    cache.set(`messages_${id}`, msgs, 5 * 60 * 1000); // TTL 5 мин
  }, []);

  // ── Социальные ссылки ────────────────────────────────────────────────────
  const [savedSocialLinks, setSavedSocialLinks] = useCachedState("socialLinks", {}, 60 * 60 * 1000); // TTL 1 час

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 767;
      setIsMobile(mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ── Lock body scroll while ChatPage is mounted (fixes "double scroll" on mobile)
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevBodyOverscroll = body.style.overscrollBehavior;
    const prevBodyPosition = body.style.position;
    const prevBodyWidth = body.style.width;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.overscrollBehavior = "none";
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      body.style.overscrollBehavior = prevBodyOverscroll;
      body.style.position = prevBodyPosition;
      body.style.width = prevBodyWidth;
    };
  }, []);

  // ── Track visualViewport (mobile keyboard) so the input stays above keyboard
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  useEffect(() => {
    if (!isMobile || typeof window === "undefined" || !window.visualViewport) return;
    const vv = window.visualViewport;
    const update = () => {
      const offset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      setKeyboardOffset(offset);
    };
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, [isMobile]);

  // ── Pinch-to-scale: zoom через CSS `zoom` на .chat-page-root ───────────────
  const TEXT_SCALE_MIN = 0.85;
  const TEXT_SCALE_MAX = 1.6;
  const clampTextScale = (v) => Math.max(TEXT_SCALE_MIN, Math.min(TEXT_SCALE_MAX, v));
  const [textScale, setTextScale] = useState(() => {
    try {
      const saved = parseFloat(localStorage.getItem("chatTextScale"));
      return Number.isFinite(saved) && saved > 0 ? clampTextScale(saved) : 1;
    } catch { return 1; }
  });
  const textScaleRef = useRef(textScale);
  useEffect(() => {
    textScaleRef.current = textScale;
    try { localStorage.setItem("chatTextScale", String(textScale)); } catch {}
  }, [textScale]);

  useEffect(() => {
    if (!isMobile || typeof window === "undefined") return;

    // Блокируем нативный браузерный zoom, используем свой через CSS zoom
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    const prevViewport = viewportMeta?.getAttribute("content") || null;
    if (viewportMeta) {
      viewportMeta.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
      );
    }

    let isPinching = false;
    let initialDistance = 0;
    let initialScale = textScaleRef.current;

    const getDistance = (t) =>
      Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);

    const onTouchStart = (e) => {
      if (e.touches.length === 2) {
        isPinching = true;
        initialDistance = getDistance(e.touches);
        initialScale = textScaleRef.current;
        e.preventDefault();
      }
    };
    const onTouchMove = (e) => {
      if (isPinching && e.touches.length === 2) {
        e.preventDefault();
        const d = getDistance(e.touches);
        if (initialDistance > 0) {
          const next = clampTextScale(initialScale * (d / initialDistance));
          setTextScale(Math.round(next * 100) / 100);
        }
      }
    };
    const onTouchEnd = (e) => {
      if (!e.touches || e.touches.length < 2) {
        isPinching = false;
        initialDistance = 0;
      }
    };

    const blockGesture = (e) => { e.preventDefault(); };

    document.addEventListener("touchstart",   onTouchStart, { passive: false });
    document.addEventListener("touchmove",    onTouchMove,  { passive: false });
    document.addEventListener("touchend",     onTouchEnd,   { passive: true });
    document.addEventListener("touchcancel",  onTouchEnd,   { passive: true });
    document.addEventListener("gesturestart", blockGesture);
    document.addEventListener("gesturechange",blockGesture);
    document.addEventListener("gestureend",   blockGesture);

    return () => {
      document.removeEventListener("touchstart",   onTouchStart);
      document.removeEventListener("touchmove",    onTouchMove);
      document.removeEventListener("touchend",     onTouchEnd);
      document.removeEventListener("touchcancel",  onTouchEnd);
      document.removeEventListener("gesturestart", blockGesture);
      document.removeEventListener("gesturechange",blockGesture);
      document.removeEventListener("gestureend",   blockGesture);
      if (viewportMeta && prevViewport !== null) {
        viewportMeta.setAttribute("content", prevViewport);
      }
    };
  }, [isMobile]);

  const scrollToBottom = useCallback(() => {
    setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 80);
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, aiLoading, showAiButtons, selectedUser, scrollToBottom]);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    const scrollHeight = textarea.scrollHeight;
    const maxHeight = isMobile ? 100 : 140;
    textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    textarea.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
    setInputHeight(Math.max(textarea.offsetHeight + 32, isMobile ? 60 : 80));
  }, [text, isMobile]);

  // ✅ ОБРАБОТКА ПРЕФИЛЛА ПРИ НАВИГАЦИИ
  useEffect(() => {
    if (location.state?.prefill && selectedUser?.type === "ai") {
      const { prefill, categoryId } = location.state;
      let messageText = "";

      if (prefill === "new_match" && categoryId) {
        // Маппинг категорий для текста
        const categoryTexts = {
          // friends: lang === "fr" ? "un ami" : "a friend",
          clients: lang === "fr" ? "un client pour mon business" : "a client for business",
          startup: lang === "fr" ? "une startup" : "a startup",
          // dating: lang === "fr" ? "un partenaire romantique" : "a romantic partner",
          job: lang === "fr" ? "un emploi/stage" : "a job/internship",
          other: lang === "fr" ? "quelque chose d'autre" : "something else"
        };

        messageText = lang === "fr"
          ? `Je veux trouver ${categoryTexts[categoryId] || categoryId}`
          : `I want to find ${categoryTexts[categoryId] || categoryId}`;
      } else if (prefill === "change_about_me") {
        setAiMode("edit_about_init");
        messageText = lang === "fr"
          ? "Je veux modifier mon 'À propos de moi'"
          : "I want to update my 'About me'";
      } else if (prefill === "edit_request") {
        const { requestText, requestId } = location.state;
        if (requestId) {
          setEditRequestId(requestId);
          setAiMode("edit_request_init");
        }
        if (requestText) {
          messageText = lang === "fr"
            ? `Je veux modifier ma demande "${requestText}"`
            : `I want to change my request "${requestText}"`;
        } else {
          messageText = lang === "fr"
            ? "Je veux modifier ma demande"
            : "I want to change my request";
        }
      }

      if (messageText) {
        setText(messageText);
        // ⬇️ СБРАСЫВАЕМ КНОПКИ при редактировании реквеста/about, иначе input заблокирован
        if (prefill === "edit_request" || prefill === "change_about_me") {
          setShowAiButtons(false);
        }
        // Очистка состояния, чтобы не повторялось
        navigate(location.pathname, { replace: true, state: null });
      }
    }
  }, [location.state, selectedUser, lang, navigate]);

  useClickOutside(attachmentMenuRef, showAttachmentMenu, () => setShowAttachmentMenu(false));
  useClickOutside(menuRef, showMenu, () => setShowMenu(false));

  // ── Тема: подключаем общую систему с CSS-переменными и плавным переходом ──
  const isSamsungBrowser = isSamsungProp ?? (
    typeof navigator !== "undefined" && /SamsungBrowser/i.test(navigator.userAgent)
  );
  const activeTheme = isSamsungBrowser ? "samsung" : theme;

  // CSS-переменные + плавные transitions через commonHooks
  const cssThemeVars = useThemeCssVars(theme, isSamsungBrowser);

  // Chat-специфичные переменные поверх общих (glassmorphism, иконки и т.д.)
  const chatSpecific = useMemo(() => {
    const LIGHT = {
      border: "#7b83e6",
      chatUser: "#f0eeff",   // входящие сообщения — чуть светлее, чтобы отличались от белого
      chatOther: "#667eea11", ai: "#ffffff", // AI-пузырьки белые — максимальный контраст с фоном
      gradient: "linear-gradient(135deg, #5b5bd6 0%, #6d28d9 100%)", // насыщеннее для исходящих
      glassPanel: "rgba(255,255,255,0.72)",
      glassBorder: "rgba(111, 126, 234, 0.20)",
      glassText: "#1a2340",
      glassShadow: "0 12px 34px rgba(65,80,150,0.13), inset 0 1px 1px rgba(255,255,255,0.82)",
      glassMenuBg: "rgba(248, 250, 255, 0.92)",
      aiLoading: "rgba(237,242,255,0.92)", aiLoadingText: "#4f46a5",
      attachBg: "rgba(238, 243, 255, 0.74)",
      iconColor: "#ffffff",
      backIconColor: "#1a2340",
      // Доп. переменные для пузырьков
      aiBubbleBorder: "1px solid rgba(111, 126, 234, 0.16)",
      aiBubbleShadow: "0 8px 22px rgba(65,80,150,0.10)",
      userBubbleShadow: "0 10px 24px rgba(91,110,225,0.28)",
    };
    const DARK = {
      border: "#667eea",
      chatUser: "#0f3460", chatOther: "#667eea11", ai: "#0f3460",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      glassPanel: "rgba(30, 40, 70, 0.45)",
      glassBorder: "rgba(120, 140, 255, 0.22)",
      glassText: "#f0f4ff",
      glassShadow: "0 8px 32px rgba(0,0,0,0.40), inset 0 1px 1px rgba(255,255,255,0.08)",
      glassMenuBg: "rgba(30, 40, 70, 0.82)",
      aiLoading: "rgba(30,40,60,0.82)", aiLoadingText: "#ccd0ff",
      attachBg: "rgba(30, 40, 70, 0.30)",
      iconColor: "#ffffff",
      backIconColor: "#f0f4ff",
      aiBubbleBorder: "1px solid rgba(120,140,255,0.15)",
      aiBubbleShadow: "0 2px 8px rgba(0,0,0,0.25)",
      userBubbleShadow: "0 2px 8px rgba(0,0,0,0.35)",
    };
    const SAMSUNG = {
      ...LIGHT,
      iconColor: "#ffffff",
      backIconColor: "#1e1450",
    };
    if (activeTheme === "dark") return DARK;
    if (activeTheme === "samsung") return SAMSUNG;
    return LIGHT;
  }, [activeTheme]);

  // Итоговый themeVars — общие CSS-переменные + чат-специфичные значения
  const themeVars = useMemo(
    () => ({ ...cssThemeVars, ...chatSpecific }),
    [cssThemeVars, chatSpecific]
  );

  const menuBtnStyle = (themeVars) => ({
    background: "none",
    border: "none",
    padding: "10px 12px",
    width: "100%",
    textAlign: "left",
    color: themeVars.fg,
    cursor: "pointer",
    fontSize: "14px",
    borderRadius: "8px",
    transition: "background 0.2s ease",
  });

  const filteredDialogs = useMemo(() =>
    dialogs.filter(d =>
      d.username?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.email?.toLowerCase().includes(searchQuery.toLowerCase())
    ),
  [dialogs, searchQuery]);

  // ── AI welcome: страховка на уровне рендера ──────────────────────────────
  // setMessages вызывается из множества мест (loadAiHistory, sendAiMessage,
  // resetProfile, findAnotherMatch, attachments, WS), и не все ветки пропускают
  // массив через localizeMessages. Чтобы пользователь с lang="fr" не видел
  // английское приветствие даже при первом заходе (когда кеш пуст и какая-то
  // ветка успевает вставить «сырое» сообщение от бека), переводим приветствие
  // на лету при рендере. Это идемпотентно: если строка уже на FR — маркер
  // не сработает и сообщение вернётся как есть.
  //
  // Дополнительно помечаем самый первый AI-бабл — это позволяет fallback-
  // эвристике (isProbablyEnglishWelcomeText) сработать, даже если бек поменял
  // формулировку и ни один из явных маркеров не подошёл. Это безопасно, потому
  // что мы переводим в FR-шаблон только сообщение, гарантированно являющееся
  // приветствием (первая AI-реплика).
  const aiDisplayMessages = useMemo(() => {
    let firstAiSeen = false;
    return messages.map((msg) => {
      const isFirstAi = !firstAiSeen && msg && msg.sender_id === 0;
      if (isFirstAi) firstAiSeen = true;
      return {
        ...msg,
        content: translateWelcomeIfNeeded(msg.content, lang, { isFirstAiBubble: isFirstAi }),
      };
    });
  }, [messages, lang]);

  // Сообщения без is_match_reason — фильтруем один раз, чтобы при наборе
  // текста в инпуте не пересчитывать массив на каждом рендере.
  const visibleMessages = useMemo(
    () => aiDisplayMessages.filter(msg => !msg.is_match_reason),
    [aiDisplayMessages]
  );

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const h = date.getHours().toString().padStart(2, "0");
    const m = date.getMinutes().toString().padStart(2, "0");
    if (isToday) return `${h}:${m}`;
    const day = date.getDate();
    const months = lang === "fr" ? ["jan", "fév", "mar", "avr", "mai", "jun", "jul", "aoû", "sep", "oct", "nov", "déc"]
      : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${day} ${months[date.getMonth()]}, ${h}:${m}`;
  };

  // checkMatchingStatus остаётся — вызывается и после отправки сообщений
  const checkMatchingStatus = async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${API_URL}/api/matching_status`, { headers: authHeaders });
      setStartMatchingDisabled(
        res.data.has_attempt && ["pending", "in_progress"].includes(res.data.status)
      );
    } catch (err) {
      console.error("Matching status check failed:", err);
    }
  };

  useEffect(() => {
    if (startMatchingDisabled && !prevStartMatchingDisabledRef.current) {
      toast(
        lang === "fr"
          ? "🔍 Recherche lancée ! L'IA recherche le meilleur candidat..."
          : "🔍 Matching started! AI is searching for the best match...",
        "bottom",
        10000
      );
    }
    prevStartMatchingDisabledRef.current = startMatchingDisabled;
  }, [startMatchingDisabled, lang, toast]);

  // ── Параллельная загрузка всех начальных данных ──────────────────────────
  // dialogs, socialLinks уже показаны из кеша — здесь тихо обновляем с бека
  useEffect(() => {
    if (!token) { setDialogsLoaded(true); return; }
    Promise.all([
      // 1. Диалоги — обновляем тихо поверх кеша
      axios.get(`${API_URL}${MESSAGE_ENDPOINTS.DIALOGS}`, { headers: authHeaders })
        .then(res => setDialogs(res.data.filter(u => u.id !== 0)))
        .catch(err => console.warn("Dialogs fetch failed (using cache):", err?.message || err))
        .finally(() => setDialogsLoaded(true)),
      // 2. Статус профиля
      axios.get(`${API_URL}/api/profile_status`, { headers: authHeaders })
        .then(res => {
          const hasProfile = res.data?.profile_completed === true;
          const hasRequest = res.data?.has_request === true;
          if (res.data?.username) {
            setCurrentUsername(res.data.username);
            localStorage.setItem("username", res.data.username);
          }
          const isOnUserChat = /^\/chat\/\d+$/.test(window.location.pathname);
          if (!hasProfile || !hasRequest) {
            setProfileIncomplete(true);
            if (!isOnUserChat) navigate("/chat/ai", { replace: true });
          } else {
            setProfileIncomplete(false);
          }
          setShowAiButtons(hasProfile);
        })
        .catch(err => {
          // Раньше глоталось молча — юзер не понимал, почему «ничего не появилось».
          console.error("profile_status fetch failed:", err);
          toast(
            lang === "fr"
              ? "Échec de la vérification du profil. Vérifiez votre connexion."
              : "Profile check failed. Check your connection.",
            "error",
            6000
          );
        })
        .finally(() => setProfileCheckComplete(true)),
      // 3. Социальные ссылки — обновляем тихо поверх кеша
      axios.get(`${API_URL}/api/social-links`, { headers: authHeaders })
        .then(res => setSavedSocialLinks(res.data.links || {}))
        .catch(err => console.warn("social-links fetch failed:", err?.message || err)),
      // 4. Статус матчинга — всегда с бека (живые данные)
      axios.get(`${API_URL}/api/matching_status`, { headers: authHeaders })
        .then(res => setStartMatchingDisabled(
          res.data.has_attempt && ["pending", "in_progress"].includes(res.data.status)
        ))
        .catch(err => console.warn("matching_status fetch failed:", err?.message || err)),
    ]);
  }, [token]);

  // Автоматическое открытие чата с AI если нет диалогов с другими пользователями
  useEffect(() => {
    if (dialogs.length > 0 && !chatId && !selectedUser) {
      const hasUserDialogs = dialogs.some(d => d.id !== 0);
      if (!hasUserDialogs && !location.pathname.includes('/chat/ai')) {
        setSelectedUser({ id: "ai", username: "AI Assistant", type: "ai" });
        navigate("/chat/ai", { replace: true });
      }
    }
  }, [dialogs, chatId, selectedUser, navigate, location.pathname]);

  const handleResetProfile = async () => {
    setShowMenu(false);
    const confirmMsg = lang === "fr"
      ? "Êtes-vous sûr de vouloir réinitialiser votre profil et l'historique des discussions ? Cette action est irréversible."
      : "Are you sure you want to reset your profile and chat history? This action cannot be undone.";
    if (!window.confirm(confirmMsg)) return;
    try {
      await axios.post(`${API_URL}/api/profile/reset`, {}, {
        headers: authHeaders,
      });
      toast(
        lang === "fr"
          ? "Profil et historique réinitialisés. Rechargement..."
          : "Profile and chat history reset. Reloading...",
        "success",
        2000
      );
      setTimeout(() => window.location.reload(), 1200);
    } catch (err) {
      console.error("Profile reset error: ", err);
      toast(
        lang === "fr"
          ? "Échec de la réinitialisation du profil."
          : "Failed to reset profile.",
        "error",
        6000
      );
    }
  };

  const loadAiHistory = async () => {
    // Сразу показываем кешированные сообщения (с локализацией приветствия)
    const cached = getCachedMessages("ai");
    if (cached.length > 0) setMessages(localizeMessages(cached, lang));

    try {
      let processedMessages;
      try {
        const res = await axios.get(`${API_URL}/api/ai_conversation`, {
          headers: authHeaders,
          params: { lang },
        });
        // Новый источник истины — дерево ai_messages (активный путь + метаданные
        // веток). Кешируем оригинал бека, локализацию приветствия применяем при показе.
        processedMessages = mapAiServerMessages(res.data?.messages || []);
      } catch (errNew) {
        // Fallback на легаси-эндпоинт, если бек ещё не задеплоен с деревом ai_messages
        // (иначе чат «исчезает» при рассинхроне фронта и бэка).
        if (errNew?.response?.status !== 404) throw errNew;
        const legacy = await axios.get(`${API_URL}/messages/0`, {
          headers: authHeaders,
          params: { lang },
        });
        processedMessages = (legacy.data || []).map((m) => ({
          id: m.id,
          sender_id: m.sender_id,
          recipient_id: m.recipient_id,
          content: m.content,
          timestamp: m.timestamp,
          edited_at: null,
          branch_index: 0,
          branch_count: 1,
          sibling_ids: [],
          can_edit: false,
        }));
      }

      setCachedMessages("ai", processedMessages);
      setMessages(localizeMessages(processedMessages, lang));

      const lastMsg = processedMessages[processedMessages.length - 1];
      if (!lastMsg || lastMsg.sender_id !== 0) return;

      // ⬇️ Если пришли из профиля для редактирования реквеста/about — не показываем кнопки
      const isEditMode = location.state?.prefill === "edit_request" || 
                         location.state?.prefill === "change_about_me";

      if (isEditMode) {
        setShowAiButtons(false);
        setMatchingDone(false);
      } else {
        // showAiButtons is restored from sessionStorage on state init — don't
        // re-derive from message text here. Message text may mention "Start Matching"
        // mid-conversation (in a clarifying question), which would incorrectly show
        // the button when the user hasn't finished filling their request yet.
        // Only call checkMatchingStatus to sync the disabled/enabled state.
        if (showAiButtons) await checkMatchingStatus();
        else setStartMatchingDisabled(false);
      }
    } catch (err) {
      console.error("AI history load error: ", err);
      // Если бек недоступен — оставляем кеш, не очищаем
      if (getCachedMessages("ai").length === 0) setMessages([]);
    }
  };

  useEffect(() => {
    const loadMessages = async () => {
      if (!selectedUser) {
        setMessages([]);
        return;
      }
      selectedUserRef.current = selectedUser;

      if (selectedUser.type === "ai") {
        await loadAiHistory();
      } else if (selectedUser.type === "support") {
        // Support-чат: отдельный API, изолированный от обычных Match-чатов.
        const cacheKey = "support";
        const cached = getCachedMessages(cacheKey);
        if (cached.length > 0) setMessages(cached);
        else setMessages([]);
        try {
          const res = await axios.get(`${API_URL}/api/support/chat`, { headers: authHeaders });
          if (selectedUserRef.current?.type !== "support") return;
          const chatId = res.data?.id;
          const msgs = (res.data?.messages || []).map(m => ({
            ...m,
            timestamp: m.created_at,
          }));
          setMessages(msgs);
          setCachedMessages(cacheKey, msgs);
          // Сохраняем id чата для последующих send/poll
          setSelectedUser(prev => prev && prev.type === "support"
            ? { ...prev, supportChatId: chatId, supportStatus: res.data?.status }
            : prev);
        } catch (err) {
          console.error("Error loading support chat:", err);
          if (getCachedMessages(cacheKey).length === 0) setMessages([]);
        }
      } else {
        // Сразу показываем кеш — не мигаем пустым экраном
        const cacheKey = `user_${selectedUser.id}`;
        const cached = getCachedMessages(cacheKey);
        if (cached.length > 0) setMessages(cached);
        else setMessages([]);

        try {
          const res = await axios.get(
            `${API_URL}${MESSAGE_ENDPOINTS.GET_BY_USER(selectedUser.id)}`,
            { headers: authHeaders }
          );
          if (selectedUserRef.current?.id === selectedUser.id) {
            const msgs = res.data.map(m => ({ ...m, timestamp: m.timestamp || m.created_at }));
            setMessages(msgs);
            setCachedMessages(cacheKey, msgs);
          }
        } catch (err) {
          console.error("Error loading messages:", err);
          // Оставляем кеш если бек недоступен
          if (getCachedMessages(`user_${selectedUser.id}`).length === 0) setMessages([]);
        }
      }
    };
    loadMessages();
  }, [selectedUser?.id, selectedUser?.type, token, currentUsername]);

  // Поллинг новых support-сообщений (10s) — простой и надёжный способ
  // без WebSocket-канала для саппорта.
  useEffect(() => {
    if (selectedUser?.type !== "support") return;
    let stopped = false;
    const tick = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/support/chat`, { headers: authHeaders });
        if (stopped || selectedUserRef.current?.type !== "support") return;
        const msgs = (res.data?.messages || []).map(m => ({ ...m, timestamp: m.created_at }));
        setMessages(prev => {
          // Без скачков: если набор изменился по id — обновим.
          const prevIds = prev.map(p => p.id).join(",");
          const nextIds = msgs.map(p => p.id).join(",");
          if (prevIds === nextIds) return prev;
          setCachedMessages("support", msgs);
          return msgs;
        });
      } catch (e) {
        // тихо игнорим — следующая итерация попробует снова
      }
    };
    const id = setInterval(tick, 10000);
    return () => { stopped = true; clearInterval(id); };
  }, [selectedUser?.type, token]);

  // При смене языка перелокализуем AI-приветствие из кеша (там хранится
  // оригинал бека на английском), чтобы не ждать перезагрузки страницы.
  useEffect(() => {
    if (selectedUser?.type !== "ai") return;
    const cached = getCachedMessages("ai");
    if (cached.length === 0) return;
    setMessages(localizeMessages(cached, lang));
  }, [lang, selectedUser?.type, getCachedMessages]);

  // WebSocket: один раз на токен, переиспользуется для всех чатов
  useEffect(() => {
    if (!token) return;
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const wsUrl = `${protocol}//${window.location.host}${WS_ENDPOINT(token)}`;

    let reconnectTimer = null;
    let isCleaned = false;

    const connect = () => {
      if (isCleaned) return;
      ws.current = new WebSocket(wsUrl);
      ws.current.onopen = () => console.log("WebSocket connected");
      ws.current.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          const current = selectedUserRef.current;
          if (
            current &&
            current.type === "user" &&
            (msg.sender_id === current.id || msg.recipient_id === current.id) &&
            msg.sender_id !== 0 &&
            msg.recipient_id !== 0
          ) {
            const newMsg = { ...msg, timestamp: msg.timestamp || msg.created_at };
            setMessages(prev => {
              const updated = [...prev, newMsg];
              setCachedMessages(`user_${current.id}`, updated);
              return updated;
            });
          }
        } catch (err) {
          console.error("WebSocket message error: ", err);
        }
      };
      ws.current.onclose = () => {
        console.log("WebSocket closed");
        if (!isCleaned) {
          reconnectTimer = setTimeout(connect, 3000);
        }
      };
      ws.current.onerror = (err) => console.error("WebSocket error: ", err);
    };

    connect();

    return () => {
      isCleaned = true;
      clearTimeout(reconnectTimer);
      ws.current?.close();
      ws.current = null;
    };
  }, [token]);

  // Инициализация чата из URL
  useEffect(() => {
    if (!chatId) {
      setSelectedUser(null);
      return;
    }
    if (chatId === "ai") {
      setSelectedUser({ id: "ai", username: "AI Assistant", type: "ai" });
    } else if (chatId === "support") {
      setSelectedUser({ id: "support", username: "Support", type: "support" });
    } else {
      const user = dialogs.find(d => d.id.toString() === chatId);
      if (user) {
        setSelectedUser({ ...user, type: "user" });
      } else if (dialogsLoaded) {
        // Только сбрасываем, если диалоги уже загружены и пользователь действительно не найден
        setSelectedUser(null);
      }
      // Если dialogsLoaded=false — ждём загрузки диалогов, не сбрасываем selectedUser
    }
  }, [chatId, dialogs, dialogsLoaded]);

  const sendAiMessage = async (e) => {
    e.preventDefault();
    if (!text.trim() || aiLoading) return;
    const userMessage = {
      id: `temp-${Date.now()}`,
      sender_id: 1,
      recipient_id: 0,
      content: text.trim(),
      timestamp: new Date().toISOString(),
    };
    setMessages(prev => {
      const updated = [...prev, userMessage];
      setCachedMessages("ai", updated);
      return updated;
    });
    setText("");
    setAiLoading(true);
    setTimeout(scrollToBottom, 80);
    try {
      const payload = { content: userMessage.content, lang, mode: aiMode };
      if ((aiMode === "edit_request" || aiMode === "edit_request_init") && editRequestId) {
        payload.edit_request_id = editRequestId;
      }
      const response = await axios.post(
        `${API_URL}${AI_ENDPOINTS.MESSAGE}`,
        payload,
        { headers: authHeaders }
      );

      if (response.data?.mode === "new_search_request") {
        setAiMode("profile");
        // Уважаем флаг бека: если can_start_matching=false (валидация не прошла,
        // дубликат, ошибка БД) — не врём фронтом, что запрос создан.
        const canStart = response.data?.show_start_matching === true;
        const newSrId = response.data?.search_request_id;
        if (canStart && newSrId) setActiveSearchRequestId(Number(newSrId));

        if (canStart) {
          const infoMsg = lang === "fr"
            ? "✅ Nouvelle demande créée. Cliquez sur « Start Matching » pour lancer la recherche."
            : "✅ New search request created. Click Start Matching to begin.";
          toast(infoMsg, "success", 8000);
        }
        await loadAiHistory();
        setShowAiButtons(canStart);
        if (canStart) {
          setStartMatchingDisabled(false);
          setMatchingDone(false);
        }
        setAiLoading(false);
        return;
      }

      if (response.data?.mode === "edit_request_ready") {
        setAiMode("edit_request");
        await loadAiHistory();
        setAiLoading(false);
        return;
      }

      if (response.data?.mode === "edit_request_confirmed") {
        setAiMode("profile");
        setEditRequestId(null);
        const infoMsg = lang === "fr"
          ? "✅ Demande mise à jour."
          : "✅ Request updated.";
        toast(infoMsg, "success", 6000);
        await loadAiHistory();
        setAiLoading(false);
        return;
      }

      if (response.data?.mode === "edit_about_ready") {
        setAiMode("edit_about");
        await loadAiHistory();
        setAiLoading(false);
        return;
      }

      if (response.data?.mode === "edit_about_confirmed") {
        setAiMode("profile");
        const infoMsg = lang === "fr"
          ? "✅ 'À propos de moi' mis à jour."
          : "✅ 'About me' updated.";
        toast(infoMsg, "success", 6000);
        await loadAiHistory();
        setShowAiButtons(true);
        setStartMatchingDisabled(false);
        setAiLoading(false);
        return;
      }

      if (response.data?.mode === "edit_about_needs_request") {
        setAiMode("new_search_request");
        const infoMsg = lang === "fr"
          ? "✅ 'À propos de moi' mis à jour. Décrivez maintenant qui vous cherchez."
          : "✅ 'About me' updated. Now describe who you're looking for.";
        toast(infoMsg, "success", 8000);
        await loadAiHistory();
        setShowAiButtons(false);
        setAiLoading(false);
        return;
      }

      await loadAiHistory();

      const aiResponse = response.data?.answer || response.data?.response || "";
      const showButtons = response.data?.show_buttons ?? false;

      // Profile completed in chat → backend creates SearchRequest and returns its id.
      const profileSrId = response.data?.search_request_id;
      if (profileSrId) {
        setActiveSearchRequestId(Number(profileSrId));
        setMatchingDone(false);
      }

      const hasProfile = messageHasProfile(aiResponse);
      const hasButtons = messageHasButtonTrigger(aiResponse);

      setShowAiButtons(hasProfile || showButtons || hasButtons);
    } catch (err) {
      console.error("AI message error: ", err);
      toast(
        lang === "fr" ? "Erreur lors de l'envoi du message" : "Error sending message",
        "error"
      );
    } finally {
      setAiLoading(false);
    }
  };

  // Защита от двойного клика по Start Matching: реактивный setState не успевает
  // обновить DOM-disabled между двумя touch-end'ами на мобиле.
  const startMatchInFlightRef = useRef(false);
  const startMatch = async () => {
    if (startMatchInFlightRef.current) return;
    startMatchInFlightRef.current = true;
    setAiLoading(true);
    setStartMatchingDisabled(true);
    try {
      const payload = { lang };
      // Передаём конкретный запрос, чтобы бек не угадывал «последний по дате».
      if (activeSearchRequestId != null) {
        payload.search_request_id = activeSearchRequestId;
      }
      const res = await axios.post(
        `${API_URL}${PROFILE_ENDPOINTS.START_MATCH}`,
        payload,
        { headers: authHeaders }
      );
      const okMsg = res.data?.answer || res.data?.message ||
        (lang === "fr"
          ? "Recherche lancée ! Consultez les résultats dans votre profil."
          : "Matching started! Check results in your profile.");
      toast(okMsg, "success", 8000);
      setShowAiButtons(true);
      setMatchingDone(true);
    } catch (err) {
      console.error("Match error: ", err);
      const errMsg = err.response?.data?.answer ||
        err.response?.data?.message ||
        (lang === "fr" ? "Erreur lors du lancement de la recherche" : "Error starting matching");
      toast(errMsg, "error", 8000);
      setStartMatchingDisabled(false);
    } finally {
      setAiLoading(false);
      startMatchInFlightRef.current = false;
    }
  };

  const findAnotherMatch = () => {
    setAiMode("new_search_request");
    // Сбрасываем привязку к старому запросу — следующий start_match должен
    // запуститься уже на новом SearchRequest.
    setActiveSearchRequestId(null);
    setMatchingDone(false);
    const msg = {
      id: Date.now(),
      sender_id: 0,
      recipient_id: "current_user",
      content: lang === "fr"
        ? "✨ Parfait ! Décrivez qui vous souhaitez trouver dans cette nouvelle recherche ?"
        : "✨ Great! Tell me who you want to find in this new search?",
      timestamp: new Date().toISOString(),
    };
    setMessages(prev => [...prev, msg]);
    setShowAiButtons(false);
  };

  // Применяет ответ /api/ai_messages/* (активный путь дерева) к состоянию чата.
  const applyAiConversation = useCallback((serverMsgs) => {
    const processed = mapAiServerMessages(serverMsgs);
    setCachedMessages("ai", processed);
    setMessages(localizeMessages(processed, lang));
    const last = serverMsgs && serverMsgs[serverMsgs.length - 1];
    if (last && last.role === "assistant") {
      setShowAiButtons(messageHasProfile(last.content) || messageHasButtonTrigger(last.content));
    }
  }, [lang, setCachedMessages]);

  const startEditAiMessage = (msg) => {
    setEditingMsgId(msg.id);
    setEditingText(msg.content || "");
  };

  const cancelEditAiMessage = () => {
    setEditingMsgId(null);
    setEditingText("");
  };

  const submitEditAiMessage = async (msg) => {
    const content = (editingText || "").trim();
    if (!content) return;
    setEditingMsgId(null);
    setAiLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/ai_messages/${msg.id}/edit`,
        { content, lang },
        { headers: authHeaders }
      );
      applyAiConversation(res.data?.messages || []);
    } catch (err) {
      console.error("Edit AI message error:", err);
      toast(lang === "fr" ? "Erreur lors de la modification" : "Error editing message", "error");
      await loadAiHistory();
    } finally {
      setEditingText("");
      setAiLoading(false);
      setTimeout(scrollToBottom, 80);
    }
  };

  const switchAiBranch = async (msg, dir) => {
    const ids = msg.sibling_ids || [];
    if (ids.length < 2) return;
    const curIdx = msg.branch_index ?? ids.indexOf(msg.id);
    const nextIdx = curIdx + dir;
    if (nextIdx < 0 || nextIdx >= ids.length) return;
    const targetId = ids[nextIdx];
    setAiLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/api/ai_messages/${targetId}/select`,
        {},
        { headers: authHeaders }
      );
      applyAiConversation(res.data?.messages || []);
    } catch (err) {
      console.error("Switch AI branch error:", err);
    } finally {
      setAiLoading(false);
    }
  };

  const resetProfile = async () => {
    setAiLoading(true);
    try {
      const triggerMsg = lang === "fr"
        ? "Je veux modifier mon 'À propos de moi'"
        : "I want to update my 'About me'";

      const userMessage = {
        id: `temp-${Date.now()}`,
        sender_id: 1,
        recipient_id: 0,
        content: triggerMsg,
        timestamp: new Date().toISOString(),
      };
      setMessages(prev => {
        const updated = [...prev, userMessage];
        setCachedMessages("ai", updated);
        return updated;
      });

      const response = await axios.post(
        `${API_URL}${AI_ENDPOINTS.MESSAGE}`,
        { content: triggerMsg, lang, mode: "edit_about_init" },
        { headers: authHeaders }
      );
      if (response.data?.mode === "edit_about_ready") {
        setAiMode("edit_about");
      } else {
        setAiMode("edit_about_init");
      }
      await loadAiHistory();
      setShowAiButtons(false);
      setStartMatchingDisabled(false);
      setMatchingDone(false);
    } catch (err) {
      console.error("Edit 'About me' init error: ", err);
      toast(
        lang === "fr" ? "Erreur lors de la mise à jour" : "Error updating About me",
        "error"
      );
    } finally {
      setAiLoading(false);
    }
  };

  const sendMessageViaAPI = async (recipientId, content) => {
    try {
      const newMsg = {
        id: Date.now(),
        sender_id: "current_user",
        recipient_id: recipientId,
        content,
        timestamp: new Date().toISOString(),
      };
      setMessages(prev => [...prev, newMsg]);
      await axios.post(
        `${API_URL}${MESSAGE_ENDPOINTS.SEND}`,
        { recipient_id: recipientId, content },
        { headers: authHeaders }
      );
      setText("");
    } catch (err) {
      console.error("Error sending message:", err);
      setMessages(prev => prev.filter(m => m.id !== Date.now()));
    }
  };

  const sendSupportMessage = async (content) => {
    // Оптимистично добавляем своё сообщение в UI
    const optimistic = {
      id: `temp-${Date.now()}`,
      chat_id: selectedUser?.supportChatId || null,
      sender_kind: "user",
      sender_id: "current_user",
      content,
      timestamp: new Date().toISOString(),
      created_at: new Date().toISOString(),
      _optimistic: true,
    };
    setMessages(prev => {
      const updated = [...prev, optimistic];
      setCachedMessages("support", updated);
      return updated;
    });
    setText("");
    try {
      const res = await axios.post(
        `${API_URL}/api/support/messages`,
        { content },
        { headers: authHeaders }
      );
      const real = { ...res.data, timestamp: res.data?.created_at };
      setMessages(prev => {
        const updated = prev.map(m => m.id === optimistic.id ? real : m);
        setCachedMessages("support", updated);
        return updated;
      });
    } catch (err) {
      // Возвращаем UX к исходному состоянию + помечаем сбой
      console.error("Error sending support message:", err);
      setMessages(prev => {
        const updated = prev.filter(m => m.id !== optimistic.id);
        setCachedMessages("support", updated);
        return updated;
      });
      const msg = err?.response?.status === 429
        ? (lang === "fr" ? "Trop de messages, ralentissez." : "Too many messages — slow down.")
        : (lang === "fr" ? "Impossible d'envoyer le message" : "Failed to send message");
      try { toast(msg, "error"); } catch (_) {}
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!text.trim() || !selectedUser) return;
    if (selectedUser.type === "ai") {
      await sendAiMessage(e);
    } else if (selectedUser.type === "support") {
      await sendSupportMessage(text.trim());
    } else if (ws.current?.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify({ recipient_id: selectedUser.id, content: text }));
      setText("");
    } else {
      await sendMessageViaAPI(selectedUser.id, text);
    }
  };

  const handleSelectUser = useCallback((user) => {
    setSelectedUser(user);
    setShowMenu(false);
    if (user.type === "ai") navigate("/chat/ai");
    else if (user.type === "support") navigate("/chat/support");
    else if (user.id) navigate(`/chat/${user.id}`);
  }, [navigate]);

  const handleBackToList = useCallback(() => navigate("/chat"), [navigate]);

  const handleMouseDown = (e) => {
    if (isMobile) return;
    e.preventDefault();
    setIsResizing(true);
  };

  const handleMouseMove = (e) => {
    if (!isResizing || isMobile) return;
    const containerWidth = window.innerWidth;
    const newWidth = (e.clientX / containerWidth) * 100;
    const clamped = Math.min(Math.max(newWidth, 20), 60);
    setSidebarWidth(clamped);
    localStorage.setItem("chatSidebarWidth", clamped.toString());
  };

  const handleMouseUp = () => setIsResizing(false);

  useEffect(() => {
    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isResizing]);

  const adjustTextareaHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    const maxHeight = isMobile ? 100 : 140;
    const scrollHeight = textarea.scrollHeight;
    textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    textarea.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
    setTimeout(() => {
      setInputHeight(Math.max(textarea.offsetHeight + 32, isMobile ? 60 : 80));
    }, 10);
  }, [isMobile]);

  useEffect(() => {
    adjustTextareaHeight();
  }, [text, adjustTextareaHeight, isMobile]);

  const placeholderText = lang === "fr" ? "Écrivez un message..." : "Type a message...";

  const fileInputRef = useRef(null);
  const [showSocialOptions, setShowSocialOptions] = useState(false);
  const [socialLinkModal, setSocialLinkModal] = useState(null);
  const [socialLinkValue, setSocialLinkValue] = useState("");
  // ── Match reason — сворачивание/разворачивание ───────────────────────────
  // С 3-го визита в чат — по умолчанию свёрнуто (сохраняется локально)
  const [matchReasonCollapsed, setMatchReasonCollapsed] = useState(false);

  useEffect(() => {
    if (!selectedUser?.id || selectedUser.type !== "user") return;
    const key = `chatVisits_${selectedUser.id}`;
    try {
      const visits = parseInt(localStorage.getItem(key) || "0", 10) + 1;
      localStorage.setItem(key, String(visits));
      // 3-й и последующие визиты — сворачиваем по умолчанию
      setMatchReasonCollapsed(visits >= 3);
    } catch { setMatchReasonCollapsed(false); }
  }, [selectedUser?.id]);

  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showAvatarFull, setShowAvatarFull] = useState(false);
  const [partnerSocialLinks, setPartnerSocialLinks] = useState({});

  // ── Match rating (звёзды в профиле) ─────────────────────────────────────
  const [matchRating, setMatchRating] = useState(null);      // 1-5 | null
  const [ratingHover, setRatingHover] = useState(null);      // hover preview
  const [ratingLoading, setRatingLoading] = useState(false);
  const [ratingJustSaved, setRatingJustSaved] = useState(false);

  // При открытии модалки профиля — пушим фиктивную запись в историю,
  // чтобы кнопка «Назад» закрывала модалку, а не выкидывала из чата
  useEffect(() => {
    if (showUserProfile) {
      window.history.pushState({ userProfileModal: true }, "");
      const handlePopState = (e) => {
        setShowUserProfile(false);
        setShowAvatarFull(false);
      };
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, [showUserProfile]);

  const openUserProfile = useCallback(async () => {
    if (!selectedUser || selectedUser.type !== "user") return;
    setShowUserProfile(true);
    setMatchRating(null);
    setRatingJustSaved(false);
    try {
      const [socialRes, ratingRes] = await Promise.allSettled([
        axios.get(`${API_URL}/api/users/${selectedUser.id}/social-links`, { headers: authHeaders }),
        selectedUser.match_id
          ? axios.get(`${API_URL}/api/matches/${selectedUser.match_id}/rating`, { headers: authHeaders })
          : Promise.reject("no match_id"),
      ]);
      setPartnerSocialLinks(socialRes.status === "fulfilled" ? (socialRes.value.data.links || {}) : {});
      setMatchRating(ratingRes.status === "fulfilled" ? ratingRes.value.data.rating : null);
    } catch {
      setPartnerSocialLinks({});
      setMatchRating(null);
    }
  }, [selectedUser, authHeaders]);

  const handleRateMatch = useCallback(async (stars) => {
    if (!selectedUser?.match_id || ratingLoading) return;
    setMatchRating(stars);          // оптимистичное обновление
    setRatingLoading(true);
    try {
      await axios.post(
        `${API_URL}/api/matches/${selectedUser.match_id}/rating`,
        { rating: stars },
        { headers: authHeaders },
      );
      setRatingJustSaved(true);
      setTimeout(() => setRatingJustSaved(false), 1800);
    } catch {
      // откат если ошибка
      setMatchRating(prev => prev === stars ? null : prev);
    } finally {
      setRatingLoading(false);
    }
  }, [selectedUser, authHeaders, ratingLoading]);

  const handleDeleteAccount = async () => {
    setShowDeleteConfirm(false);
    try {
      await axios.delete(`${API_URL}/api/account`, {
        headers: authHeaders,
      });
      localStorage.clear();
      alert(
        lang === "fr"
          ? "Votre compte a été supprimé. Votre adresse e-mail a été conservée. Pour restaurer votre compte, contactez le support."
          : "Your account has been deleted. Your email has been retained. To restore your account, please contact support."
      );
      navigate("/login");
    } catch (err) {
      console.error("Delete account error:", err);
      alert(
        lang === "fr"
          ? "Erreur lors de la suppression du compte. Veuillez réessayer."
          : "Error deleting account. Please try again."
      );
    }
  };

  const handleSocialLinkSubmit = async () => {
    const link = socialLinkValue.trim();
    if (!link || !selectedUser) return;
    const label = socialLinkModal?.label || socialLinkModal?.network || "";
    const messageContent = `${label}: ${link}`;

    // Сохраняем ссылку на сервер
    if (socialLinkModal?.network) {
      try {
        const res = await axios.patch(
          `${API_URL}/api/social-links`,
          { network: socialLinkModal.network, value: link },
          { headers: authHeaders }
        );
        setSavedSocialLinks(res.data.links || {});
      } catch (err) {
        console.error("Failed to save social link:", err);
      }
    }

    setSocialLinkModal(null);
    setSocialLinkValue("");
    setShowAttachmentMenu(false);
    setShowSocialOptions(false);

    if (selectedUser.type === "ai") {
      const userMessage = {
        id: `temp-${Date.now()}`,
        sender_id: 1,
        recipient_id: 0,
        content: messageContent,
        timestamp: new Date().toISOString(),
      };
      setMessages(prev => [...prev, userMessage]);
      setAiLoading(true);
      setTimeout(scrollToBottom, 80);
      try {
        await axios.post(
          `${API_URL}${AI_ENDPOINTS.MESSAGE}`,
          { content: messageContent, lang, mode: aiMode },
          { headers: authHeaders }
        );
        await loadAiHistory();
      } catch (err) {
        console.error("Social link AI message error:", err);
        toast(lang === "fr" ? "Erreur lors de l'envoi" : "Error sending message", "error");
      } finally {
        setAiLoading(false);
      }
    } else if (ws.current?.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify({ recipient_id: selectedUser.id, content: messageContent }));
    } else {
      await sendMessageViaAPI(selectedUser.id, messageContent);
    }
  };

  // ── Вычисляем match reason до рендера ──────────────────────────────────────
  const matchReasonText = selectedUser?.match_reason
    ? (lang === "fr"
        ? (selectedUser.match_reason_fr || selectedUser.match_reason)
        : (selectedUser.match_reason_en || selectedUser.match_reason))
    : null;
  const matchReasonLabel    = lang === "fr" ? "Raison du match" : "Match reason";
  const matchReasonCompat   = lang === "fr" ? "Compatibilité"   : "Compatibility";

  // ── Высота верхнего спейсера (хедер + tableSlot бар под ним) ─────────────
  const topSpacerHeight = useMemo(() => {
    const headerH = isMobile ? 88 : 104;
    const slotH   = (tableSlot && tableSlotStatus !== "expired") ? (isMobile ? 64 : 120) : (tableSlotStatus === "expired" ? (isMobile ? 90 : 110) : 0);
    return headerH + slotH + 8;
  }, [isMobile, tableSlot]);

  const [redesignSidebarWidth, setRedesignSidebarWidth] = useState(() => {
    const saved = parseInt(localStorage.getItem("chatRedesignSidebarWidth") || "", 10);
    const max = typeof window !== "undefined" ? Math.min(560, Math.max(280, window.innerWidth - 760)) : 560;
    return Number.isFinite(saved) ? Math.min(Math.max(saved, 280), max) : Math.min(350, max);
  });
  const [redesignRightWidth, setRedesignRightWidth] = useState(() => {
    const saved = parseInt(localStorage.getItem("chatRightPanelWidth") || "", 10);
    return Number.isFinite(saved) ? Math.min(Math.max(saved, 320), 620) : 430;
  });
  const [isRedesignResizing, setIsRedesignResizing] = useState(false);
  const [isRedesignRightResizing, setIsRedesignRightResizing] = useState(false);
  const handleRedesignResizeStart = useCallback((e) => {
    if (isMobile) return;
    e.preventDefault();
    setIsRedesignResizing(true);
  }, [isMobile]);
  const handleRedesignRightResizeStart = useCallback((e) => {
    if (isMobile) return;
    e.preventDefault();
    setIsRedesignRightResizing(true);
  }, [isMobile]);

  useEffect(() => {
    try {
      localStorage.setItem("chatRightPanelOpen", String(showRightPanel));
    } catch {}
  }, [showRightPanel]);

  useEffect(() => {
    if (!isRedesignResizing || isMobile) return;
    const handleMove = (e) => {
      const max = Math.min(560, Math.max(280, window.innerWidth - 760));
      const next = Math.min(Math.max(e.clientX, 280), max);
      setRedesignSidebarWidth(next);
      localStorage.setItem("chatRedesignSidebarWidth", String(next));
    };
    const handleUp = () => setIsRedesignResizing(false);
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleUp);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isRedesignResizing, isMobile]);

  useEffect(() => {
    if (!isRedesignRightResizing || isMobile) return;
    const handleMove = (e) => {
      const max = Math.min(620, Math.max(320, window.innerWidth - redesignSidebarWidth - 420));
      const next = Math.min(Math.max(window.innerWidth - e.clientX, 320), max);
      setRedesignRightWidth(next);
      localStorage.setItem("chatRightPanelWidth", String(next));
    };
    const handleUp = () => setIsRedesignRightResizing(false);
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleUp);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isRedesignRightResizing, isMobile, redesignSidebarWidth]);

  const redesignRightOpen = showRightPanel && !!selectedUser;
  const redesignRightVisible = !isMobile && redesignRightOpen;
  const redesignGridColumns = isMobile
    ? undefined
    : `var(--na-sidebar-width) 4px minmax(0, 1fr)${redesignRightVisible ? " 4px var(--na-right-width)" : ""}`;
  const getEntityName = (user) => {
    if (!user) return "";
    if (user.type === "ai" || user.id === "ai") return lang === "fr" ? "Assistant IA" : "AI Assistant";
    if (user.type === "support" || user.id === "support") return lang === "fr" ? "Chat Support" : "Support Chat";
    return user.username || user.name || user.email || "User";
  };

  const getEntityHandle = (user) => {
    if (!user) return "";
    const raw = user.username || user.name || user.email || "user";
    return raw.includes("@") ? raw : `@${raw}`;
  };

  const getDialogPreview = (user) => {
    const raw = user?.last_message || user?.lastMessage || user?.message || user?.preview;
    if (raw && typeof raw === "object") return raw.content || raw.text || "";
    return raw || user?.about || (lang === "fr" ? "Ouvrir le dialogue" : "Open conversation");
  };

  const getDialogTime = (user) => {
    const raw = user?.last_message || user?.lastMessage;
    const timestamp = user?.last_message_at || user?.updated_at || user?.created_at || (raw && typeof raw === "object" ? (raw.timestamp || raw.created_at) : null);
    return timestamp ? formatMessageTime(timestamp) : "";
  };

  const getCompatScore = (user) => {
    const raw = user?.compatibility_score ?? user?.compatibility ?? user?.match_score ?? user?.score;
    const num = Number(raw);
    return Number.isFinite(num) ? Math.max(0, Math.min(100, Math.round(num))) : null;
  };

  const profileScore = getCompatScore(selectedUser) ?? 85;
  const selectedName = getEntityName(selectedUser);
  const selectedHandle = getEntityHandle(selectedUser);
  const selectedShowsOnline = selectedUser?.type === "support" || selectedUser?.type === "ai";
  const dialogSections = (() => {
    const map = {};
    const sections = [];
    filteredDialogs.forEach((user) => {
      const key = user.event_id ? String(user.event_id) : "__direct__";
      if (!map[key]) {
        map[key] = {
          key,
          event_id: user.event_id || null,
          title: user.event_id
            ? (user.event_title || `Event #${user.event_id}`)
            : (lang === "fr" ? "Directs" : "Direct messages"),
          users: [],
        };
        sections.push(map[key]);
      }
      map[key].users.push(user);
    });
    sections.sort((a, b) => {
      if (a.event_id && !b.event_id) return -1;
      if (!a.event_id && b.event_id) return 1;
      return 0;
    });
    return sections;
  })();
  const conversationDateLine = (selectedUser?.type === "ai" ? messages : visibleMessages).find(m => m?.timestamp)?.timestamp;
  const sideMatchReasonText = matchReasonText || selectedUser?.match_reason || (lang === "fr" ? "Raison du match indisponible." : "Match reason is not available yet.");

  const renderAvatar = (user, size = 48, className = "", showStatus = false) => {
    const type = user?.type || user?.id;
    const name = getEntityName(user);
    const isSupport = type === "support" || user?.id === "support";
    const isAi = type === "ai" || user?.id === "ai";
    return (
      <div className={`na-avatar-wrap ${className}`} style={{ width: size, height: size }}>
        {isSupport || isAi ? (
          <img src={isAi ? ai : support} alt={name} />
        ) : (
          <Avatar
            key={user?.id || name || "avatar"}
            userId={user?.id || name || "avatar"}
            enabled={!user?.localOnly}
            size={size}
            username={name}
          />
        )}
        {showStatus && <span className="na-status" />}
      </div>
    );
  };

  const renderDialogRow = (user, subtitle, active, onClick, extraRight = null) => (
    (() => {
      const rowSlot = user?.match_id ? (allTableSlots[String(user.match_id)] ?? null) : null;
      const rowSlotStatus = rowSlot?.status ?? null;
      const fmtSec = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
      let slotBadge = null;
      let slotTimer = null;
      if (rowSlot) {
        if (rowSlotStatus === "active") {
          slotBadge = <span className="na-row-slot-badge active">🪑 Table {rowSlot.table_number}</span>;
          slotTimer = (
            <span className={`na-row-slot-timer${(rowSlot.seconds_left ?? 0) < 60 ? " urgent" : ""}`}>
              {fmtSec(rowSlot.seconds_left ?? 0)}
            </span>
          );
        } else if (rowSlotStatus === "searching") {
          slotBadge = (
            <span className="na-row-slot-badge searching">
              🔍 {lang === "fr" ? `Table ${rowSlot.table_number}` : `Table ${rowSlot.table_number}`}
            </span>
          );
          slotTimer = <span className="na-row-slot-timer searching">{fmtSec(rowSlot.seconds_left ?? 0)}</span>;
        } else if (rowSlotStatus === "queued") {
          slotBadge = (
            <span className="na-row-slot-badge queued">
              {rowSlot.queue_position ? `⏳ #${rowSlot.queue_position}` : "⏳"}
            </span>
          );
          const s = rowSlot.seconds_left ?? 0;
          slotTimer = (
            <span className="na-row-slot-timer queued">
              {s <= 0 ? "—" : (s < 60 ? "<1m" : (s < 3600 ? `~${Math.round(s / 60)}m` : `~${Math.floor(s / 3600)}h`))}
            </span>
          );
        } else if (rowSlotStatus === "expired") {
          slotBadge = (
            <span className="na-row-slot-badge expired">
              ✅ {lang === "fr" ? "Terminé" : "Done"}
            </span>
          );
        }
      }
      return (
        <button
          key={user.id || user.username || user.email}
          type="button"
          className={`na-dialog-row${active ? " active" : ""}${rowSlotStatus === "active" ? " table-rainbow-border" : ""}${rowSlotStatus === "searching" ? " searching-pulse" : ""}`}
          onClick={onClick}
        >
          {renderAvatar(user, 48, "", user.type === "support" || user.type === "ai")}
          <span className="na-dialog-text">
            <strong>{getEntityName(user)}</strong>
            {slotBadge ? <span className="na-row-slot-line">{slotBadge}</span> : <small>{subtitle}</small>}
          </span>
          <span className="na-dialog-meta">
            <span className="na-dialog-time-row">
              {slotTimer}
              <span className="na-dialog-time-text">{extraRight}</span>
            </span>
          </span>
        </button>
      );
    })()
  );

  const slotLabel = (() => {
    if (!tableSlot) return "";
    if (tableSlotStatus === "queued") {
      return tableSlot.queue_position
        ? (lang === "fr" ? `File #${tableSlot.queue_position}` : `Queue #${tableSlot.queue_position}`)
        : (lang === "fr" ? "En file d'attente" : "Waiting in queue");
    }
    if (tableSlotStatus === "searching") return lang === "fr" ? "Recherche de table" : "Finding table";
    if (tableSlotStatus === "expired") return lang === "fr" ? "Session terminee" : "Session done";
    return lang === "fr" ? "Votre table" : "Your table";
  })();

  const slotTime = (() => {
    const seconds = tableSlot?.seconds_left ?? 0;
    if (tableSlotStatus === "queued") {
      if (seconds <= 0) return lang === "fr" ? "bientot" : "soon";
      if (seconds < 60) return "<1 min";
      if (seconds < 3600) return `~${Math.round(seconds / 60)} min`;
      return `~${Math.floor(seconds / 3600)}h ${Math.round((seconds % 3600) / 60)}m`;
    }
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
  })();

  const renderStars = (compact = false) => (
    <div className={compact ? "na-stars compact" : "na-stars"}>
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = (ratingHover ?? matchRating ?? 0) >= star;
        return (
          <button
            key={star}
            type="button"
            className={`star-btn${filled && !ratingHover && matchRating === star ? " star-active" : ""}`}
            disabled={ratingLoading}
            onMouseEnter={() => setRatingHover(star)}
            onMouseLeave={() => setRatingHover(null)}
            onClick={() => handleRateMatch(star)}
            aria-label={`Rate ${star}`}
          >
            <svg width={compact ? 24 : 32} height={compact ? 24 : 32} viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                fill={filled ? "#ffd66d" : "rgba(255,255,255,0.14)"}
                stroke={filled ? "#ffc247" : "rgba(255,255,255,0.22)"}
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        );
      })}
    </div>
  );

  const quickInsert = (value) => {
    setText(prev => prev ? `${prev}\n${value}` : value);
    setTimeout(() => textareaRef.current?.focus(), 0);
  };

  const chatIsLight = activeTheme !== "dark";

  const redesignCss = `
    .na-chat-page-root, .na-chat-page-root * { box-sizing: border-box; }
    .na-chat-page-root {
      --na-bg: ${chatIsLight ? LH.cssVar.bg : "#050815"};
      --na-bg-2: ${chatIsLight ? LH.cssVar.bg2 : "#070b1a"};
      --na-panel: ${chatIsLight ? LH.cssVar.panel : "#0b1124"};
      --na-card: ${chatIsLight ? LH.cssVar.card : "#151c39"};
      --na-card-strong: ${chatIsLight ? LH.cssVar.cardStrong : "rgba(21,28,57,.88)"};
      --na-line: ${chatIsLight ? LH.cssVar.line : "#202944"};
      --na-text: ${chatIsLight ? LH.cssVar.text : "#f6f7ff"};
      --na-soft: ${chatIsLight ? LH.cssVar.soft : "#b7c0e5"};
      --na-muted: ${chatIsLight ? LH.cssVar.muted : "#8792bb"};
      --na-violet: ${chatIsLight ? LAVENDER_HAZE.accent : "#7c4dff"};
      --na-green: #23d586;
      --na-yellow: ${chatIsLight ? LH.cssVar.yellow : "#ffd66d"};
      --na-red: #ff4b59;
      --na-glass-panel: ${chatIsLight ? LH.cssVar.glassPanel : "rgba(30,40,70,.45)"};
      --na-glass-menu: ${chatIsLight ? LH.cssVar.glassMenu : "rgba(30,40,70,.82)"};
      --na-glass-border: ${chatIsLight ? LH.cssVar.glassBorder : "rgba(120,140,255,.22)"};
      --na-glass-shadow: ${chatIsLight ? LH.cssVar.glassShadow : "0 8px 32px rgba(0,0,0,.40), inset 0 1px 1px rgba(255,255,255,.08), inset 0 -1px 1px rgba(0,0,0,.18)"};
      --na-glass-text: ${chatIsLight ? LH.cssVar.glassText : "#f0f4ff"};
      --na-chat-surface: ${chatIsLight ? LH.cssVar.chatSurface : "radial-gradient(circle at 50% 2%, rgba(120,140,255,.12), transparent 28%), linear-gradient(180deg, #1a1a2e 0%, #15182b 100%)"};
      --na-row-hover: ${chatIsLight ? LH.cssVar.rowHover : "rgba(255,255,255,.035)"};
      --na-row-active: ${chatIsLight ? LH.cssVar.rowActive : "linear-gradient(90deg, rgba(122,76,255,.27), rgba(30,39,76,.34))"};
      --na-popover-bg: ${chatIsLight ? LH.cssVar.popoverBg : "rgba(20,27,55,.96)"};
      --na-input-bg: ${chatIsLight ? LH.cssVar.inputBg : "rgba(26,33,63,.78)"};
      --na-bubble-them: ${chatIsLight ? LH.cssVar.bubbleThem : "linear-gradient(180deg, rgba(34,43,73,.96), rgba(29,36,63,.96))"};
      --na-bubble-system: ${chatIsLight ? LH.cssVar.bubbleSystem : "linear-gradient(145deg, rgba(31,34,88,.72), rgba(18,25,54,.68))"};
      --na-table-inner: ${chatIsLight ? LH.cssVar.tableInner : "rgba(14, 20, 45, .96)"};
      --na-status-ring: ${chatIsLight ? LH.cssVar.statusRing : "#0b1227"};
      color: var(--na-text);
      font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      background: ${chatIsLight
        ? LH.pageBackground
        : "radial-gradient(circle at 73% 18%, rgba(89,64,202,.12), transparent 34%), radial-gradient(circle at 100% 0%, rgba(197,66,187,.17), transparent 30%), linear-gradient(180deg, rgba(8,12,27,.98), rgba(5,8,19,.99))"};
      transition:
        background 0.24s cubic-bezier(0.22,1,0.36,1),
        color 0.18s ease;
    }
    @media (prefers-reduced-motion: no-preference) {
      .na-chat-page-root :where(.na-rail, .na-dialogs, .na-chat, .na-rightbar, .na-chat-header, .na-composer, .na-dialog-row, .na-bubble, .na-match-card, .na-side-card, .na-popover, .na-search input, .na-compose, .na-icon, .na-attach-menu, .na-support-delete, .na-table-main:before) {
        transition:
          background 0.22s cubic-bezier(0.22,1,0.36,1),
          background-color 0.22s cubic-bezier(0.22,1,0.36,1),
          border-color 0.2s ease,
          color 0.18s ease,
          box-shadow 0.22s ease;
      }
    }
    .na-chat-page-root button, .na-chat-page-root input, .na-chat-page-root textarea { font: inherit; }
    .na-chat-page-root button { border: 0; background: none; color: inherit; cursor: pointer; }
    .na-chat-page-root * {
      scrollbar-width: thin;
      scrollbar-color: rgba(124,77,255,.48) transparent;
    }
    .na-chat-page-root *::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    .na-chat-page-root *::-webkit-scrollbar-button {
      display: none;
      width: 0;
      height: 0;
    }
    .na-chat-page-root *::-webkit-scrollbar-track {
      background: transparent;
    }
    .na-chat-page-root *::-webkit-scrollbar-thumb {
      background: rgba(124,77,255,.48);
      border-radius: 999px;
    }
    .na-chat-page-root *::-webkit-scrollbar-corner {
      background: transparent;
    }
    @keyframes naRainbowRotate {
      0% { background-position: 0% 50%; }
      100% { background-position: 200% 50%; }
    }
    @keyframes naRailGlow {
      0% { background-position: 0% 0%; }
      100% { background-position: 0% 200%; }
    }
    @keyframes naYellowPulse {
      0%, 100% { box-shadow: 0 0 0 0 rgba(254,202,87,0); background: transparent; }
      50% { box-shadow: 0 0 0 6px rgba(254,202,87,.14); background: rgba(254,202,87,.07); }
    }
    .na-workspace {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: var(--na-sidebar-width, 350px) 4px minmax(0, 1fr) 4px var(--na-right-width, 430px);
      min-width: 0;
      min-height: 0;
      overflow: hidden;
    }
    .na-workspace.na-no-right { grid-template-columns: var(--na-sidebar-width, 350px) 4px minmax(0, 1fr); }
    .na-chat { border-right: 1px solid var(--na-line); }
    .na-sidebar-resizer {
      width: 4px;
      min-width: 4px;
      cursor: col-resize;
      background: transparent;
      border-left: 1px solid var(--na-line);
      border-right: 0;
      position: relative;
      z-index: 10;
      transition: background .16s ease, border-color .16s ease;
    }
    .na-sidebar-resizer::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 1px;
      transform: translateX(-50%);
      border-radius: 999px;
      background: rgba(124,77,255,.20);
      opacity: 1;
      transition: background .16s ease, opacity .16s ease;
    }
    .na-sidebar-resizer:hover,
    .na-sidebar-resizer.resizing {
      background: transparent;
      border-color: rgba(124,77,255,.30);
    }
    .na-sidebar-resizer:hover::before,
    .na-sidebar-resizer.resizing::before {
      background: rgba(124,77,255,.34);
      opacity: 1;
    }
    .na-right-resizer {
      width: 4px;
      min-width: 4px;
      cursor: col-resize;
      background: transparent;
      border-left: 1px solid var(--na-line);
      position: relative;
      z-index: 10;
      transition: border-color .16s ease;
    }
    .na-right-resizer::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 1px;
      transform: translateX(-50%);
      border-radius: 999px;
      background: rgba(124,77,255,.18);
      transition: background .16s ease;
    }
    .na-right-resizer:hover,
    .na-right-resizer.resizing {
      border-color: rgba(124,77,255,.30);
    }
    .na-right-resizer:hover::before,
    .na-right-resizer.resizing::before {
      background: rgba(124,77,255,.34);
    }
    .na-rail {
      padding: 18px 13px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      background: var(--na-panel);
      backdrop-filter: blur(22px) saturate(145%);
      min-width: 0;
      min-height: 0;
    }
    .na-dots {
      width: 42px;
      height: 42px;
      display: grid;
      grid-template-columns: repeat(3, 5px);
      grid-auto-rows: 5px;
      gap: 6px;
      place-content: center;
      opacity: .72;
      margin-bottom: 6px;
    }
    .na-dots i { width: 5px; height: 5px; border-radius: 50%; background: var(--na-muted); }
    .na-rail-btn {
      width: 52px;
      height: 52px;
      border-radius: 15px;
      display: grid;
      place-items: center;
      color: var(--na-soft);
      transition: .18s ease;
    }
    .na-rail-btn svg { width: 25px; height: 25px; }
    .na-rail-btn.active {
      background: linear-gradient(135deg, #7c4dff, #5d40ef);
      box-shadow: 0 14px 36px rgba(103,71,255,.5), inset 0 0 0 1px rgba(255,255,255,.12);
      color: #fff;
    }
    .na-rail-btn:not(.active):hover, .na-icon:hover, .na-compose:hover { background: var(--na-row-hover); }
    .na-rail-user { margin-top: auto; }
    .na-chat-page-root .na-avatar-wrap {
      position: relative;
      flex: 0 0 auto;
      border-radius: 50%;
      display: grid;
      place-items: center;
      overflow: visible;
      color: #fff;
      font-weight: 800;
      background: linear-gradient(135deg, #f05cb4, #8655ff);
      box-shadow: inset 0 0 0 1px rgba(255,255,255,.12);
    }
    .na-chat-page-root .na-avatar-wrap > img, .na-chat-page-root .na-avatar-wrap > div {
      width: 100% !important;
      height: 100% !important;
      border-radius: 50% !important;
    }
    .na-chat-page-root .na-avatar-wrap > img { object-fit: cover; display: block; background: #fff; }
    .na-status, .na-online-dot {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: var(--na-green);
      display: inline-block;
      box-shadow: 0 0 14px rgba(35,213,134,.7);
    }
    .na-status {
      position: absolute;
      width: 12px;
      height: 12px;
      right: -1px;
      bottom: 3px;
      border: 3px solid var(--na-status-ring);
      z-index: 3;
    }
    .na-dialogs {
      background: var(--na-panel);
      backdrop-filter: blur(22px) saturate(145%);
      display: flex;
      flex-direction: column;
      padding: calc(var(--na-page-top) + 20px) 14px 0 16px;
      min-width: 0;
      min-height: 0;
    }
    .na-brand {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      padding: 0 2px 0 22px;
    }
    .na-logo {
      position: relative;
      width: 122px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: .02em;
      color: ${chatIsLight ? LH.logoColor : "#cfc7ff"};
      text-shadow: ${chatIsLight ? LH.logoShadow : "0 0 18px rgba(164,133,255,.75)"};
      font-size: 33px;
      font-family: Georgia, serif;
    }
    .na-logo .na-logo-dot { position: absolute; top: 4px; width: 18px; height: 18px; }
    .na-logo .left { left: 2px; }
    .na-logo .right { right: 2px; }
    .na-compose {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      display: grid;
      place-items: center;
      background: var(--na-card-strong);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadowSm : "0 10px 30px rgba(0,0,0,.18)"};
      color: var(--na-text);
    }
    .na-search {
      position: relative;
      height: 39px;
      margin: 0 16px 19px 8px;
      display: block;
    }
    .na-search svg {
      position: absolute;
      left: 13px;
      top: 50%;
      transform: translateY(-50%);
      width: 17px;
      height: 17px;
      color: var(--na-muted);
      pointer-events: none;
    }
    .na-search input {
      width: 100%;
      height: 100%;
      border: 1px solid var(--na-line);
      background: var(--na-input-bg);
      color: var(--na-text);
      outline: none;
      border-radius: 10px;
      padding: 0 45px 0 39px;
      font-size: 14px;
    }
    .na-kbd {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      color: var(--na-muted);
    }
    .na-scroller, .na-messages, .na-rightbar, .na-profile-scroll {
      overflow: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(124,77,255,.38) transparent;
    }
    .na-scroller {
      padding: 0 2px 0 0;
      margin-right: -4px;
      min-height: 0;
      flex: 1;
      position: relative;
      z-index: 7;
      scrollbar-gutter: auto;
      overscroll-behavior: contain;
      scrollbar-width: thin;
      scrollbar-color: rgba(124,77,255,.78) transparent;
    }
    .na-scroller::-webkit-scrollbar {
      width: 1px;
      height: 1px;
    }
    .na-scroller::-webkit-scrollbar-button {
      display: none;
      width: 0;
      height: 0;
    }
    .na-scroller::-webkit-scrollbar-track {
      background: transparent;
    }
    .na-scroller::-webkit-scrollbar-thumb {
      background: rgba(142,101,255,.86);
      border-radius: 999px;
    }
    .na-scroller::-webkit-scrollbar-corner {
      background: transparent;
    }
    .na-section-title {
      margin: 16px 8px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-transform: uppercase;
      color: var(--na-muted);
      font-size: 12px;
      font-weight: 800;
      letter-spacing: .045em;
    }
    .na-section-title .plain {
      text-transform: none;
      color: var(--na-muted);
      font-weight: 600;
      letter-spacing: 0;
      font-size: 12px;
    }
    .na-group-toggle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 10px 12px 4px;
      margin-top: 6px;
      color: var(--na-muted);
      user-select: none;
    }
    .na-group-line {
      flex: 1 1 auto;
      min-width: 8px;
      height: 1px;
      opacity: .9;
    }
    .na-group-line.left {
      background: linear-gradient(to right, transparent 0%, rgba(140,160,255,.30) 100%);
    }
    .na-group-line.right {
      background: linear-gradient(to left, transparent 0%, rgba(140,160,255,.30) 100%);
    }
    .na-group-label {
      flex: 0 1 auto;
      min-width: 0;
      max-width: 72%;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: .04em;
      text-transform: uppercase;
      white-space: nowrap;
      line-height: 1.45;
      color: ${chatIsLight ? LH.mutedColor : "rgba(160,180,255,.68)"};
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .na-group-chevron {
      flex: 0 0 auto;
      width: 12px;
      height: 12px;
      opacity: .62;
      transition: transform .22s cubic-bezier(.22,1,.36,1), opacity .16s ease;
    }
    .na-group-chevron.collapsed {
      transform: rotate(-90deg);
    }
    .na-group-toggle:hover .na-group-chevron {
      opacity: .95;
    }
    .na-dialog-row {
      width: 100%;
      min-height: 66px;
      border-radius: 16px;
      display: grid;
      grid-template-columns: 50px minmax(0, 1fr) auto;
      gap: 11px;
      align-items: center;
      padding: 8px 10px;
      text-align: left;
      border: 1px solid transparent;
      color: var(--na-text);
    }
    .na-dialog-row.active {
      background: var(--na-row-active);
      border-color: transparent;
      position: relative;
      overflow: hidden;
      box-shadow: none;
    }
    .na-dialog-row.active:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      border-radius: 16px 0 0 16px;
      background: linear-gradient(180deg, #54a0ff, #7c4dff, #40e0d0, #54a0ff);
      background-size: 100% 220%;
      animation: naRailGlow 2.8s linear infinite;
    }
    .na-dialog-row.table-rainbow-border {
      position: relative;
      overflow: hidden;
      isolation: isolate;
      background: linear-gradient(270deg, rgba(255,107,107,0.12), rgba(254,202,87,0.10), rgba(72,219,251,0.12), rgba(255,159,243,0.10), rgba(84,160,255,0.12), rgba(255,107,107,0.12));
      background-size: 200% 100%;
      background-repeat: repeat;
      animation: naRainbowRotate 8s linear infinite;
      box-shadow: inset 0 0 0 1px rgba(120,140,255,0.18), 0 0 18px rgba(84,160,255,0.08);
    }
    .na-dialog-row.table-rainbow-border:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      border-radius: 16px 0 0 16px;
      background: linear-gradient(180deg, #54a0ff, #7c4dff, #ff9ff3, #48dbfb, #54a0ff);
      background-size: 100% 260%;
      animation: naRailGlow 2.5s linear infinite;
      z-index: 1;
    }
    .na-dialog-row.table-rainbow-border.active {
      background: linear-gradient(270deg, rgba(255,107,107,0.22), rgba(254,202,87,0.18), rgba(72,219,251,0.22), rgba(255,159,243,0.18), rgba(84,160,255,0.22), rgba(255,107,107,0.22));
      background-size: 200% 100%;
      background-repeat: repeat;
      animation: naRainbowRotate 6s linear infinite;
    }
    .na-dialog-row.searching-pulse {
      animation: naYellowPulse 1.4s ease-in-out infinite;
    }
    .na-row-slot-line {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: 5px;
    }
    .na-row-slot-badge {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 2px 9px;
      border-radius: 999px;
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 0.02em;
      white-space: nowrap;
      line-height: 1.6;
    }
    .na-row-slot-badge.active {
      color: #c8eaff;
      background: linear-gradient(90deg, rgba(255,107,107,.22), rgba(84,160,255,.22));
      border: 1px solid rgba(120,140,255,.32);
    }
    .na-row-slot-badge.searching {
      color: #feca57;
      background: rgba(254,202,87,.16);
      border: 1px solid rgba(254,202,87,.42);
    }
    .na-row-slot-badge.queued {
      color: #aab4ff;
      background: rgba(120,140,255,.16);
      border: 1px solid rgba(120,140,255,.32);
    }
    .na-row-slot-badge.expired {
      color: #86efac;
      background: rgba(34,197,94,.12);
      border: 1px solid rgba(34,197,94,.30);
    }
    .na-row-slot-timer {
      display: inline-block;
      font-variant-numeric: tabular-nums;
      font-weight: 800;
      font-size: 12.5px;
      letter-spacing: 0.02em;
      color: #48dbfb;
      text-shadow: 0 0 8px rgba(72,219,251,.55);
      padding: 2px 7px;
      border-radius: 999px;
      background: rgba(20,20,40,.55);
      border: 1px solid rgba(84,160,255,.32);
      min-width: 38px;
      text-align: center;
    }
    .na-row-slot-timer.urgent {
      color: #ff6b6b;
      text-shadow: 0 0 8px rgba(255,107,107,.6);
      border-color: rgba(255,107,107,.45);
    }
    .na-row-slot-timer.searching {
      color: #feca57;
      text-shadow: 0 0 8px rgba(254,202,87,.6);
      border-color: rgba(254,202,87,.45);
    }
    .na-row-slot-timer.queued {
      color: #aab4ff;
      text-shadow: none;
      border-color: rgba(120,140,255,.32);
    }
    .na-dialog-row:hover:not(.active) { background: var(--na-row-hover); }
    .na-dialog-text { min-width: 0; display: block; }
    .na-dialog-text strong {
      display: block;
      font-size: 14px;
      font-weight: 800;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .na-dialog-text small {
      display: block;
      margin-top: 5px;
      color: var(--na-muted);
      font-size: 12.5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .na-dialog-meta {
      font-size: 12px;
      color: var(--na-muted);
      align-self: start;
      margin-top: 11px;
      text-align: right;
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 6px;
    }
    .na-dialog-meta .na-dialog-time-row {
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }
    .na-dialog-meta .na-dialog-time-text {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
    }
    .na-count {
      margin-top: 6px;
      min-width: 20px;
      height: 20px;
      border-radius: 50%;
      display: inline-grid;
      place-items: center;
      background: linear-gradient(135deg, #8f5cff, #5c3fff);
      color: #fff;
      font-size: 11px;
      font-weight: 800;
    }
    .na-empty-list { margin: 12px 10px; color: var(--na-muted); font-size: 13px; line-height: 1.5; }
    .na-chat {
      display: flex;
      flex-direction: column;
      background: var(--na-chat-surface);
      min-width: 0;
      min-height: 0;
      position: relative;
      overflow: hidden;
    }
    .na-chat-header {
      position: absolute;
      top: calc(var(--na-page-top) + 16px);
      left: 50%;
      transform: translateX(-50%);
      width: min(70%, 720px);
      max-width: calc(100% - 48px);
      min-height: 68px;
      padding: 12px 24px;
      display: flex;
      align-items: center;
      gap: 16px;
      border-radius: 60px;
      border: 1px solid var(--na-glass-border);
      background: var(--na-glass-panel);
      color: var(--na-glass-text);
      box-shadow: var(--na-glass-shadow);
      backdrop-filter: blur(20px) saturate(180%);
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      z-index: 24;
      pointer-events: auto;
    }
    .na-back-mobile { display: none; }
    .na-chat-header > button[aria-label="Open profile"] {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      flex: 0 0 auto;
    }
    .na-chat-header > button[aria-label="Open profile"] .na-avatar-wrap {
      width: 100% !important;
      height: 100% !important;
    }
    .na-title { min-width: 0; }
    .na-title h3 {
      margin: 0;
      font-size: 18px;
      line-height: 1.1;
      font-weight: 800;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .na-title p {
      margin: 6px 0 0;
      color: var(--na-soft);
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 7px;
    }
    .na-header-actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .na-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: grid;
      place-items: center;
      color: var(--na-glass-text);
      opacity: .96;
      flex: 0 0 auto;
      transition: transform .16s ease, background .18s ease, box-shadow .18s ease;
    }
    .na-icon svg { width: 21px; height: 21px; }
    .na-icon:active { transform: scale(.86); }
    .na-menu-wrap { position: relative; }
    .na-popover {
      position: absolute;
      right: 0;
      top: calc(100% + 10px);
      min-width: 170px;
      padding: 8px;
      border-radius: 14px;
      background: var(--na-popover-bg);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadowLg : "0 18px 42px rgba(0,0,0,.34)"};
      z-index: 30;
    }
    .na-popover button {
      width: 100%;
      padding: 10px 12px;
      border-radius: 10px;
      text-align: left;
      font-size: 13px;
      color: var(--na-text);
    }
    .na-popover button:hover { background: var(--na-row-hover); }
    .na-messages {
      flex: 1;
      min-height: 0;
      padding: calc(var(--na-page-top) + 122px) 34px 110px;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
    }
    .na-messages.with-ai-actions { padding-bottom: 168px; }
    .na-messages.has-table { padding-top: calc(var(--na-page-top) + 200px); }
    .na-messages.has-table.actions-open { padding-top: calc(var(--na-page-top) + 280px); }
    .na-match-card {
      margin: 20px auto 18px;
      width: min(900px, 100%);
      border-radius: 18px;
      background: var(--na-bubble-system);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadowLg2 : "0 20px 48px rgba(0,0,0,.23)"};
      position: relative;
    }
    .na-match-card { padding: 18px 22px 19px; }
    .na-match-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 11px;
      gap: 20px;
    }
    .na-match-head h4, .na-side-card h3 {
      margin: 0;
      text-transform: uppercase;
      font-size: 12.5px;
      letter-spacing: .07em;
      font-weight: 800;
    }
    .na-match-toggle { opacity: .7; font-size: 16px; }
    .na-match-body {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      column-gap: 34px;
    }
    .na-match-body p {
      max-width: 610px;
      margin: 0;
      color: var(--na-soft);
      font-size: 14px;
      line-height: 1.43;
      white-space: pre-wrap;
    }
    .na-compat {
      min-width: 164px;
      height: 38px;
      padding: 0 18px;
      border-radius: 12px;
      display: grid;
      place-items: center;
      background: rgba(124,77,255,.23);
      border: 1px solid rgba(151,123,255,.32);
      color: #d9d2ff;
      font-size: 14px;
      white-space: nowrap;
    }
    .na-date-line {
      margin: 0 auto 17px;
      color: var(--na-muted);
      font-size: 13px;
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .na-date-line:before, .na-date-line:after {
      content: "";
      width: 210px;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(91,103,150,.38));
    }
    .na-date-line:after { background: linear-gradient(90deg, rgba(91,103,150,.38), transparent); }
    .na-message-group {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 0 22px;
    }
    .na-message-group.me { align-items: flex-end; }
    .na-message-group.them { align-items: flex-start; }
    .na-message-group.system { align-items: center; }
    .na-bubble {
      max-width: min(420px, 72%);
      padding: 13px 18px;
      font-size: 14px;
      line-height: 1.48;
      box-shadow: 0 15px 36px rgba(0,0,0,.24);
      white-space: pre-wrap;
      word-break: break-word;
    }
    .na-bubble.me {
      background: linear-gradient(135deg, #6c43f5, #4e36ce);
      border: 1px solid rgba(220,211,255,.2);
      border-radius: 9px 9px 4px 9px;
      color: #fff;
    }
    .na-bubble.them {
      background: var(--na-bubble-them);
      border: 1px solid var(--na-line);
      border-radius: 9px 9px 9px 4px;
      color: var(--na-text);
    }
    .na-bubble.system {
      max-width: min(760px, 86%);
      background: var(--na-bubble-system);
      border: 1px solid var(--na-line);
      border-radius: 16px;
      color: var(--na-soft);
    }
    .na-meta {
      margin-top: 8px;
      color: var(--na-muted);
      font-size: 12px;
      line-height: 1;
    }
    .na-checks {
      color: #45b7ff;
      font-weight: 800;
      letter-spacing: -2px;
      margin-left: 4px;
    }
    .na-thinking {
      align-self: center;
      margin: 8px 0 18px;
      padding: 10px 22px;
      border-radius: 999px;
      background: var(--na-card-strong);
      border: 1px solid var(--na-line);
      color: var(--na-soft);
      font-size: 14px;
      box-shadow: ${chatIsLight ? LH.shadowMd : "0 12px 30px rgba(0,0,0,.28)"};
    }
    .na-table-card {
      margin: 0;
      width: max-content;
      max-width: min(560px, calc(100% - 24px));
      padding: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 10px;
      background: transparent;
      border: 0;
      box-shadow: none;
      position: absolute;
      top: calc(var(--na-page-top) + 104px);
      left: 50%;
      transform: translateX(-50%);
      z-index: 18;
      pointer-events: auto;
    }
    .na-table-actions { pointer-events: auto; position: relative; z-index: 2; }
    .na-pill { pointer-events: auto; position: relative; z-index: 2; }
    .na-table-main {
      min-width: 200px;
      max-width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 12px;
      padding: 10px 18px 10px 10px;
      border-radius: 16px;
      background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #ff9ff3, #54a0ff, #ff6b6b);
      background-size: 200% 100%;
      background-repeat: repeat;
      animation: naRainbowRotate 5s linear infinite;
      border: 0;
      box-shadow: 0 4px 24px rgba(84,160,255,.30);
      backdrop-filter: blur(14px) saturate(150%);
      position: relative;
      overflow: hidden;
      isolation: isolate;
      cursor: pointer;
      user-select: none;
      transition: transform .2s ease, box-shadow .2s ease;
    }
    .na-table-main:hover { transform: translateY(-1px); box-shadow: 0 6px 28px rgba(84,160,255,.42); }
    .na-table-main:active { transform: translateY(0); }
    .na-table-card.open .na-table-main { box-shadow: 0 6px 28px rgba(84,160,255,.55); }
    .na-table-main:before {
      content: "";
      position: absolute;
      inset: 2px;
      border-radius: 16px;
      background: var(--na-table-inner);
      z-index: 0;
    }
    .na-table-card.expired .na-table-main {
      background: linear-gradient(270deg, #22c55e, #86efac, #22c55e);
      background-size: 200% 100%;
      box-shadow: 0 4px 20px rgba(34,197,94,.28);
    }
    .na-table-card.expired .na-table-main:before {
      background: rgba(5,25,10,.94);
    }
    .na-table-card.queued .na-table-main {
      background: linear-gradient(270deg, #a78bfa, #818cf8, #a78bfa);
      background-size: 200% 100%;
      box-shadow: 0 4px 20px rgba(167,139,250,.28);
    }
    .na-table-card.searching .na-table-main {
      background: linear-gradient(270deg, #feca57, #ff9ff3, #feca57);
      background-size: 200% 100%;
      box-shadow: 0 4px 20px rgba(254,202,87,.26);
    }
    .na-table-card.searching .na-table-main:before {
      background: rgba(35,28,12,.94);
    }
    .na-table-number {
      min-width: 47px;
      height: 47px;
      border-radius: 14px;
      display: grid;
      place-items: center;
      background: rgba(84,160,255,.16);
      border: 1px solid rgba(84,160,255,.36);
      font-size: 26px;
      font-weight: 900;
      color: #54a0ff;
      line-height: 1;
      position: relative;
      z-index: 1;
    }
    .na-table-card.expired .na-table-number {
      display: none;
    }
    .na-table-copy strong {
      display: block;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: .08em;
      color: var(--na-yellow);
      white-space: nowrap;
    }
    .na-table-card.expired .na-table-copy strong {
      color: #22c55e;
    }
    .na-table-card.searching .na-table-copy strong {
      color: #feca57;
    }
    .na-table-copy {
      min-width: 0;
      text-align: left;
      position: relative;
      z-index: 1;
    }
    .na-table-card.expired .na-table-copy {
      text-align: center;
    }
    .na-table-copy span {
      display: block;
      margin-top: 4px;
      color: #48dbfb;
      font-size: 14px;
      font-weight: 800;
      font-variant-numeric: tabular-nums;
      text-shadow: 0 0 8px rgba(72,219,251,.45);
    }
    .na-table-copy .na-table-feedback {
      margin-top: 4px;
      color: #b7c0e5;
      font-size: 12px;
      font-weight: 600;
      text-shadow: none;
    }
    .na-table-card.searching .na-table-copy span {
      color: #feca57;
      text-shadow: 0 0 8px rgba(254,202,87,.45);
    }
    .na-table-card.queued .na-table-copy span {
      color: #aab4ff;
      text-shadow: none;
    }
    .na-table-card.expired .na-table-copy span {
      color: #86efac;
      text-shadow: 0 0 8px rgba(134,239,172,.4);
    }
    .na-table-actions { display: flex; flex-wrap: nowrap; gap: 8px; justify-content: center; align-items: center; max-width: 100%; }
    .na-pill {
      min-height: 38px;
      padding: 0 14px;
      border-radius: 12px;
      background: rgba(20,20,50,.88);
      border: 1.5px solid rgba(84,160,255,.45);
      color: #ffffff;
      font-size: 14px;
      font-weight: 800;
      white-space: nowrap;
      box-shadow: 0 2px 12px rgba(84,160,255,.18);
      backdrop-filter: blur(12px);
      flex: 0 1 auto;
    }
    .na-pill:hover { transform: translateY(-1px); }
    .na-pill:disabled { opacity: .5; cursor: not-allowed; transform: none; }
    .na-pill.danger { color: #ff7b86; border-color: rgba(255,75,89,.34); background: rgba(255,75,89,.12); box-shadow: 0 2px 12px rgba(255,75,89,.12); }
    .na-table-card.expired .na-pill { color: #feca57; border-color: rgba(254,202,87,.50); background: rgba(30,25,10,.90); box-shadow: 0 2px 12px rgba(254,202,87,.18); }
    .na-table-card.expired .na-pill.continue { color: #22c55e; border-color: rgba(34,197,94,.55); background: rgba(5,30,10,.90); box-shadow: 0 2px 12px rgba(34,197,94,.18); }
    .na-composer-area {
      position: absolute;
      left: 50%;
      bottom: 16px;
      transform: translateX(-50%);
      width: min(75%, 880px);
      max-width: 100%;
      padding: 0 12px;
      z-index: 26;
      pointer-events: none;
      box-sizing: border-box;
    }
    .na-composer {
      min-height: 64px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 14px;
      background: var(--na-glass-panel);
      border: 1px solid var(--na-glass-border);
      box-shadow: var(--na-glass-shadow);
      color: var(--na-glass-text);
      backdrop-filter: blur(20px) saturate(180%);
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      pointer-events: auto;
      isolation: isolate;
    }
    .na-composer .na-icon {
      width: 44px;
      height: 44px;
      background: rgba(99,102,241,.50);
      border: 1px solid rgba(255,255,255,.10);
      color: #fff;
      box-shadow: inset 0 1px 1px rgba(255,255,255,.08);
    }
    .na-composer .na-icon:hover {
      background: rgba(99,102,241,.62);
      box-shadow: 0 8px 22px rgba(0,0,0,.22), inset 0 1px 1px rgba(255,255,255,.10);
    }
    .na-composer textarea {
      flex: 1;
      width: 100%;
      min-height: 44px;
      max-height: 140px;
      border: 0;
      outline: 0;
      background: transparent;
      color: var(--na-glass-text);
      font-size: 15px;
      line-height: 1.45;
      resize: none;
      padding: 10px 8px;
    }
    .na-composer textarea::placeholder { color: ${chatIsLight ? LH.placeholderColor : "rgba(221,226,255,.62)"}; }
    .na-send {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: grid;
      place-items: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      box-shadow: 0 12px 28px rgba(103,71,255,.38), inset 0 1px 1px rgba(255,255,255,.14);
      flex: 0 0 auto;
      transition: transform .16s ease, filter .18s ease, box-shadow .18s ease;
    }
    .na-send:not(:disabled):hover {
      filter: brightness(1.08);
      box-shadow: 0 16px 34px rgba(103,71,255,.46), inset 0 1px 1px rgba(255,255,255,.16);
    }
    .na-send:active { transform: scale(.86); }
    .na-send:disabled, .na-composer .na-icon:disabled {
      opacity: .46;
      cursor: not-allowed;
      background: rgba(99,102,241,.42);
      box-shadow: inset 0 1px 1px rgba(255,255,255,.06);
    }
    .na-attach-menu, .na-support-delete {
      margin: 0 auto 10px;
      width: min(880px, 100%);
      border-radius: 22px;
      padding: 14px;
      background: var(--na-glass-menu);
      border: 1px solid var(--na-glass-border);
      box-shadow: var(--na-glass-shadow);
      backdrop-filter: blur(12px) saturate(170%);
      -webkit-backdrop-filter: blur(12px) saturate(170%);
      pointer-events: auto;
    }
    .na-social-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 10px;
      margin-bottom: 12px;
    }
    .na-social-btn {
      min-height: 50px;
      border-radius: 16px;
      background: var(--na-glass-panel);
      border: 1px solid var(--na-glass-border);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--na-glass-text);
      box-shadow: inset 0 1px 1px rgba(255,255,255,.06);
      backdrop-filter: blur(12px) saturate(160%);
      -webkit-backdrop-filter: blur(12px) saturate(160%);
      transition: transform .16s ease, background .16s ease, border-color .16s ease, box-shadow .16s ease;
    }
    .na-social-btn:hover {
      transform: translateY(-1px);
      background: rgba(99,102,241,.32);
      border-color: rgba(151,123,255,.42);
      box-shadow: 0 10px 24px rgba(0,0,0,.22), inset 0 0 14px rgba(124,77,255,.06);
    }
    .na-social-btn img { width: 25px; height: 25px; }
    .na-pdf-btn, .na-menu-action {
      width: 100%;
      min-height: 48px;
      border-radius: 16px;
      background: var(--na-glass-panel);
      border: 1px solid var(--na-glass-border);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      color: var(--na-glass-text);
      font-size: 14px;
      font-weight: 800;
      transition: transform .16s ease, background .16s ease, border-color .16s ease;
    }
    .na-pdf-btn:hover, .na-menu-action:hover {
      transform: translateY(-1px);
      background: rgba(99,102,241,.32);
      border-color: rgba(151,123,255,.45);
    }
    .na-pdf-btn svg {
      width: 21px;
      height: 21px;
      color: var(--na-glass-text);
      flex: 0 0 auto;
    }
    .na-ai-actions {
      margin: 0 auto 12px;
      width: min(880px, 100%);
      padding: 0;
      border-radius: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 14px;
      background: transparent;
      border: 0;
      box-shadow: none;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      pointer-events: auto;
    }
    .na-ai-actions .ai-action-btn {
      flex: 1 1 180px;
      min-width: 160px;
      max-width: 260px;
      min-height: 52px;
      padding: 0 26px;
      border-radius: 999px;
      border: none;
      background: linear-gradient(135deg, #667eea 0%, #5566d6 100%);
      color: #ffffff;
      font-weight: 800;
      font-size: 16px;
      letter-spacing: 0.2px;
      box-shadow: 0 6px 18px rgba(102,126,234,0.45), 0 2px 6px rgba(0,0,0,0.25);
      transition: transform .18s cubic-bezier(0.34,1.56,0.64,1), box-shadow .18s ease, filter .18s ease, opacity .15s ease;
      white-space: nowrap;
    }
    .na-ai-actions .ai-action-btn.match-new {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      box-shadow: 0 6px 18px rgba(16,185,129,0.45), 0 2px 6px rgba(0,0,0,0.25);
    }
    .na-ai-actions .ai-action-btn.profile-reset {
      background: linear-gradient(135deg, #ff8a4c 0%, #e8693a 100%);
      box-shadow: 0 6px 18px rgba(255,138,76,0.45), 0 2px 6px rgba(0,0,0,0.25);
    }
    .na-ai-actions .ai-action-btn:not(:disabled):hover {
      transform: translateY(-2px) scale(1.03);
      box-shadow: 0 6px 20px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.12);
      filter: brightness(1.15);
    }
    .na-ai-actions .ai-action-btn:not(:disabled):active {
      transform: translateY(1px) scale(0.96);
      filter: brightness(0.92);
    }
    .na-ai-actions .ai-action-btn:disabled {
      opacity: .6;
      cursor: not-allowed;
    }
    .na-rightbar {
      height: 100%;
      background: ${chatIsLight ? LH.rightbarBg : "linear-gradient(180deg, rgba(11,15,34,.78), rgba(8,12,28,.9))"};
      backdrop-filter: blur(22px) saturate(145%);
      min-width: 0;
      min-height: 0;
      padding: 0;
      border-left: 1px solid var(--na-line);
      position: relative;
      overflow: hidden;
      isolation: isolate;
    }
    .na-rightbar-scroll {
      position: absolute;
      inset: 0;
      overflow-y: auto;
      overflow-x: hidden;
      z-index: 1;
      padding: var(--na-page-top) 21px 22px;
      scrollbar-width: thin;
      scrollbar-color: rgba(124,77,255,.5) transparent;
    }
    .na-rightbar-scroll::-webkit-scrollbar {
      width: 6px;
    }
    .na-rightbar-scroll::-webkit-scrollbar-track {
      background: transparent;
    }
    .na-rightbar-scroll::-webkit-scrollbar-thumb {
      background: rgba(124,77,255,.45);
      border-radius: 4px;
    }
    .na-rightbar-scroll::-webkit-scrollbar-thumb:hover {
      background: rgba(124,77,255,.7);
    }
    .na-rightbar-orbs {
      position: absolute;
      inset: 0;
      pointer-events: none;
      overflow: hidden;
      z-index: 0;
    }
    .na-rightbar-orbs .na-orb {
      position: absolute;
      width: 280px;
      height: 280px;
      border-radius: 50%;
      filter: blur(70px);
      opacity: .55;
      left: 30%;
      top: 0%;
      margin-left: -140px;
      margin-top: -140px;
      will-change: top, left, transform;
    }
    .na-rightbar-orbs .na-orb.o1 {
      background: radial-gradient(circle, rgba(236,92,184,.75), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
    }
    .na-rightbar-orbs .na-orb.o2 {
      background: radial-gradient(circle, rgba(124,77,255,.70), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
      animation-delay: -3.66s;
    }
    .na-rightbar-orbs .na-orb.o3 {
      background: radial-gradient(circle, rgba(72,219,251,.55), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
      animation-delay: -7.33s;
    }
    .na-rightbar-orbs .na-orb.o4 {
      background: radial-gradient(circle, rgba(254,202,87,.48), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
      animation-delay: -11s;
    }
    .na-rightbar-orbs .na-orb.o5 {
      background: radial-gradient(circle, rgba(255,107,107,.55), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
      animation-delay: -14.66s;
    }
    .na-rightbar-orbs .na-orb.o6 {
      background: radial-gradient(circle, rgba(145,80,255,.62), transparent 70%);
      animation: naOrbOrbit 22s linear infinite;
      animation-delay: -18.33s;
    }
    .na-rightbar > section,
    .na-rightbar > .na-side-card,
    .na-rightbar > .na-profile-scroll,
    .na-rightbar > .na-rightbar-back {
      position: relative;
      z-index: 1;
    }
    @keyframes naOrbOrbit {
      0%    { top: -8%;  left: 30%; }
      16.6% { top: 12%;  left: 80%; }
      33.3% { top: 42%;  left: 95%; }
      50%   { top: 78%;  left: 70%; }
      66.6% { top: 95%;  left: 25%; }
      83.3% { top: 55%;  left: -10%; }
      100%  { top: -8%;  left: 30%; }
    }
    .na-rightbar-layer {
      min-width: 0;
      min-height: 0;
      overflow: hidden;
    }
    .na-rightbar-layer .na-rightbar {
      display: block;
    }
    .na-rightbar-back {
      position: absolute;
      left: 20px;
      top: 28px;
      width: 38px;
      height: 38px;
      border-radius: 14px;
      display: grid;
      place-items: center;
      color: var(--na-text);
      background: var(--na-card);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadowMd : "0 12px 30px rgba(0,0,0,.20)"};
      transition: transform .16s ease, background .16s ease, border-color .16s ease;
      z-index: 2;
    }
    .na-rightbar-back:hover {
      transform: translateX(-1px);
      background: rgba(124,77,255,.18);
      border-color: rgba(171,148,255,.35);
    }
    .na-rightbar-back svg {
      width: 19px;
      height: 19px;
    }
    .na-profile-hero {
      min-height: 284px;
      margin: 0 -21px;
      padding: 35px 32px 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      position: relative;
      background: transparent;
    }
    .na-profile-state {
      position: absolute;
      right: 46px;
      top: 35px;
      display: flex;
      align-items: center;
      gap: 7px;
      color: var(--na-soft);
      font-size: 12.5px;
    }
    .na-chat-page-root .na-profile-menu {
      position: absolute;
      right: 20px;
      top: 28px;
      width: 26px;
      height: 34px;
      color: var(--na-soft);
      font-size: 24px;
      display: grid;
      place-items: center;
    }
    .na-profile-avatar {
      margin-top: 2px;
      width: 116px;
      height: 116px;
      border-radius: 50%;
      padding: 4px;
      border: 1px solid rgba(216,224,255,.72);
      box-shadow: ${chatIsLight ? LH.shadowXl : "0 22px 48px rgba(0,0,0,.28)"};
      background: rgba(255,255,255,.24);
    }
    .na-profile-avatar .na-avatar-wrap { width: 100% !important; height: 100% !important; }
    .na-profile-hero h2 { margin: 15px 0 5px; font-size: 19px; line-height: 1.1; }
    .na-profile-hero p { margin: 0; color: var(--na-muted); font-size: 14px; }
    .na-role {
      margin-top: 10px;
      min-width: 61px;
      height: 27px;
      padding: 0 13px;
      display: inline-grid;
      place-items: center;
      border-radius: 999px;
      background: linear-gradient(135deg, #8b5cf6, #5a3cf0);
      color: #fff;
      font-size: 12px;
      font-weight: 800;
    }
    .na-side-card {
      margin-top: 20px;
      border-radius: 14px;
      background: var(--na-card);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadowXl2 : "0 16px 45px rgba(0,0,0,.18)"};
      padding: 22px 21px;
    }
    .na-side-card h3 { margin-bottom: 22px; color: var(--na-text); }
    .na-side-card.match h3 { color: var(--na-yellow); margin-bottom: 18px; }
    .na-summary {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 18px;
    }
    .na-ring {
      width: 118px;
      height: 118px;
      border-radius: 50%;
      display: grid;
      place-items: center;
      position: relative;
      isolation: isolate;
      box-shadow:
        0 0 0 1px rgba(196,181,253,.16),
        0 20px 42px rgba(96,75,255,.22),
        inset 0 0 22px rgba(255,255,255,.05);
    }
    .na-ring:before {
      content: "";
      position: absolute;
      inset: 4px;
      border-radius: 50%;
      background:
        radial-gradient(circle at 36% 28%, rgba(255,255,255,.13), transparent 30%),
        ${chatIsLight ? LH.popoverInnerBg : "linear-gradient(145deg, rgba(19,25,58,.98), rgba(11,16,38,.98))"};
      box-shadow: ${chatIsLight ? LH.popoverInnerShadow : "inset 0 0 24px rgba(0,0,0,.34)"};
      z-index: 1;
    }
    .na-ring:after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(255,255,255,.12), transparent 30%, rgba(255,255,255,.04));
      opacity: .32;
      z-index: 0;
    }
    .na-ring-text {
      position: relative;
      z-index: 3;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    .na-ring-text strong { font-size: 25px; letter-spacing: .01em; }
    .na-ring-text span { margin-top: 6px; color: var(--na-muted); font-size: 11px; }
    .na-summary-reason {
      margin: 0;
      color: var(--na-soft);
      font-size: 13px;
      line-height: 1.55;
      width: 100%;
      max-height: none;
      overflow: visible;
      padding: 2px 4px 0;
      text-align: left;
    }
    .na-rate-card {
      text-align: center;
    }
    .na-rate-card h3 {
      text-align: left;
    }
    .na-rate-card .na-stars {
      justify-content: center;
    }
    .na-rate-status {
      margin-top: 10px;
      min-height: 18px;
      color: var(--na-muted);
      font-size: 12px;
      font-weight: 700;
    }
    .na-tags { display: flex; flex-wrap: wrap; gap: 10px 9px; }
    .na-tag {
      min-height: 31px;
      padding: 7px 13px;
      border-radius: 11px;
      background: rgba(124,77,255,.14);
      border: 1px solid rgba(134,105,255,.28);
      color: var(--na-soft);
      font-size: 13px;
      display: inline-flex;
      align-items: center;
    }
    .na-quick { padding: 0; overflow: hidden; }
    .na-quick-head {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 21px;
    }
    .na-quick-head h3 { margin: 0; color: var(--na-text); }
    .na-quick-row {
      min-height: 53px;
      display: grid;
      grid-template-columns: 24px 1fr 18px;
      gap: 16px;
      align-items: center;
      padding: 0 21px;
      border-top: 1px solid rgba(126,138,187,.16);
      color: var(--na-text);
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      width: 100%;
    }
    .na-quick-row svg { width: 21px; height: 21px; color: var(--na-soft); }
    .na-quick-row .chev { font-size: 26px; color: var(--na-muted); font-weight: 300; }
    .na-quick-row.danger, .na-quick-row.danger svg, .na-quick-row.danger .chev { color: var(--na-red); }
    .na-drawer-actions {
      padding: 10px 16px 16px;
      display: grid;
      gap: 8px;
      border-top: 1px solid rgba(126,138,187,.16);
      background: ${chatIsLight ? LH.composerBg : "rgba(7,11,25,.28)"};
    }
    .na-drawer-actions button {
      min-height: 40px;
      border-radius: 12px;
      background: rgba(124,77,255,.16);
      color: var(--na-glass-text);
      font-weight: 800;
    }
    .na-drawer-actions button.danger {
      background: rgba(255,75,89,.12);
      color: var(--na-red);
    }
    .na-empty-chat {
      flex: 1;
      display: grid;
      place-items: center;
      min-height: 0;
      color: var(--na-muted);
      text-align: center;
      padding: 40px;
    }
    .na-empty-chat h2 { margin: 16px 0 8px; color: var(--na-text); font-size: 22px; }
    .na-modal-backdrop, .na-profile-modal, .na-avatar-full {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,.58);
      backdrop-filter: blur(14px);
      padding: 20px;
    }
    .na-modal-card, .na-profile-card {
      width: min(420px, 100%);
      border-radius: 20px;
      background: var(--na-popover-bg);
      border: 1px solid var(--na-line);
      box-shadow: ${chatIsLight ? LH.shadow2xl : "0 30px 80px rgba(0,0,0,.45)"};
      padding: 24px;
      color: var(--na-text);
    }
    .na-modal-card h3, .na-profile-card h3 { margin: 0 0 16px; font-size: 17px; }
    .na-modal-card input {
      width: 100%;
      height: 44px;
      border-radius: 13px;
      border: 1px solid rgba(126,138,187,.24);
      background: var(--na-input-bg);
      color: var(--na-text);
      outline: 0;
      padding: 0 14px;
    }
    .na-modal-actions { display: flex; gap: 10px; margin-top: 16px; }
    .na-modal-actions button {
      flex: 1;
      height: 42px;
      border-radius: 12px;
      background: rgba(124,77,255,.18);
      font-weight: 800;
    }
    .na-modal-actions button.primary { background: linear-gradient(135deg, #8355ff, #5a3bed); }
    .na-profile-card {
      width: min(460px, 96vw);
      max-height: min(760px, calc(100dvh - 32px));
      padding: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .na-profile-card-head {
      padding: 22px;
      display: flex;
      align-items: center;
      gap: 14px;
      border-bottom: 1px solid rgba(126,138,187,.16);
    }
    .na-profile-scroll { padding: 20px 22px 24px; min-height: 0; }
    .na-close {
      position: absolute;
      right: 12px;
      top: 12px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: rgba(255,255,255,.1) !important;
      z-index: 2;
    }
    .na-stars { display: flex; gap: 5px; align-items: center; }
    .na-stars.compact { justify-content: center; }
    .na-stars button { padding: 0; line-height: 0; }
    .na-profile-section { margin-top: 18px; }
    .na-profile-section h4 {
      margin: 0 0 10px;
      text-transform: uppercase;
      letter-spacing: .06em;
      font-size: 11px;
      color: var(--na-muted);
    }
    .na-avatar-full {
      z-index: 10000;
      cursor: zoom-out;
      background: rgba(0,0,0,.88);
    }
    .na-avatar-full .na-avatar-wrap {
      width: min(86vw, 86vh) !important;
      height: min(86vw, 86vh) !important;
    }
    .na-bottom-nav { display: none; }
    @media (max-width: 1450px) {
      .na-workspace { grid-template-columns: var(--na-sidebar-width, 320px) 4px minmax(0, 1fr); }
      .na-workspace.na-no-right { grid-template-columns: var(--na-sidebar-width, 320px) 4px minmax(0, 1fr); }
      .na-rightbar-scroll { padding-left: 18px; padding-right: 18px; }
      .na-profile-hero { margin-left: -18px; margin-right: -18px; }
      .na-summary { gap: 16px; }
      .na-ring { width: 108px; height: 108px; }
      .na-ring:after { inset: 0; width: auto; height: auto; }
    }
    @media (max-width: 1180px) {
      .na-workspace, .na-workspace.na-no-right { grid-template-columns: var(--na-sidebar-width, 320px) 4px minmax(0, 1fr); }
      .na-match-body { grid-template-columns: 1fr; row-gap: 14px; }
      .na-compat { width: max-content; }
    }
    @media (max-width: 760px) {
      .na-chat-page-root {
        width: 100%;
        max-width: 100%;
        overflow-x: hidden;
      }
      .na-workspace, .na-workspace.na-no-right {
        display: block;
        width: 100%;
        max-width: 100%;
        height: 100%;
        overflow-x: hidden;
      }
      .na-rail, .na-sidebar-resizer, .na-right-resizer { display: none; }
      .na-workspace.na-has-chat .na-dialogs { display: none; }
      .na-workspace.na-has-chat.na-has-right-panel .na-chat { display: none; }
      .na-workspace:not(.na-has-chat) .na-chat { display: none; }
      .na-workspace:not(.na-has-right-panel) .na-rightbar-layer { display: none; }
      .na-dialogs, .na-chat, .na-rightbar-layer {
        width: 100%;
        max-width: 100%;
        height: 100%;
        overflow-x: hidden;
      }
      .na-dialogs { border-right: 0; }
      .na-chat { border-right: 0; }
      .na-chat-header {
        top: calc(var(--na-page-top) + 8px);
        width: calc(100% - 24px);
        max-width: calc(100% - 24px);
        min-height: 58px;
        padding: 8px 14px;
        gap: 10px;
        border-radius: 999px;
      }
      .na-back-mobile { display: grid; place-items: center; width: 35px; height: 35px; border-radius: 12px; }
      .na-header-actions { gap: 4px; }
      .na-icon { width: 32px; height: 32px; }
      .na-chat-header > button[aria-label="Open profile"] {
        width: 38px;
        height: 38px;
      }
      .na-title h3 { font-size: 14px; }
      .na-title p { margin-top: 3px; font-size: 12px; }
      .na-messages { padding: calc(var(--na-page-top) + 94px) 12px 130px; }
      .na-messages.with-ai-actions { padding-bottom: 240px; }
      .na-messages.has-table { padding-top: calc(var(--na-page-top) + 200px); }
      .na-messages.has-table.actions-open { padding-top: calc(var(--na-page-top) + 270px); }
      .na-ai-actions {
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: center;
        gap: 10px;
        width: calc(100% - 20px);
        max-width: calc(100% - 20px);
        margin: 0 auto 12px;
      }
      .na-ai-actions .ai-action-btn {
        flex: 1 1 calc(50% - 5px);
        max-width: calc(50% - 5px);
        min-width: 0;
        min-height: 50px;
        font-size: 15px;
        padding: 0 18px;
      }
      .na-ai-actions .ai-action-btn.profile-reset {
        flex: 1 1 100%;
        max-width: 100%;
      }
      .na-match-card { margin: 14px auto 14px; padding: 14px; border-radius: 16px; }
      .na-match-body p { font-size: 12.5px; }
      .na-date-line:before, .na-date-line:after { width: 58px; }
      .na-bubble { max-width: 84%; font-size: 13px; }
      .na-composer-area {
        bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 10px);
        max-width: calc(100% - 10px);
        padding: 0 4px;
      }
      .na-composer { min-height: 56px; border-radius: 22px; gap: 8px; padding: 8px 10px; }
      .na-composer .na-icon { width: 36px; height: 36px; }
      .na-composer textarea { font-size: 13px; }
      .na-send { width: 36px; height: 36px; }
      .na-social-grid { grid-template-columns: repeat(4, 1fr); }
      .na-table-card { flex-direction: column; align-items: center; width: min(calc(100% - 24px), 330px); top: calc(var(--na-page-top) + 80px); }
      .na-table-main { width: 100%; padding: 10px 16px; }
      .na-table-actions { justify-content: center; }
      .na-rightbar {
        width: 100%;
        max-width: 100%;
        height: 100%;
        border-left: 0;
        overflow-x: hidden;
      }
      .na-rightbar-scroll {
        padding-left: 16px;
        padding-right: 16px;
      }
      .na-profile-hero {
        margin-left: -16px;
        margin-right: -16px;
        padding-left: 22px;
        padding-right: 22px;
      }
      .na-rightbar-back { left: 14px; top: 24px; }
      .na-bottom-nav {
        display: none;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 74px;
        grid-template-columns: repeat(5, 1fr);
        padding: 8px 18px 18px;
        background: rgba(10,15,33,.92);
        border-top: 1px solid var(--na-line);
        backdrop-filter: blur(22px) saturate(145%);
        z-index: 20;
      }
      .na-bottom-nav button { display: grid; place-items: center; color: var(--na-soft); border-radius: 16px; }
      .na-bottom-nav .active { background: linear-gradient(135deg, #7c4dff, #5b3df0); color: #fff; }
      .na-bottom-nav svg { width: 23px; height: 23px; }
    }
  `;

  if (typeof window !== "undefined") {
    return (
      <div
        className="na-chat-page-root"
        style={{
          "--na-page-top": isMobile ? `${50 / Math.max(textScale || 1, 0.01)}px` : "70px",
          "--na-sidebar-width": `${redesignSidebarWidth}px`,
          "--na-right-width": `${redesignRightWidth}px`,
          position: "fixed",
          top: 0,
          left: 0,
          right: isMobile ? "auto" : 0,
          bottom: 0,
          width: isMobile ? `${100 / Math.max(textScale || 1, 0.01)}vw` : undefined,
          maxWidth: isMobile ? `${100 / Math.max(textScale || 1, 0.01)}vw` : undefined,
          overflow: "hidden",
          overflowX: "hidden",
          zoom: isMobile ? textScale : 1,
        }}
      >
        <style>{redesignCss}</style>

        {showPdfModal && (
          <PdfToTextModal
            onClose={() => setShowPdfModal(false)}
            onApply={(cleanText) => {
              setText((prev) => prev + (prev && !prev.endsWith("\n") ? "\n\n" : " ") + cleanText);
              setShowPdfModal(false);
              textareaRef.current?.focus();
            }}
          />
        )}

        <main
          className={`na-workspace${selectedUser ? " na-has-chat" : ""}${redesignRightOpen ? " na-has-right-panel" : ""}${selectedUser && !redesignRightVisible ? " na-no-right" : ""}`}
          style={redesignGridColumns ? { gridTemplateColumns: redesignGridColumns } : undefined}
        >
          {/* Left rail menu disabled by request.
          <aside className="na-rail">
            <div className="na-dots" aria-hidden="true">
              <i /><i /><i /><i /><i /><i />
            </div>
            <button type="button" className="na-rail-btn active" aria-label="Chats">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" /></svg>
            </button>
            <button type="button" className="na-rail-btn" aria-label="People">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
            </button>
            <button type="button" className="na-rail-btn" aria-label="Calendar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
            </button>
            <button type="button" className="na-rail-btn" aria-label="Analytics">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18" /><path d="M18 17V9M13 17V5M8 17v-3" /></svg>
            </button>
            <button type="button" className="na-rail-btn" aria-label="Settings">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.38 1.03V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1.03-.38H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-.6 1.65 1.65 0 0 0 .38-1.03V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06A2 2 0 1 1 19.73 7l-.06.06A1.65 1.65 0 0 0 19.4 9c.22.33.6.57 1 .6.33.03.6.03.6.03a2 2 0 1 1 0 4h-.09A1.65 1.65 0 0 0 19.4 15z" /></svg>
            </button>
            <div className="na-rail-user">
              {renderAvatar({ id: currentUsername || "me", username: currentUsername || "NA", localOnly: true }, 42, "", true)}
            </div>
          </aside>
          */}

          <aside className="na-dialogs">
            <label className="na-search">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={translations[lang]?.searchDialogs || "Search dialogs..."}
              />
              <span className="na-kbd">Ctrl K</span>
            </label>

            <div className="na-scroller">
              <div className="na-section-title">{translations[lang]?.yourDialogs || "Your dialogs"}</div>
              {renderDialogRow(
                { id: "support", username: "Support Chat", type: "support" },
                lang === "fr" ? "Obtenez l'aide de notre equipe" : "Get help from our team",
                selectedUser?.id === "support",
                () => handleSelectUser({ id: "support", username: "Support", type: "support" })
              )}
              {renderDialogRow(
                { id: "ai", username: "AI Assistant", type: "ai" },
                lang === "fr" ? "Discutez avec l'IA" : "Chat with AI for assistance",
                selectedUser?.id === "ai",
                () => handleSelectUser({ id: "ai", username: "AI Assistant", type: "ai" })
              )}

              <div className="na-section-title">
                <span>{lang === "fr" ? "Vos conversations" : "Your conversations"}</span>
                <span className="plain">Recent</span>
              </div>

              {dialogSections.length === 0 ? (
                <div className="na-empty-list">
                  {lang === "fr" ? "Aucune conversation pour le moment." : "No conversations yet."}
                </div>
              ) : dialogSections.map((section) => {
                const isCollapsed = !!collapsedGroups[section.key];
                return (
                  <div key={section.key}>
                    {(dialogSections.length > 1 || section.event_id) && (
                      <button type="button" className="na-group-toggle" onClick={() => toggleGroup(section.key)}>
                        <span className="na-group-line left" />
                        <span className="na-group-label" title={section.title}>{section.title}</span>
                        <span className="na-group-line right" />
                        <svg className={`na-group-chevron${isCollapsed ? " collapsed" : ""}`} viewBox="0 0 12 12" fill="none" aria-hidden="true">
                          <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    )}
                    {!isCollapsed && section.users.map((user) => {
                      const unread = user.unread_count || user.unread || 0;
                      return renderDialogRow(
                        { ...user, type: "user" },
                        getDialogPreview(user),
                        selectedUser?.id === user.id,
                        () => handleSelectUser({ ...user, type: "user" }),
                        <>
                          {getDialogTime(user)}
                          {unread ? <><br /><span className="na-count">{unread}</span></> : null}
                        </>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </aside>

          <div
            className={`na-sidebar-resizer${isRedesignResizing ? " resizing" : ""}`}
            onMouseDown={handleRedesignResizeStart}
            role="separator"
            aria-orientation="vertical"
            aria-label={lang === "fr" ? "Redimensionner le panneau des dialogues" : "Resize dialogs panel"}
          />

          <section className="na-chat">
            {selectedUser ? (
              <>
                <header className="na-chat-header">
                  <button type="button" className="na-back-mobile" aria-label="Back" onClick={handleBackToList}>
                    <IconBack size={22} color="#eef2ff" />
                  </button>
                  <button
                    type="button"
                    onClick={() => { if (selectedUser.type === "user") openUserProfile(); }}
                    aria-label="Open profile"
                    style={{ padding: 0, lineHeight: 0 }}
                  >
                    {renderAvatar(selectedUser, 54, "", false)}
                  </button>
                  <div className="na-title" onClick={() => { if (selectedUser.type === "user") openUserProfile(); }}>
                    <h3>{selectedName}</h3>
                    {selectedShowsOnline && <p><span className="na-online-dot" />Online</p>}
                  </div>
                  <div className="na-header-actions">
                    <div ref={menuRef} className="na-menu-wrap">
                      <button
                        type="button"
                        className="na-icon"
                        aria-label="More"
                        onClick={() => {
                          setShowMenu(false);
                          setShowRightPanel(v => !v);
                        }}
                      >
                        <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="19" cy="12" r="2" /></svg>
                      </button>
                    </div>
                  </div>
                </header>

                {tableSlot && (
                  <article className={`na-table-card ${tableSlotStatus || ""}${slotActionsOpen ? " open" : ""}`}>
                    <div
                      className="na-table-main"
                      onClick={() => setSlotActionsOpen(v => !v)}
                      role="button"
                      tabIndex={0}
                    >
                      <div className="na-table-number">{tableSlot.table_number || "-"}</div>
                      <div className="na-table-copy">
                        <strong>
                          {tableSlotStatus === "expired" && tableSlot.table_number
                            ? `${slotLabel} - Table ${tableSlot.table_number}`
                            : slotLabel}
                        </strong>
                        <span>
                          {tableSlotStatus === "expired"
                            ? (lang === "fr" ? "Vous pouvez demander un redemarrage" : "You can ask to restart")
                            : `${slotTime}${tableSlotStatus !== "queued" ? ` ${lang === "fr" ? "restant" : "left"}` : ""}`}
                        </span>
                        {slotActionFeedback && <span className="na-table-feedback">{slotActionFeedback.ok ? "OK" : "Error"}: {slotActionFeedback.msg}</span>}
                      </div>
                    </div>
                    {slotActionsOpen && (
                      <div className="na-table-actions">
                        {tableSlotStatus !== "queued" && tableSlotStatus !== "expired" && (
                          <>
                            <button type="button" className="na-pill" disabled={!!slotActionLoading} onClick={() => handleSlotAction("extend5")}>+5 min</button>
                            <button type="button" className="na-pill" disabled={!!slotActionLoading} onClick={() => handleSlotAction("extend10")}>+10 min</button>
                          </>
                        )}
                        {tableSlotStatus === "expired" && (tableSlot.expired_ago ?? 999) < 120 && (
                          <button type="button" className="na-pill continue" disabled={!!slotActionLoading} onClick={() => handleSlotAction("restart")}>
                            {lang === "fr" ? "Continuer" : "Continue"}
                          </button>
                        )}
                        <button type="button" className="na-pill" disabled={!!slotActionLoading} onClick={() => handleSlotAction("restart")}>
                          {lang === "fr" ? "Redemarrer" : "Restart"}
                        </button>
                        {tableSlotStatus !== "expired" && (
                          <button type="button" className="na-pill danger" disabled={!!slotActionLoading} onClick={() => handleSlotAction("cancel")}>
                            {lang === "fr" ? "Annuler" : "Cancel"}
                          </button>
                        )}
                      </div>
                    )}
                  </article>
                )}

                <div className={`na-messages${tableSlot ? " has-table" : ""}${tableSlot && slotActionsOpen ? " actions-open" : ""}${selectedUser.type === "ai" && showAiButtons ? " with-ai-actions" : ""}`}>
                  {selectedUser.type === "user" && matchReasonText && (
                    <article className="na-match-card">
                      <div className="na-match-head">
                        <h4><span style={{ color: "var(--na-yellow)" }}>*</span> {matchReasonLabel}</h4>
                        <button type="button" className="na-match-toggle" onClick={() => setMatchReasonCollapsed(v => !v)}>
                          {matchReasonCollapsed ? ">" : "v"}
                        </button>
                      </div>
                      {!matchReasonCollapsed && (
                        <div className="na-match-body">
                          <p>{matchReasonText}</p>
                          <div className="na-compat">{matchReasonCompat}: {profileScore}%</div>
                        </div>
                      )}
                    </article>
                  )}

                  {conversationDateLine && <div className="na-date-line">{formatMessageTime(conversationDateLine)}</div>}

                  {selectedUser.type === "ai" ? (
                    aiDisplayMessages.map((msg, idx) => {
                      const isAi = msg.sender_id === 0;
                      const isEditing = editingMsgId === msg.id;
                      const bIdx = msg.branch_index ?? 0;
                      const bCount = msg.branch_count ?? 1;
                      return (
                        <div key={msg.id || idx} className={`na-message-group ${isAi ? "them" : "me"}`}>
                          {isEditing ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: 6, width: "100%", maxWidth: 520 }}>
                              <textarea
                                value={editingText}
                                onChange={(e) => setEditingText(e.target.value)}
                                rows={3}
                                autoFocus
                                style={{ width: "100%", borderRadius: 12, padding: "10px 12px", border: "1px solid rgba(0,0,0,0.15)", fontSize: 14, resize: "vertical", fontFamily: "inherit" }}
                              />
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button type="button" onClick={() => submitEditAiMessage(msg)} disabled={aiLoading} style={AI_EDIT_SAVE_STYLE}>
                                  {lang === "fr" ? "Enregistrer" : "Save"}
                                </button>
                                <button type="button" onClick={cancelEditAiMessage} style={AI_EDIT_CANCEL_STYLE}>
                                  {lang === "fr" ? "Annuler" : "Cancel"}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className={`na-bubble ${isAi ? "them" : "me"}`}>{msg.content}</div>
                          )}
                          <div className="na-meta" style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            {bCount > 1 && (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: 2, marginRight: 4 }}>
                                <button type="button" onClick={() => switchAiBranch(msg, -1)} disabled={aiLoading || bIdx <= 0} style={AI_BRANCH_BTN_STYLE}>‹</button>
                                <span style={{ fontSize: 11 }}>{bIdx + 1}/{bCount}</span>
                                <button type="button" onClick={() => switchAiBranch(msg, 1)} disabled={aiLoading || bIdx >= bCount - 1} style={AI_BRANCH_BTN_STYLE}>›</button>
                              </span>
                            )}
                            {formatMessageTime(msg.timestamp)}
                            {!isAi && msg.can_edit && !isEditing && (
                              <button type="button" onClick={() => startEditAiMessage(msg)} title={lang === "fr" ? "Modifier" : "Edit"} style={AI_EDIT_BTN_STYLE}>✎</button>
                            )}
                            {!isAi && <span className="na-checks">✓✓</span>}
                          </div>
                        </div>
                      );
                    })
                  ) : selectedUser.type === "support" ? (
                    messages.map((msg, idx) => {
                      const kind = msg.sender_kind || "user";
                      if (kind === "system") {
                        return (
                          <div key={msg.id || idx} className="na-message-group system">
                            <div className="na-bubble system">{msg.content}</div>
                            <div className="na-meta">{formatMessageTime(msg.timestamp)}</div>
                          </div>
                        );
                      }
                      const isIncoming = kind === "support";
                      return (
                        <div key={msg.id || idx} className={`na-message-group ${isIncoming ? "them" : "me"}`}>
                          <div className={`na-bubble ${isIncoming ? "them" : "me"}`}>{msg.content}</div>
                          <div className="na-meta">
                            {isIncoming && <span style={{ marginRight: 6, opacity: 0.7 }}>{msg.sender_name || "Support"}</span>}
                            {formatMessageTime(msg.timestamp)}
                            {!isIncoming && <span className="na-checks">{msg._optimistic ? "…" : "✓✓"}</span>}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    visibleMessages.map((msg, idx) => {
                      const isIncoming = msg.sender_id === selectedUser.id;
                      const isSystemMessage = msg.sender_id === 0;
                      if (isSystemMessage) {
                        return (
                          <div key={msg.id || idx} className="na-message-group system">
                            <div className="na-bubble system">
                              {msg.is_match_reason ? ((lang === "fr" ? msg.content_fr : msg.content_en) || msg.content) : msg.content}
                            </div>
                            <div className="na-meta">{formatMessageTime(msg.timestamp)}</div>
                          </div>
                        );
                      }
                      return (
                        <div key={msg.id || idx} className={`na-message-group ${isIncoming ? "them" : "me"}`}>
                          <div className={`na-bubble ${isIncoming ? "them" : "me"}`}>{msg.content}</div>
                          <div className="na-meta">{formatMessageTime(msg.timestamp)}{!isIncoming && <span className="na-checks">✓✓</span>}</div>
                        </div>
                      );
                    })
                  )}

                  {aiLoading && (
                    <div className="na-thinking">
                      Thinking<span style={{ marginLeft: 6 }}><span className="typing-dot">.</span><span className="typing-dot">.</span><span className="typing-dot">.</span></span>
                    </div>
                  )}
                  <div ref={messagesEndRef} />
                </div>

                <div className="na-composer-area" ref={attachmentMenuRef}>
                  {selectedUser?.type === "support" && (
                    <div className="na-support-delete">
                      {!showDeleteConfirm ? (
                        <button type="button" className="na-menu-action" onClick={() => setShowDeleteConfirm(true)}>
                          {lang === "fr" ? "Supprimer mes donnees" : "Delete my data"}
                        </button>
                      ) : (
                        <div className="na-ai-actions" style={{ margin: 0, padding: 0, boxShadow: "none", border: 0, background: "transparent" }}>
                          <button type="button" onClick={handleDeleteAccount}>{lang === "fr" ? "Oui, supprimer" : "Yes, delete"}</button>
                          <button type="button" onClick={() => setShowDeleteConfirm(false)}>{lang === "fr" ? "Annuler" : "Cancel"}</button>
                        </div>
                      )}
                    </div>
                  )}

                  {showAttachmentMenu && (
                    <div className="na-attach-menu" onClick={(e) => e.stopPropagation()}>
                      {showSocialOptions && (
                        <div className="na-social-grid">
                          {SOCIAL_BUTTONS_CONFIG.map(({ network, icon, placeholder, labelFr }) => (
                            <button
                              key={network}
                              type="button"
                              className="na-social-btn"
                              title={labelFr && lang === "fr" ? labelFr : network}
                              onClick={() => {
                                setSocialLinkModal({ network, label: labelFr && lang === "fr" ? labelFr : network, placeholder });
                                setSocialLinkValue(savedSocialLinks[network] || "");
                              }}
                            >
                              <img src={icon} alt={network} />
                            </button>
                          ))}
                        </div>
                      )}
                      <button
                        type="button"
                        className="na-pdf-btn"
                        onClick={() => {
                          setShowPdfModal(true);
                          setShowAttachmentMenu(false);
                          setShowSocialOptions(false);
                        }}
                      >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <path d="M14 2v6h6" />
                          <path d="M9 15h6" />
                          <path d="M9 18h4" />
                        </svg>
                        <span>{lang === "fr" ? "Upload PDF" : "Upload PDF"}</span>
                      </button>
                    </div>
                  )}

                  {selectedUser.type === "ai" && showAiButtons && (
                    <AiActionButtons
                      lang={lang}
                      onStartMatch={startMatch}
                      onFindAnother={findAnotherMatch}
                      startDisabled={startMatchingDisabled}
                      loading={aiLoading}
                      matchingDone={matchingDone}
                      variant="compact"
                    />
                  )}

                  <form className="na-composer" onSubmit={sendMessage}>
                    <button
                      type="button"
                      className="na-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        const willOpen = !showAttachmentMenu;
                        setShowAttachmentMenu(willOpen);
                        setShowSocialOptions(willOpen);
                      }}
                      aria-label={lang === "fr" ? "Pieces jointes" : "Attachments"}
                    >
                      <IconAttach size={22} color="#dfe4ff" />
                    </button>
                    <textarea
                      ref={textareaRef}
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          sendMessage(e);
                        }
                      }}
                      rows={1}
                      placeholder={selectedUser?.type === "ai" && showAiButtons
                        ? (lang === "fr" ? "Boutons ci-dessus ou écrivez librement..." : "Use the buttons above or just type...")
                        : placeholderText}
                      // Раньше input был disabled, когда показаны AI-кнопки. Если кнопки
                      // зависали в показанном состоянии — юзер не мог писать AI. Теперь
                      // блокируем только во время сетевого запроса.
                      disabled={selectedUser?.type === "ai" && aiLoading}
                    />
                    <button
                      type="submit"
                      className="na-send"
                      disabled={!text.trim() || (selectedUser?.type === "ai" && aiLoading)}
                      aria-label={lang === "fr" ? "Envoyer" : "Send"}
                    >
                      {aiLoading ? <span style={{ fontSize: 16 }}>...</span> : <IconSend size={24} color="#ffffff" />}
                    </button>
                  </form>
                </div>

                <input
                  id="file-upload"
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) console.log("Selected file: ", file.name);
                    e.target.value = null;
                  }}
                />
              </>
            ) : (
              <div className="na-empty-chat">
                <div>
                  <div style={{ fontSize: 42 }}>...</div>
                  <h2>{translations[lang]?.yourDialogs || "Your Dialogs"}</h2>
                  <p>{lang === "fr" ? "Selectionnez une conversation pour commencer." : "Select a conversation to start messaging."}</p>
                </div>
              </div>
            )}

            {/* Mobile bottom navigation disabled by request.
            <nav className="na-bottom-nav">
              <button type="button" className="active" aria-label="Chats"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" /></svg></button>
              <button type="button" aria-label="People"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /></svg></button>
              <button type="button" aria-label="Calendar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg></button>
              <button type="button" aria-label="AI"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v10l8-4-8 14V12L4 16l8-14z" /></svg></button>
              <button type="button" aria-label="Settings"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.38 1.03V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1.03-.38H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-.6 1.65 1.65 0 0 0 .38-1.03V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06A2 2 0 1 1 19.73 7l-.06.06A1.65 1.65 0 0 0 19.4 9c.22.33.6.57 1 .6.33.03.6.03.6.03a2 2 0 1 1 0 4h-.09A1.65 1.65 0 0 0 19.4 15z" /></svg></button>
            </nav>
            */}
          </section>

          {redesignRightVisible && (
            <div
              className={`na-right-resizer${isRedesignRightResizing ? " resizing" : ""}`}
              onMouseDown={handleRedesignRightResizeStart}
              role="separator"
              aria-orientation="vertical"
              aria-label={lang === "fr" ? "Redimensionner le panneau de droite" : "Resize right panel"}
            />
          )}

          {showRightPanel && selectedUser && (
            <div className="na-rightbar-layer">
            <aside className="na-rightbar" onClick={(e) => e.stopPropagation()}>
              <div className="na-rightbar-orbs" aria-hidden="true">
                <span className="na-orb o1" />
                <span className="na-orb o2" />
                <span className="na-orb o3" />
                <span className="na-orb o4" />
                <span className="na-orb o5" />
                <span className="na-orb o6" />
              </div>
              <div className="na-rightbar-scroll">
              <section className="na-profile-hero">
                <button
                  type="button"
                  className="na-rightbar-back"
                  onClick={() => setShowRightPanel(false)}
                  aria-label={lang === "fr" ? "Retour" : "Back"}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18 9 12l6-6" />
                  </svg>
                </button>
                {selectedShowsOnline && <div className="na-profile-state"><span className="na-online-dot" />Online</div>}
                <button type="button" className="na-profile-avatar" onClick={() => setShowAvatarFull(true)} aria-label="Open avatar">
                  {renderAvatar(selectedUser, selectedUser.type === "user" ? 108 : 94)}
                </button>
                <h2>{selectedName}</h2>
                <p>{selectedHandle}</p>
                <span className="na-role">{selectedUser.type === "ai" ? "AI" : selectedUser.type === "support" ? "Support" : "User"}</span>
              </section>

              {selectedUser.type === "user" ? (
                <>
                  <section className="na-side-card match">
                    <h3>Match summary</h3>
                    <div className="na-summary">
                      <div
                        className="na-ring"
                        style={{
                          background: `conic-gradient(from 0deg, #ffcf5a 0%, #ff7a59 ${Math.round(profileScore * 0.5)}%, #4ade80 ${profileScore}%, rgba(49,56,94,.55) ${profileScore}% 100%)`,
                        }}
                      >
                        <div className="na-ring-text"><strong>{profileScore}%</strong><span>Compatibility</span></div>
                      </div>
                      <p className="na-summary-reason">{sideMatchReasonText}</p>
                </div>
              </section>

              {selectedUser.match_id && (
                <section className="na-side-card na-rate-card">
                  <h3>{lang === "fr" ? "Evaluer ce match" : "Rate this match"}</h3>
                  {renderStars()}
                  <div className="na-rate-status" style={{ color: ratingJustSaved ? "#86efac" : "#aab4db" }}>
                    {ratingJustSaved
                      ? "Rating saved"
                      : matchRating
                        ? (lang === "fr" ? `Votre note : ${matchRating}/5` : `Your rating: ${matchRating}/5`)
                        : (lang === "fr" ? "Cliquez pour evaluer" : "Click to rate")}
                  </div>
                </section>
              )}

              <section className="na-side-card na-quick">
                <div className="na-quick-head"><h3>Quick actions</h3><span>v</span></div>
                <button type="button" className="na-quick-row" onClick={openUserProfile}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                  <span>View full profile</span><span className="chev">&gt;</span>
                </button>
                <button type="button" className="na-quick-row" onClick={() => quickInsert(lang === "fr" ? "On peut planifier un appel cette semaine ?" : "Maybe we can schedule a call this week?")}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                  <span>Schedule a call</span><span className="chev">&gt;</span>
                </button>
                <button type="button" className="na-quick-row" onClick={() => { setShowAttachmentMenu(true); setShowSocialOptions(true); setShowRightPanel(false); }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M8 9h8M8 13h5" /></svg>
                  <span>Share contact</span><span className="chev">&gt;</span>
                </button>
                <button type="button" className="na-quick-row danger" onClick={() => setShowMenu(v => !v)}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                  <span>Report / Block</span><span className="chev">&gt;</span>
                </button>
                {showMenu && (
                  <div className="na-drawer-actions">
                    <button type="button" onClick={() => setShowMenu(false)}>
                      {translations[lang]?.clearChat || "Clear Chat"}
                    </button>
                    <button type="button" className="danger" onClick={() => setShowMenu(false)}>
                      {translations[lang]?.blockUser || "Block User"}
                    </button>
                  </div>
                )}
              </section>
                </>
              ) : (
                <section className="na-side-card na-quick">
                  <div className="na-quick-head"><h3>{lang === "fr" ? "Actions" : "Actions"}</h3><span>v</span></div>
                  {selectedUser.type === "ai" ? (
                    <>
                      <button type="button" className="na-quick-row" onClick={() => { setShowRightPanel(false); handleResetProfile(); }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 3v6h6" /></svg>
                        <span>{translations[lang]?.resetChat || "Reset chat"}</span><span className="chev">&gt;</span>
                      </button>
                      <button type="button" className="na-quick-row" onClick={() => { setShowRightPanel(false); resetProfile(); }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                        <span>{lang === "fr" ? "Modifier le profil" : "Change profile"}</span><span className="chev">&gt;</span>
                      </button>
                    </>
                  ) : (
                    <button type="button" className="na-quick-row danger" onClick={() => setShowDeleteConfirm(true)}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 14H6L5 6" /></svg>
                      <span>{lang === "fr" ? "Supprimer mes donnees" : "Delete my data"}</span><span className="chev">&gt;</span>
                    </button>
                  )}
                  <button type="button" className="na-quick-row" onClick={() => setShowRightPanel(false)}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6 6 18M6 6l12 12" /></svg>
                    <span>{lang === "fr" ? "Fermer" : "Close"}</span><span className="chev">&gt;</span>
                  </button>
                </section>
              )}
              </div>
            </aside>
            </div>
          )}
        </main>

        {socialLinkModal && (
          <div className="na-modal-backdrop" onClick={() => { setSocialLinkModal(null); setSocialLinkValue(""); }}>
            <div className="na-modal-card" onClick={(e) => e.stopPropagation()}>
              <h3>{lang === "fr" ? `Votre lien ${socialLinkModal.label}` : `Your ${socialLinkModal.label} link`}</h3>
              <input
                autoFocus
                type="text"
                value={socialLinkValue}
                onChange={(e) => setSocialLinkValue(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleSocialLinkSubmit(); }}
                placeholder={socialLinkModal.placeholder}
              />
              <div className="na-modal-actions">
                <button type="button" onClick={() => { setSocialLinkModal(null); setSocialLinkValue(""); }}>
                  {lang === "fr" ? "Annuler" : "Cancel"}
                </button>
                <button type="button" className="primary" disabled={!socialLinkValue.trim()} onClick={handleSocialLinkSubmit}>
                  {lang === "fr" ? "Envoyer" : "Send"}
                </button>
              </div>
            </div>
          </div>
        )}

        {showUserProfile && selectedUser?.type === "user" && (
          <div className="na-profile-modal" onClick={() => { setShowUserProfile(false); setShowAvatarFull(false); }}>
            <div className="na-profile-card" onClick={(e) => e.stopPropagation()}>
              <button type="button" className="na-close" onClick={() => { setShowUserProfile(false); setShowAvatarFull(false); }}>x</button>
              <div className="na-profile-card-head">
                <button type="button" onClick={() => setShowAvatarFull(true)} style={{ padding: 0, lineHeight: 0 }}>
                  {renderAvatar(selectedUser, 72)}
                </button>
                <div>
                  <h3 style={{ margin: 0 }}>{selectedName}</h3>
                  <div style={{ color: "#a7b0cf", marginTop: 5 }}>{selectedHandle}</div>
                </div>
              </div>
              <div className="na-profile-scroll">
                {selectedUser.match_id && (
                  <section className="na-profile-section">
                    <h4>{lang === "fr" ? "Evaluer ce match" : "Rate this match"}</h4>
                    {renderStars()}
                    <div style={{ marginTop: 8, color: ratingJustSaved ? "#86efac" : "#aab4db", fontSize: 13 }}>
                      {ratingJustSaved
                        ? "Rating saved"
                        : matchRating
                          ? (lang === "fr" ? `Votre note : ${matchRating}/5` : `Your rating: ${matchRating}/5`)
                          : (lang === "fr" ? "Cliquez pour evaluer" : "Click to rate")}
                    </div>
                  </section>
                )}

                {Object.keys(partnerSocialLinks).length > 0 && (
                  <section className="na-profile-section">
                    <h4>{lang === "fr" ? "Liens sociaux" : "Social links"}</h4>
                    <div className="na-tags">
                      {Object.entries(partnerSocialLinks).map(([network, url]) => {
                        const iconMap = { telegram: telegramIcon, instagram: instagramIcon, linkedin: linkedinIcon, facebook: facebookIcon, whatsapp: whatsappIcon, email: emailIcon, phone: phoneIcon, outlook: outlookIcon };
                        const icon = iconMap[network.toLowerCase()];
                        const href = network.toLowerCase() === "phone"
                          ? `tel:${url}`
                          : network.toLowerCase() === "email"
                            ? `mailto:${url}`
                            : url.startsWith("http") ? url : `https://${url}`;
                        return (
                          <a key={network} href={href} target="_blank" rel="noopener noreferrer" className="na-social-btn" style={{ width: 44, minHeight: 44, textDecoration: "none" }} onClick={e => e.stopPropagation()}>
                            {icon ? <img src={icon} alt={network} /> : network[0].toUpperCase()}
                          </a>
                        );
                      })}
                    </div>
                  </section>
                )}

                {selectedUser.match_reason && (
                  <section className="na-profile-section">
                    <h4>{lang === "fr" ? "Raison du match" : "Match reason"}</h4>
                    <p style={{ color: "#dfe4fb", lineHeight: 1.65, margin: 0 }}>{selectedUser.match_reason}</p>
                  </section>
                )}

                <section className="na-profile-section">
                  <h4>{lang === "fr" ? "A propos" : "About user"}</h4>
                  <p style={{ color: "#dfe4fb", lineHeight: 1.65, margin: 0 }}>
                    {selectedUser.about || (lang === "fr" ? "Aucune description" : "No description yet")}
                  </p>
                </section>
              </div>
            </div>
          </div>
        )}

        {showAvatarFull && selectedUser?.type === "user" && (
          <div className="na-avatar-full" onClick={() => setShowAvatarFull(false)}>
            {renderAvatar(selectedUser, 800)}
          </div>
        )}

        <MessageAnimations theme={activeTheme} />
      </div>
    );
  }
  // ────────────────────────────────────────────────────────────────────────────

  return (
    <div className="chat-page-root" style={{
      position: "fixed",
      top: isMobile ? "50px" : "70px",
      left: 0,
      right: 0,
      bottom: 0,
      overflow: "hidden",
      display: "flex",
      WebkitOverflowScrolling: "touch",
      overscrollBehavior: "contain",
      touchAction: "manipulation",
      zoom: isMobile ? textScale : 1,
    }}>
      {showPdfModal && (
        <PdfToTextModal
          onClose={() => setShowPdfModal(false)}
          onApply={(cleanText) => {
            setText((prev) => prev + (prev && !prev.endsWith("\n") ? "\n\n" : " ") + cleanText);
            setShowPdfModal(false);
            textareaRef.current?.focus();
          }}
        />
      )}

      {/* Сайдбар - ВСЕГДА виден на десктопе, на мобилке скрывается при выборе чата */}
      <div
        className="chat-sidebar"
        style={{
          width: isMobile ? (selectedUser ? "0%" : "100%") : `${sidebarWidth}%`,
          minWidth: isMobile ? "0px" : "200px",
          height: "100%",
          maxHeight: "100%",
          borderRight: isMobile ? "none" : `1px solid ${themeVars.border}40`,
          background: themeVars.bg,
          overflowY: "auto",
          overflowX: "hidden",
          WebkitOverflowScrolling: "touch",
          overscrollBehavior: "contain",
          position: "relative",
          boxSizing: "border-box",
          transition: "none",
          zIndex: 100,
          display: isMobile && selectedUser ? "none" : "block",
        }}
      >
        <div
          style={{
            padding: "20px 20px",
            borderBottom: `1px solid ${themeVars.border}30`,
            background: themeVars.card,
          }}
        >
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={translations[lang]?.searchDialogs || "Search dialogs..."}
            style={{
              width: "100%",
              padding: "8px 12px",
              borderRadius: "8px",
              border: `1px solid ${themeVars.border}40`,
              background: themeVars.bg,
              color: themeVars.fg,
              fontSize: "14px",
              outline: "none",
              boxSizing: "border-box",
            }}
          />
        </div>
        <div
          style={{
            padding: "24px 20px 16px 20px",
            borderBottom: `1px solid ${themeVars.border}30`,
            background: themeVars.card,
            fontWeight: 700,
            fontSize: 18,
            color: themeVars.fg,
          }}>
          {translations[lang]?.yourDialogs || "Your Dialogs"}
        </div>

        <div
          className="chat-list-item"
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const ripple = document.createElement("span");
            ripple.className = "chat-ripple";
            ripple.style.top = `${e.clientY - rect.top}px`;
            ripple.style.left = `${e.clientX - rect.left}px`;
            e.currentTarget.appendChild(ripple);
            setTimeout(() => ripple.remove(), 520);
            handleSelectUser({ id: "support", username: "Support", type: "support" });
          }}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 16px",
            background: selectedUser?.id === "support" ? themeVars.card : "none",
            color: themeVars.fg,
            cursor: "pointer",
            fontWeight: selectedUser?.id === "support" ? 600 : 400,
            borderLeft: selectedUser?.id === "support" ? `3px solid ${themeVars.border}` : "3px solid transparent",
            transition: "all 0.2s ease",
          }}
        >
          <div className="chat-avatar" style={{ width: "48px", height: "48px", borderRadius: "50%", background: "#ffffff", marginRight: 12 }}>
            <img src={support} alt="Support" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>
              {lang === "fr" ? "Chat Support" : "Support Chat"}
            </div>
            <div style={{ fontSize: 12, opacity: 0.6 }}>
              {lang === "fr" ? "Obtenez l'aide de notre équipe" : "Get help from our team"}
            </div>
          </div>
        </div>

        <div
          className="chat-list-item"
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const ripple = document.createElement("span");
            ripple.className = "chat-ripple";
            ripple.style.top = `${e.clientY - rect.top}px`;
            ripple.style.left = `${e.clientX - rect.left}px`;
            e.currentTarget.appendChild(ripple);
            setTimeout(() => ripple.remove(), 520);
            handleSelectUser({ id: "ai", username: "AI Assistant", type: "ai" });
          }}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "12px 16px",
            background: selectedUser?.id === "ai" ? themeVars.card : "none",
            color: themeVars.fg,
            cursor: "pointer",
            fontWeight: selectedUser?.id === "ai" ? 600 : 400,
            borderLeft: selectedUser?.id === "ai" ? `3px solid ${themeVars.border}` : "3px solid transparent",
            transition: "all 0.2s ease",
          }}
        >
          <div className="chat-avatar" style={{ width: "48px", height: "48px", borderRadius: "50%", background: "#ffffff", marginRight: 12 }}>
            <img src={ai} alt="AI" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>
              {lang === "fr" ? "Assistant IA" : "AI Assistant"}
            </div>
            <div style={{ fontSize: 12, opacity: 0.6 }}>
              {lang === "fr" ? "Discutez avec l'IA pour obtenir de l'aide" : "Chat with AI for assistance"}
            </div>
          </div>
        </div>

        <div style={{ height: 1, background: themeVars.border, margin: "12px 16px", opacity: 0.2 }} />

        <div
          style={{
            padding: "8px 16px 12px 16px",
            fontWeight: 600,
            fontSize: 13,
            opacity: 0.7,
            color: themeVars.fg,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{lang === "fr" ? "Vos Conversations" : "Your Conversations"}</span>
          <button
            style={{
              background: "none",
              border: "none",
              cursor: "default",
              opacity: 0.4,
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={themeVars.fg} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
          </button>
        </div>

        {(() => {
          // Группируем диалоги по event_id
          const groups = [];
          const groupMap = {};

          filteredDialogs.forEach(u => {
            const key = u.event_id ? String(u.event_id) : "__direct__";
            if (!groupMap[key]) {
              groupMap[key] = {
                event_id: u.event_id || null,
                event_title: u.event_title || null,
                dialogs: [],
              };
              groups.push(groupMap[key]);
            }
            groupMap[key].dialogs.push(u);
          });

          // Ивентовые группы сначала, потом прямые матчи
          groups.sort((a, b) => {
            if (a.event_id && !b.event_id) return -1;
            if (!a.event_id && b.event_id) return 1;
            return 0;
          });

          const dividerStyle = {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 12px 4px",
            marginTop: "6px",
          };
          const lineColor = activeTheme === "dark"
            ? "rgba(140,160,255,0.30)"
            : "rgba(100,80,200,0.22)";
          const lineLeftStyle = {
            flex: "1 1 auto",
            minWidth: "8px",
            height: "1px",
            background: `linear-gradient(to right, transparent 0%, ${lineColor} 100%)`,
          };
          const lineRightStyle = {
            flex: "1 1 auto",
            minWidth: "8px",
            height: "1px",
            background: `linear-gradient(to left, transparent 0%, ${lineColor} 100%)`,
          };
          const labelStyle = {
            flex: "0 1 auto",
            minWidth: 0,
            maxWidth: "70%",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
            color: activeTheme === "dark"
              ? "rgba(160,180,255,0.55)"
              : "rgba(80,60,160,0.50)",
          };

          return groups.map(group => {
            const groupKey = group.event_id ? String(group.event_id) : "__direct__";
            const isCollapsed = !!collapsedGroups[groupKey];
            const showHeader = groups.length > 1 || group.event_id;
            return (
            <div key={groupKey}>
              {/* Разделитель-заголовок группы — кликабельный для сворачивания */}
              {showHeader && (
                <div
                  style={{ ...dividerStyle, cursor: "pointer", userSelect: "none" }}
                  onClick={() => toggleGroup(groupKey)}
                  title={isCollapsed
                    ? (lang === "fr" ? "Développer" : "Expand")
                    : (lang === "fr" ? "Réduire" : "Collapse")}
                >
                  <div style={lineLeftStyle} />
                  <span style={labelStyle} title={group.event_title || (lang === "fr" ? "Directs" : "Direct")}>
                    {group.event_id
                      ? (group.event_title || `Event #${group.event_id}`)
                      : (lang === "fr" ? "Directs" : "Direct")}
                  </span>
                  <div style={lineRightStyle} />
                  <svg
                    width="12" height="12" viewBox="0 0 12 12" fill="none"
                    style={{
                      flexShrink: 0,
                      transition: "transform 0.22s cubic-bezier(0.22,1,0.36,1)",
                      transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
                      opacity: 0.55,
                    }}
                  >
                    <path d="M2 4L6 8L10 4" stroke={activeTheme === "dark" ? "rgba(160,180,255,0.9)" : "rgba(80,60,160,0.9)"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}

              <div style={{
                overflow: "hidden",
                maxHeight: isCollapsed ? "0px" : "9999px",
                opacity: isCollapsed ? 0 : 1,
                transform: isCollapsed ? "translateY(-4px)" : "translateY(0)",
                transition: isCollapsed
                  ? "max-height 0.28s cubic-bezier(0.4,0,1,1), opacity 0.18s ease, transform 0.22s ease"
                  : "max-height 0.35s cubic-bezier(0,0,0.2,1), opacity 0.22s ease 0.04s, transform 0.25s ease 0.04s",
              }}>
              {group.dialogs.map((u) => {
                const uSlot = u.match_id ? (allTableSlots[String(u.match_id)] ?? null) : null;
                const uSlotStatus = uSlot?.status ?? null;
                const fmtSec = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
                return (
                <div
                  key={u.id}
                  className={`chat-list-item${uSlotStatus === "active" ? " table-rainbow-border" : ""}${uSlotStatus === "searching" ? " searching-pulse" : ""}`}
                  onClick={(e) => {
                    // ripple effect
                    const rect = e.currentTarget.getBoundingClientRect();
                    const ripple = document.createElement("span");
                    ripple.className = "chat-ripple";
                    ripple.style.top = `${e.clientY - rect.top}px`;
                    ripple.style.left = `${e.clientX - rect.left}px`;
                    e.currentTarget.appendChild(ripple);
                    setTimeout(() => ripple.remove(), 520);
                    handleSelectUser({ ...u, type: "user" });
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    background: selectedUser?.id === u.id ? themeVars.card : "transparent",
                    color: themeVars.fg,
                    cursor: "pointer",
                    fontWeight: selectedUser?.id === u.id ? 600 : 400,
                    borderLeft: uSlot ? "none" : (selectedUser?.id === u.id ? `3px solid ${themeVars.border}` : "3px solid transparent"),
                    borderRadius: "12px",
                    margin: "2px 8px",
                    boxSizing: "border-box",
                    minWidth: 0,
                    transition: "all 0.2s ease",
                  }}
                >
                  <div className="chat-avatar" style={{ marginRight: 12 }}>
                    <Avatar userId={u.id} size={48} username={u.username || u.name || u.email || ""} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {u.username || u.name || u.email}
                    </div>
                    {uSlot && (
                      <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 4 }}>
                        {uSlotStatus === "active" && (
                          <div style={{
                            position: "relative", display: "inline-flex", alignItems: "center", gap: 4,
                          }}>
                            <div style={{
                              position: "absolute", inset: 0, borderRadius: 20,
                              background: activeTheme === "dark" ? "rgba(20,20,40,0.52)" : "rgba(255,255,255,0.52)",
                              backdropFilter: "blur(8px) saturate(180%)",
                              WebkitBackdropFilter: "blur(8px) saturate(180%)",
                              border: "1px solid rgba(255,255,255,0.22)",
                              boxShadow: "0 2px 10px rgba(84,160,255,0.18)",
                            }} />
                            <div style={{
                              position: "relative", display: "flex", alignItems: "center", gap: 4,
                              padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                              background: "linear-gradient(90deg, rgba(255,107,107,0.22), rgba(84,160,255,0.22))",
                              WebkitBackgroundClip: "text",
                              color: activeTheme === "dark" ? "#c8eaff" : "#2a4a7a",
                            }}>
                              🪑 Table {uSlot.table_number}
                            </div>
                          </div>
                        )}
                        {uSlotStatus === "searching" && (
                          <div style={{
                            padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                            background: "rgba(254,202,87,0.18)", border: "1px solid rgba(254,202,87,0.45)",
                            color: activeTheme === "dark" ? "#feca57" : "#9a6e00",
                            whiteSpace: "nowrap",
                          }}>
                            🔍 {lang === "fr" ? `Trouver table ${uSlot.table_number}` : `Find table ${uSlot.table_number}`}
                          </div>
                        )}
                        {uSlotStatus === "queued" && (
                          <div style={{
                            padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                            background: "rgba(120,140,255,0.15)", border: "1px solid rgba(120,140,255,0.35)",
                            color: activeTheme === "dark" ? "#aab4ff" : "#4a35b0",
                            whiteSpace: "nowrap",
                          }}>
                            {uSlot.queue_position ? `⏳ #${uSlot.queue_position}` : "⏳ Queue"}
                          </div>
                        )}
                        {uSlotStatus === "expired" && (
                          <div style={{
                            padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                            background: "rgba(34,197,94,0.12)", border: "1px solid rgba(34,197,94,0.30)",
                            color: activeTheme === "dark" ? "#86efac" : "#166534",
                            whiteSpace: "nowrap",
                          }}>
                            ✅ {lang === "fr" ? "Session terminée" : "Session done"}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {uSlot && uSlotStatus !== "expired" && (
                    <div style={{ position: "relative", flexShrink: 0, marginLeft: 8 }}>
                      <div style={{
                        position: "absolute", inset: "-4px -6px", borderRadius: 12,
                        background: activeTheme === "dark" ? "rgba(20,20,40,0.55)" : "rgba(255,255,255,0.55)",
                        backdropFilter: "blur(8px) saturate(180%)",
                        WebkitBackdropFilter: "blur(8px) saturate(180%)",
                        border: `1px solid ${
                          uSlotStatus === "searching" ? "rgba(254,202,87,0.55)" :
                          uSlotStatus === "queued"    ? "rgba(120,140,255,0.40)" :
                          uSlot.seconds_left < 60     ? "rgba(255,107,107,0.5)" :
                                                        "rgba(84,160,255,0.35)"
                        }`,
                        boxShadow: uSlotStatus === "searching" ? "0 2px 12px rgba(254,202,87,0.30)" :
                                   uSlotStatus === "queued"    ? "0 2px 12px rgba(120,140,255,0.22)" :
                                   uSlot.seconds_left < 60     ? "0 2px 12px rgba(255,107,107,0.3)" :
                                                                  "0 2px 12px rgba(84,160,255,0.25)",
                      }} />
                      <div style={{
                        position: "relative", fontSize: 13, fontWeight: 800,
                        fontVariantNumeric: "tabular-nums", letterSpacing: "0.02em",
                        color: uSlotStatus === "searching" ? "#feca57" :
                               uSlotStatus === "queued"    ? (activeTheme === "dark" ? "#aab4ff" : "#4a35b0") :
                               uSlot.seconds_left < 60     ? "#ff6b6b" : "#48dbfb",
                        textShadow: uSlotStatus === "searching" ? "0 0 8px rgba(254,202,87,0.7)" :
                                    uSlotStatus === "queued"    ? "none" :
                                    uSlot.seconds_left < 60     ? "0 0 8px rgba(255,107,107,0.7)" :
                                                                   "0 0 8px rgba(72,219,251,0.7)",
                        minWidth: 38, textAlign: "center",
                      }}>
                        {uSlotStatus === "queued"
                          ? (uSlot.seconds_left > 0
                              ? (uSlot.seconds_left < 60
                                  ? "<1m"
                                  : (uSlot.seconds_left < 3600
                                      ? `~${Math.round(uSlot.seconds_left / 60)}m`
                                      : `~${Math.floor(uSlot.seconds_left / 3600)}h${Math.round((uSlot.seconds_left % 3600) / 60)}m`))
                              : "—")
                          : fmtSec(uSlot.seconds_left)}
                      </div>
                    </div>
                  )}
                </div>
                );
              })}
              </div>
            </div>
          ); });
        })()}
      </div>

      {/* Разделитель для десктопа */}
      {!isMobile && selectedUser && (
        <div
          onMouseDown={handleMouseDown}
          style={{
            width: "4px",
            background: isResizing ? themeVars.border : `${themeVars.border}40`,
            cursor: "col-resize",
            position: "relative",
            transition: isResizing ? "none" : "background 0.2s ease",
            zIndex: 10,
          }}
          onMouseEnter={(e) => { if (!isResizing) e.target.style.background = themeVars.border; }}
          onMouseLeave={(e) => { if (!isResizing) e.target.style.background = `${themeVars.border}40`; }}
        />
      )}

      {/* Основной контент чата - показывается только при выбранном пользователе */}
      {selectedUser && (
        <div
          className="chat-main"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            background: themeVars.bg,
            position: "relative",
            overflow: "hidden",
            minWidth: 0,
            minHeight: 0,
            height: "100%",
            maxHeight: "100%",
            width: isMobile ? "100%" : "auto",
            zIndex: 90,
          }}
        >
          <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, minWidth: 0, position: "relative" }}>
            <div
              className="chat-messages-container"
              style={{
                flex: 1,
                overflow: "hidden",
                position: "relative",
                minHeight: 0,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                background: activeTheme === "dark" ? "#1a1a2e" : "#f4f3fa",
              }}
            >
              {/* Fixed SVG background — stays in place while messages scroll */}
              <ChatBackground theme={activeTheme} />
              {/* Header capsule */}
              <div
                style={{
                  position: "absolute",
                  top: isMobile ? "8px" : "16px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: isMobile ? "calc(100% - 24px)" : "min(70%, 720px)",
                  zIndex: 20,
                  pointerEvents: "none",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    padding: isMobile ? "8px 14px" : "12px 24px",
                    borderRadius: isMobile ? "999px" : "60px",
                    minHeight: isMobile ? "52px" : "68px",
                    display: "flex",
                    alignItems: "center",
                    gap: isMobile ? "10px" : "16px",
                    width: "fit-content",
                    maxWidth: "92%",
                    pointerEvents: "auto",
                    backdropFilter: "blur(20px) saturate(180%)",
                    WebkitBackdropFilter: "blur(20px) saturate(180%)",
                    background: themeVars.glassPanel,
                    border: `1px solid ${themeVars.glassBorder}`,
                    boxShadow: themeVars.glassShadow,
                    color: themeVars.glassText,
                  }}
                >
                  {isMobile && (
                    <button
                      onClick={handleBackToList}
                      aria-label={lang === "fr" ? "Retour" : "Back"}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                        flexShrink: 0,
                      }}
                    >
                      <IconBack size={20} color={themeVars.backIconColor} />
                    </button>
                  )}

                  {selectedUser.type === "ai" || selectedUser.type === "support" ? (
                    <div
                      style={{
                        width: isMobile ? "36px" : "48px",
                        height: isMobile ? "36px" : "48px",
                        borderRadius: "50%",
                        background: "#fff",
                        flexShrink: 0,
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={selectedUser.type === "ai" ? ai : support}
                        alt=""
                        style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                      />
                    </div>
                  ) : (
                    <div
                      onClick={openUserProfile}
                      style={{
                        flexShrink: 0,
                        cursor: "pointer",
                        borderRadius: "50%",
                        overflow: "hidden",
                        lineHeight: 0,
                        transition: "transform 0.18s ease, box-shadow 0.18s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.08)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(100,80,200,0.28)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = "";
                      }}
                    >
                      <Avatar
                        key={selectedUser.id}
                        userId={selectedUser.id}
                        size={isMobile ? 36 : 48}
                        username={selectedUser.username || selectedUser.email || ""}
                      />
                    </div>
                  )}

                  <div
                    onClick={() => { if (selectedUser.type === "user") openUserProfile(); }}
                    style={{
                      flex: 1,
                      fontWeight: 600,
                      fontSize: isMobile ? "14px" : "18px",
                      color: themeVars.glassText,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                      cursor: selectedUser.type === "user" ? "pointer" : "default",
                      transition: "opacity 0.15s ease",
                    }}
                    onMouseEnter={(e) => { if (selectedUser.type === "user") e.currentTarget.style.opacity = "0.7"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.opacity = ""; }}
                  >
                    {selectedUser.type === "ai"
                      ? lang === "fr" ? "Assistant IA" : "AI Assistant"
                      : selectedUser.username || selectedUser.email}
                  </div>

                  <div ref={menuRef} style={{ position: "relative" }}>
                    <button
                      onClick={() => setShowMenu(!showMenu)}
                      onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; }}
                      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.35s cubic-bezier(0.34,1.56,0.64,1)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.2s ease"; }}
                      onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; }}
                      onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.35s cubic-bezier(0.34,1.56,0.64,1)"; }}
                      style={{
                        width: isMobile ? "32px" : "40px",
                        height: isMobile ? "32px" : "40px",
                        background: "none",
                        border: "none",
                        color: themeVars.glassText,
                        fontSize: isMobile ? "20px" : "24px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                      }}
                    >
                      ⋮
                    </button>

                    {showMenu && (
                      <div
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "calc(100% + 30px)",
                          transform: "translateX(-50%)",
                          padding: "8px",
                          borderRadius: "16px",
                          minWidth: "160px",
                          zIndex: 1000,
                          pointerEvents: "auto",
                          backdropFilter: "blur(20px) saturate(180%)",
                          WebkitBackdropFilter: "blur(20px) saturate(180%)",
                          background: themeVars.glassMenuBg,
                          border: `1px solid ${themeVars.glassBorder}`,
                          boxShadow: themeVars.glassShadow,
                          color: themeVars.glassText,
                        }}
                      >
                        {selectedUser.type !== "ai" && (
                          <>
                            <button
                              onClick={() => {
                                setShowMenu(false);
                              }}
                              style={{
                                ...menuBtnStyle(themeVars),
                                width: "100%",
                                textAlign: "center",
                                padding: "10px 12px",
                                borderRadius: "12px",
                              }}
                            >
                              {translations[lang]?.clearChat || "Clear Chat"}
                            </button>
                            <button
                              onClick={() => {
                                setShowMenu(false);
                              }}
                              style={{
                                ...menuBtnStyle(themeVars),
                                width: "100%",
                                textAlign: "center",
                                padding: "10px 12px",
                                borderRadius: "12px",
                                marginTop: "6px",
                              }}
                            >
                              {translations[lang]?.blockUser || "Block User"}
                            </button>
                          </>
                        )}
                        {selectedUser.type === "ai" && (
                          <button
                            onClick={() => {
                              setShowMenu(false);
                              handleResetProfile();
                            }}
                            style={{
                              ...menuBtnStyle(themeVars),
                              color: "#ff6b6b",
                              width: "100%",
                              textAlign: "center",
                              padding: "10px 12px",
                              borderRadius: "12px",
                            }}
                          >
                            {translations[lang]?.resetChat || "Reset chat"}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ── Table Slot — единый виджет для мобилки и ПК ── */}
              {tableSlot && tableSlotStatus !== "expired" && (
                <div style={{
                  position: "absolute",
                  top: isMobile ? "88px" : "100px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 18,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}>

                  {/* ── Горизонтальный ряд: [+5/+10] [плашка] [🔄 Restart] ── */}
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: isMobile ? 8 : 12 }}>

                    {/* Левая колонка: +5 / +10 мин (только для active) */}
                    <div style={{
                      display: tableSlotStatus === "queued" ? "none" : "flex",
                      flexDirection: "column", gap: 7,
                      opacity: slotActionsOpen ? 1 : 0,
                      pointerEvents: slotActionsOpen ? "auto" : "none",
                      transform: slotActionsOpen ? "translateX(0)" : "translateX(18px)",
                      transition: "opacity 0.24s ease, transform 0.24s cubic-bezier(0.22,1,0.36,1)",
                    }}>
                      {[5, 10].map(min => (
                        <button
                          key={min}
                          onClick={() => handleSlotAction(`extend${min}`)}
                          disabled={!!slotActionLoading}
                          style={{
                            padding: isMobile ? "10px 14px" : "11px 18px",
                            borderRadius: "12px",
                            border: "1.5px solid rgba(84,160,255,0.45)",
                            background: activeTheme === "dark" ? "rgba(20,20,50,0.88)" : "rgba(240,243,255,0.92)",
                            color: "#54a0ff",
                            WebkitTextFillColor: "#54a0ff",
                            fontSize: isMobile ? 14 : 15,
                            fontWeight: 800,
                            cursor: slotActionLoading ? "not-allowed" : "pointer",
                            opacity: slotActionLoading === `extend${min}` ? 0.5 : 1,
                            backdropFilter: "blur(12px)",
                            whiteSpace: "nowrap",
                            boxShadow: "0 2px 12px rgba(84,160,255,0.22)",
                            transition: "opacity 0.15s, transform 0.12s",
                          }}
                          onMouseDown={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                          onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                          onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                          onTouchStart={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                          onTouchEnd={e => { e.currentTarget.style.transform = "scale(1)"; }}
                        >
                          {slotActionLoading === `extend${min}` ? "⏳" : `+${min} min`}
                        </button>
                      ))}
                    </div>

                    {/* Центр: плашка стола — тап/клик открывает/закрывает */}
                    <div
                      onClick={() => setSlotActionsOpen(v => !v)}
                      style={{
                        position: "relative",
                        borderRadius: isMobile ? "16px" : "18px",
                        padding: "2px",
                        background: tableSlotStatus === "searching"
                          ? "linear-gradient(270deg, #feca57, #ff9ff3, #feca57)"
                          : tableSlotStatus === "queued"
                            ? "linear-gradient(270deg, #a78bfa, #818cf8, #a78bfa)"
                            : "linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #ff9ff3, #54a0ff, #ff6b6b)",
                        backgroundSize: "400% 400%",
                        animation: "rainbowRotate 2.5s linear infinite",
                        boxShadow: slotActionsOpen
                          ? "0 6px 28px rgba(84,160,255,0.55)"
                          : tableSlotStatus === "searching"
                            ? (isMobile ? "0 4px 18px rgba(254,202,87,0.45)" : "0 4px 24px rgba(254,202,87,0.40)")
                            : (isMobile ? "0 4px 18px rgba(84,160,255,0.32)" : "0 4px 24px rgba(84,160,255,0.30)"),
                        minWidth: isMobile ? 150 : 200,
                        cursor: "pointer",
                        userSelect: "none",
                        flexShrink: 0,
                        overflow: "hidden",
                        transition: "box-shadow 0.2s ease",
                      }}>
                      {isMobile ? (
                        <div style={{
                          background: tableSlotStatus === "searching"
                            ? (activeTheme === "dark" ? "rgba(40,30,5,0.96)" : "rgba(255,252,235,0.97)")
                            : (activeTheme === "dark" ? "rgba(20,20,40,0.94)" : "rgba(245,243,252,0.96)"),
                          borderRadius: "14px", padding: "10px 20px 12px",
                          backdropFilter: "blur(14px)",
                          display: "flex", flexDirection: "column", alignItems: "center", gap: 6,
                          width: "100%", boxSizing: "border-box",
                        }}>
                          {tableSlotStatus === "queued" ? (
                            <>
                              <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                                <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", opacity: 0.7, color: themeVars.fg, whiteSpace: "nowrap" }}>
                                  {lang === "fr" ? "⏳ File d'attente" : "⏳ In queue"}
                                </span>
                                {tableSlot.queue_position != null && (
                                  <span key={`q-pos-${tableSlot.queue_position}`} style={{ fontSize: 28, fontWeight: 900, lineHeight: 1, background: "linear-gradient(90deg, #a78bfa, #818cf8)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                                    #{tableSlot.queue_position}
                                  </span>
                                )}
                              </div>
                              <div style={{ display: "flex", alignItems: "baseline", gap: 6, justifyContent: "center", flexWrap: "wrap" }}>
                                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", opacity: 0.6, color: themeVars.fg, whiteSpace: "nowrap" }}>
                                  {lang === "fr" ? "Table dispo dans" : "Table in"}
                                </span>
                                <span style={{ fontSize: 16, fontWeight: 800, lineHeight: 1, fontVariantNumeric: "tabular-nums",
                                  color: activeTheme === "dark" ? "#aab4ff" : "#4a35b0",
                                  WebkitTextFillColor: activeTheme === "dark" ? "#aab4ff" : "#4a35b0",
                                }}>
                                  {tableSlot.seconds_left > 0
                                    ? (tableSlot.seconds_left < 60
                                        ? (lang === "fr" ? "<1 min" : "<1 min")
                                        : (tableSlot.seconds_left < 3600
                                            ? `~${Math.round(tableSlot.seconds_left / 60)} min`
                                            : `~${Math.floor(tableSlot.seconds_left / 3600)}h ${Math.round((tableSlot.seconds_left % 3600) / 60)}m`))
                                    : (lang === "fr" ? "bientôt" : "soon")}
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                                <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", opacity: 0.7, color: tableSlotStatus === "searching" ? "#feca57" : themeVars.fg, whiteSpace: "nowrap" }}>
                                  {tableSlotStatus === "searching"
                                    ? (lang === "fr" ? "🔍 Trouver table" : "🔍 Find table")
                                    : "🪑 Table"}
                                </span>
                                <span key={`m-tnum-${tableSlotStatus}-${tableSlot.table_number}`} style={{ fontSize: 30, fontWeight: 900, lineHeight: 1, background: tableSlotStatus === "searching" ? "linear-gradient(90deg, #feca57, #ff9ff3)" : "linear-gradient(90deg, #54a0ff, #ff9ff3)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                                  {tableSlot.table_number}
                                </span>
                              </div>
                              <div style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
                                <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", opacity: 0.6, color: themeVars.fg, whiteSpace: "nowrap" }}>
                                  {lang === "fr" ? "⏱ Restant" : "⏱ Left"}
                                </span>
                                <span style={{ fontSize: 26, fontWeight: 800, lineHeight: 1, fontVariantNumeric: "tabular-nums",
                                  color: tableSlotStatus === "searching" ? "#feca57" : (tableSlot.seconds_left < 60 ? "#ff6b6b" : "#48dbfb"),
                                  WebkitTextFillColor: tableSlotStatus === "searching" ? "#feca57" : (tableSlot.seconds_left < 60 ? "#ff6b6b" : "#48dbfb"),
                                }}>
                                  {Math.floor(tableSlot.seconds_left / 60)}:{String(tableSlot.seconds_left % 60).padStart(2, "0")}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <div style={{
                          background: tableSlotStatus === "searching"
                            ? (activeTheme === "dark" ? "rgba(40,30,5,0.93)" : "rgba(255,252,235,0.96)")
                            : (activeTheme === "dark" ? "rgba(20,20,40,0.92)" : "rgba(245,243,252,0.95)"),
                          borderRadius: "16px", padding: "14px 24px",
                          textAlign: "center", minWidth: 200, backdropFilter: "blur(12px)",
                        }}>
                        {tableSlotStatus === "queued" ? (
                          <>
                            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", opacity: 0.7,
                              color: themeVars.fg, marginBottom: 6 }}>
                              {lang === "fr" ? "⏳ En file d'attente" : "⏳ Waiting in queue"}
                            </div>
                            {tableSlot.queue_position != null && (
                              <div key={`d-q-pos-${tableSlot.queue_position}`} style={{ fontSize: 32, fontWeight: 900, lineHeight: 1,
                                background: "linear-gradient(90deg, #a78bfa, #818cf8)",
                                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: 8 }}>
                                #{tableSlot.queue_position}
                              </div>
                            )}
                            <div style={{ fontSize: 13, fontWeight: 700, fontVariantNumeric: "tabular-nums",
                              color: activeTheme === "dark" ? "#aab4ff" : "#4a35b0",
                              WebkitTextFillColor: activeTheme === "dark" ? "#aab4ff" : "#4a35b0",
                            }}>
                              <span style={{ fontSize: 10, opacity: 0.7, marginRight: 4, WebkitTextFillColor: "unset", color: themeVars.fg }}>
                                {lang === "fr" ? "table dans" : "table in"}
                              </span>
                              {tableSlot.seconds_left > 0
                                ? (tableSlot.seconds_left < 60
                                    ? "<1 min"
                                    : (tableSlot.seconds_left < 3600
                                        ? `~${Math.round(tableSlot.seconds_left / 60)} min`
                                        : `~${Math.floor(tableSlot.seconds_left / 3600)}h ${Math.round((tableSlot.seconds_left % 3600) / 60)}m`))
                                : (lang === "fr" ? "bientôt" : "soon")}
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", opacity: 0.7,
                              color: tableSlotStatus === "searching" ? "#feca57" : themeVars.fg, marginBottom: 6 }}>
                              {tableSlotStatus === "searching"
                                ? (lang === "fr" ? "🔍 Trouvez la table" : "🔍 Find your table")
                                : (lang === "fr" ? "🪑 Vous êtes à la table" : "🪑 You are at table")}
                            </div>
                            <div key={`d-tnum-${tableSlotStatus}-${tableSlot.table_number}`} style={{ fontSize: 32, fontWeight: 900, lineHeight: 1,
                              background: tableSlotStatus === "searching"
                                ? "linear-gradient(90deg, #feca57, #ff9ff3)"
                                : "linear-gradient(90deg, #54a0ff, #ff9ff3)",
                              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: 8 }}>
                              {tableSlot.table_number}
                            </div>
                            <div style={{ fontSize: 13, fontWeight: 700, fontVariantNumeric: "tabular-nums",
                              color: tableSlotStatus === "searching" ? "#feca57" : (tableSlot.seconds_left < 60 ? "#ff6b6b" : "#48dbfb"),
                              WebkitTextFillColor: tableSlotStatus === "searching" ? "#feca57" : (tableSlot.seconds_left < 60 ? "#ff6b6b" : "#48dbfb"),
                            }}>
                              {Math.floor(tableSlot.seconds_left / 60)}:{String(tableSlot.seconds_left % 60).padStart(2, "0")}
                              <span style={{ fontSize: 10, opacity: 0.7, marginLeft: 4, WebkitTextFillColor: "unset", color: themeVars.fg }}>
                                {lang === "fr" ? "restant" : "left"}
                              </span>
                            </div>
                          </>
                        )}
                        </div>
                      )}
                    </div>

                    {/* Правая колонка: 🔄 Restart (только для active/searching) */}
                    <div style={{
                      display: tableSlotStatus === "queued" ? "none" : "flex",
                      flexDirection: "column", gap: 7,
                      opacity: slotActionsOpen ? 1 : 0,
                      pointerEvents: slotActionsOpen ? "auto" : "none",
                      transform: slotActionsOpen ? "translateX(0)" : "translateX(-18px)",
                      transition: "opacity 0.24s ease, transform 0.24s cubic-bezier(0.22,1,0.36,1)",
                    }}>
                      <button
                        onClick={() => handleSlotAction("restart")}
                        disabled={!!slotActionLoading}
                        style={{
                          padding: isMobile ? "10px 14px" : "11px 18px",
                          borderRadius: "12px",
                          border: "1.5px solid rgba(254,202,87,0.50)",
                          background: activeTheme === "dark" ? "rgba(30,25,10,0.88)" : "rgba(255,252,235,0.92)",
                          color: activeTheme === "dark" ? "#feca57" : "#9a6e00",
                          WebkitTextFillColor: activeTheme === "dark" ? "#feca57" : "#9a6e00",
                          fontSize: isMobile ? 14 : 15,
                          fontWeight: 800,
                          cursor: slotActionLoading ? "not-allowed" : "pointer",
                          opacity: slotActionLoading === "restart" ? 0.5 : 1,
                          backdropFilter: "blur(12px)",
                          whiteSpace: "nowrap",
                          boxShadow: "0 2px 12px rgba(254,202,87,0.20)",
                          transition: "opacity 0.15s, transform 0.12s",
                        }}
                        onMouseDown={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                        onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                        onTouchStart={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                        onTouchEnd={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      >
                        {slotActionLoading === "restart" ? "⏳" : "🔄 Restart"}
                      </button>
                    </div>

                  </div>{/* конец горизонтального ряда */}

                  {/* ── Снизу: кнопка ❌ Отменить стол ── */}
                  <div style={{
                    opacity: slotActionsOpen ? 1 : 0,
                    pointerEvents: slotActionsOpen ? "auto" : "none",
                    transform: slotActionsOpen ? "translateY(0)" : "translateY(-10px)",
                    transition: "opacity 0.24s ease 0.05s, transform 0.24s cubic-bezier(0.22,1,0.36,1) 0.05s",
                  }}>
                    <button
                      onClick={() => handleSlotAction("cancel")}
                      disabled={!!slotActionLoading}
                      style={{
                        padding: isMobile ? "10px 32px" : "11px 44px",
                        borderRadius: "12px",
                        border: "1.5px solid rgba(255,107,107,0.50)",
                        background: activeTheme === "dark" ? "rgba(35,10,10,0.88)" : "rgba(255,245,245,0.92)",
                        color: "#ff6b6b",
                        WebkitTextFillColor: "#ff6b6b",
                        fontSize: isMobile ? 14 : 15,
                        fontWeight: 800,
                        cursor: slotActionLoading ? "not-allowed" : "pointer",
                        opacity: slotActionLoading === "cancel" ? 0.5 : 1,
                        backdropFilter: "blur(12px)",
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 12px rgba(255,107,107,0.20)",
                        transition: "opacity 0.15s, transform 0.12s",
                      }}
                      onMouseDown={e => { e.currentTarget.style.transform = "scale(0.96)"; }}
                      onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      onTouchStart={e => { e.currentTarget.style.transform = "scale(0.96)"; }}
                      onTouchEnd={e => { e.currentTarget.style.transform = "scale(1)"; }}
                    >
                      {slotActionLoading === "cancel" ? "⏳" : (lang === "fr" ? "❌ Annuler la table" : "❌ Cancel table")}
                    </button>
                  </div>

                  {/* Feedback тост */}
                  {slotActionFeedback && (
                    <div style={{
                      fontSize: 13, fontWeight: 700,
                      color: slotActionFeedback.ok ? "#48dbfb" : "#ff6b6b",
                      WebkitTextFillColor: slotActionFeedback.ok ? "#48dbfb" : "#ff6b6b",
                      background: activeTheme === "dark" ? "rgba(20,20,40,0.90)" : "rgba(245,243,252,0.95)",
                      padding: "5px 16px", borderRadius: "20px",
                      backdropFilter: "blur(8px)",
                      animation: "slotBarIn 0.2s ease",
                      whiteSpace: "nowrap",
                    }}>
                      {slotActionFeedback.ok ? "✓" : "✗"} {slotActionFeedback.msg}
                    </div>
                  )}
                </div>
              )}

              {/* ── Expired: "Session completed" — кнопки Continue / Restart ── */}
              {tableSlotStatus === "expired" && (
                <div style={{
                  position: "absolute",
                  top: isMobile ? "88px" : "100px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 18,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}>
                  {/* Плашка */}
                  <div style={{
                    borderRadius: isMobile ? "16px" : "18px",
                    padding: "2px",
                    background: "linear-gradient(270deg, #22c55e, #86efac, #22c55e)",
                    backgroundSize: "300% 300%",
                    animation: "rainbowRotate 3s linear infinite",
                    boxShadow: "0 4px 20px rgba(34,197,94,0.30)",
                    minWidth: isMobile ? 150 : 200,
                  }}>
                    <div style={{
                      background: activeTheme === "dark" ? "rgba(5,25,10,0.94)" : "rgba(240,255,245,0.97)",
                      borderRadius: isMobile ? "14px" : "16px",
                      padding: isMobile ? "10px 20px 10px" : "12px 24px",
                      textAlign: "center",
                      backdropFilter: "blur(14px)",
                    }}>
                      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", opacity: 0.7, color: "#22c55e", marginBottom: 4 }}>
                        ✅ {lang === "fr" ? "Session terminée — Table" : "Session done — Table"} {tableSlot.table_number}
                      </div>
                      <div style={{ fontSize: isMobile ? 12 : 13, fontWeight: 600, opacity: 0.65, color: themeVars.fg }}>
                        {lang === "fr" ? "Vous pouvez demander un redémarrage" : "You can ask to restart"}
                      </div>
                    </div>
                  </div>

                  {/* Кнопки */}
                  <div style={{ display: "flex", gap: isMobile ? 8 : 12, alignItems: "center" }}>
                    {/* Continue — только если < 120 сек назад */}
                    {(tableSlot.expired_ago ?? 999) < 120 && (
                      <button
                        onClick={() => handleSlotAction("restart")}
                        disabled={!!slotActionLoading}
                        style={{
                          padding: isMobile ? "10px 16px" : "11px 22px",
                          borderRadius: "12px",
                          border: "1.5px solid rgba(34,197,94,0.55)",
                          background: activeTheme === "dark" ? "rgba(5,30,10,0.90)" : "rgba(240,255,245,0.95)",
                          color: "#22c55e", WebkitTextFillColor: "#22c55e",
                          fontSize: isMobile ? 13 : 14, fontWeight: 800,
                          cursor: slotActionLoading ? "not-allowed" : "pointer",
                          opacity: slotActionLoading === "restart" ? 0.5 : 1,
                          backdropFilter: "blur(12px)", whiteSpace: "nowrap",
                          boxShadow: "0 2px 12px rgba(34,197,94,0.25)",
                          transition: "opacity 0.15s, transform 0.12s",
                        }}
                        onMouseDown={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                        onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                        onTouchStart={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                        onTouchEnd={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      >
                        {slotActionLoading === "restart" ? "⏳" : (lang === "fr" ? "▶ Continuer" : "▶ Continue")}
                      </button>
                    )}
                    {/* Restart — в конец очереди */}
                    <button
                      onClick={() => handleSlotAction("restart")}
                      disabled={!!slotActionLoading}
                      style={{
                        padding: isMobile ? "10px 16px" : "11px 22px",
                        borderRadius: "12px",
                        border: "1.5px solid rgba(254,202,87,0.50)",
                        background: activeTheme === "dark" ? "rgba(30,25,10,0.90)" : "rgba(255,252,235,0.95)",
                        color: activeTheme === "dark" ? "#feca57" : "#9a6e00",
                        WebkitTextFillColor: activeTheme === "dark" ? "#feca57" : "#9a6e00",
                        fontSize: isMobile ? 13 : 14, fontWeight: 800,
                        cursor: slotActionLoading ? "not-allowed" : "pointer",
                        opacity: slotActionLoading === "restart" ? 0.5 : 1,
                        backdropFilter: "blur(12px)", whiteSpace: "nowrap",
                        boxShadow: "0 2px 12px rgba(254,202,87,0.22)",
                        transition: "opacity 0.15s, transform 0.12s",
                      }}
                      onMouseDown={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                      onMouseUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                      onTouchStart={e => { e.currentTarget.style.transform = "scale(0.93)"; }}
                      onTouchEnd={e => { e.currentTarget.style.transform = "scale(1)"; }}
                    >
                      {slotActionLoading === "restart" ? "⏳" : (lang === "fr" ? "🔄 Redémarrer" : "🔄 Restart")}
                    </button>
                  </div>

                  {/* Feedback */}
                  {slotActionFeedback && (
                    <div style={{
                      fontSize: 13, fontWeight: 700,
                      color: slotActionFeedback.ok ? "#22c55e" : "#ff6b6b",
                      WebkitTextFillColor: slotActionFeedback.ok ? "#22c55e" : "#ff6b6b",
                      background: activeTheme === "dark" ? "rgba(5,25,10,0.90)" : "rgba(240,255,245,0.95)",
                      padding: "5px 16px", borderRadius: "20px",
                      backdropFilter: "blur(8px)",
                      animation: "slotBarIn 0.2s ease",
                      whiteSpace: "nowrap",
                    }}>
                      {slotActionFeedback.ok ? "✓" : "✗"} {slotActionFeedback.msg}
                    </div>
                  )}
                </div>
              )}

              <div
                className="chat-messages"
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: isMobile ? "12px" : "16px",
                  paddingBottom: isMobile
                    ? `calc(${(selectedUser.type === "ai" && showAiButtons) ? inputHeight + 80 : inputHeight + 16}px + env(safe-area-inset-bottom, 0px) + ${keyboardOffset}px)`
                    : (selectedUser.type === "ai" && showAiButtons ? "150px" : "35px"),
                  background: "transparent",
                  position: "relative",
                  zIndex: 2,
                  WebkitOverflowScrolling: "touch",
                  overscrollBehavior: "contain",
                }}
              >
                <div style={{ height: `${topSpacerHeight}px`, minHeight: `${topSpacerHeight}px`, flexShrink: 0 }} />
                {selectedUser.type === "ai" ? (
                  <>
                    {aiDisplayMessages.map((msg, idx) => {
                      const isAi = msg.sender_id === 0;
                      const isLong = msg.content.length > 120;
                      const isEditing = editingMsgId === msg.id;
                      const bIdx = msg.branch_index ?? 0;
                      const bCount = msg.branch_count ?? 1;
                      return (
                        <div
                          key={msg.id || idx}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: isAi ? "flex-start" : "flex-end",
                            marginBottom: "24px",
                          }}
                        >
                          {isEditing ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: 6, width: "100%", maxWidth: 480 }}>
                              <textarea
                                value={editingText}
                                onChange={(e) => setEditingText(e.target.value)}
                                rows={3}
                                autoFocus
                                style={{ width: "100%", borderRadius: 14, padding: "10px 14px", border: "1px solid rgba(0,0,0,0.15)", fontSize: 15, resize: "vertical", fontFamily: "inherit" }}
                              />
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button type="button" onClick={() => submitEditAiMessage(msg)} disabled={aiLoading} style={AI_EDIT_SAVE_STYLE}>
                                  {lang === "fr" ? "Enregistrer" : "Save"}
                                </button>
                                <button type="button" onClick={cancelEditAiMessage} style={AI_EDIT_CANCEL_STYLE}>
                                  {lang === "fr" ? "Annuler" : "Cancel"}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                background: isAi ? themeVars.ai : themeVars.gradient,
                                color: isAi ? themeVars.fg : "#ffffff",
                                WebkitTextFillColor: isAi ? "unset" : "#ffffff",
                                borderRadius: "18px",
                                padding: "12px 16px",
                                maxWidth: isMobile ? "85%" : "45%",
                                minWidth: isMobile ? "auto" : (isLong ? "280px" : "auto"),
                                wordWrap: "break-word",
                                overflowWrap: "anywhere",
                                whiteSpace: "pre-wrap",
                                boxShadow: isAi ? themeVars.aiBubbleShadow : themeVars.userBubbleShadow,
                                border: isAi ? themeVars.aiBubbleBorder : "none",
                                fontSize: "15px",
                                lineHeight: "1.5",
                                animation: "none",
                              }}
                            >
                              {msg.content}
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              fontSize: "11px",
                              opacity: 0.7,
                              marginTop: "4px",
                              marginLeft: isAi ? "12px" : "0",
                              marginRight: isAi ? "0" : "12px",
                            }}
                          >
                            {bCount > 1 && (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: 2, marginRight: 4 }}>
                                <button type="button" onClick={() => switchAiBranch(msg, -1)} disabled={aiLoading || bIdx <= 0} style={{ ...AI_BRANCH_BTN_STYLE, color: themeVars.fg }}>‹</button>
                                <span>{bIdx + 1}/{bCount}</span>
                                <button type="button" onClick={() => switchAiBranch(msg, 1)} disabled={aiLoading || bIdx >= bCount - 1} style={{ ...AI_BRANCH_BTN_STYLE, color: themeVars.fg }}>›</button>
                              </span>
                            )}
                            {formatMessageTime(msg.timestamp)}
                            {!isAi && msg.can_edit && !isEditing && (
                              <button type="button" onClick={() => startEditAiMessage(msg)} title={lang === "fr" ? "Modifier" : "Edit"} style={{ ...AI_EDIT_BTN_STYLE, color: themeVars.fg }}>✎</button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {aiLoading && (
                      <div
                        style={{
                          position: "absolute",
                          left: "50%",
                          bottom: isMobile ? "100px" : "180px",
                          transform: "translateX(-50%)",
                          background: themeVars.aiLoading,
                          backdropFilter: "blur(12px)",
                          padding: "10px 24px",
                          borderRadius: "999px",
                          color: themeVars.aiLoadingText,
                          fontSize: "14px",
                          fontWeight: "500",
                          whiteSpace: "nowrap",
                          zIndex: 15,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                          border: "1px solid rgba(102,126,234,0.3)",
                          pointerEvents: "none",
                        }}
                      >
                        Thinking
                        <span style={{ marginLeft: "6px" }}>
                          <span className="typing-dot">.</span>
                          <span className="typing-dot">.</span>
                          <span className="typing-dot">.</span>
                        </span>
                      </div>
                    )}

                    <div ref={messagesEndRef} />
                  </>
                ) : (
                  <>
                    {/* ── Match Reason баннер ─────────────────────────────────────────────
                        Данные из selectedUser (matches + match_reason_translations).
                        matchReasonText вычислен выше перед return, вне JSX.
                    ─────────────────────────────────────────────────────────────────── */}
                    {matchReasonText ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "24px",
                          animation: "matchReasonIn 0.3s cubic-bezier(0.22,1,0.36,1)",
                        }}
                      >
                        <div
                          style={{
                            background: activeTheme === "dark"
                              ? "linear-gradient(135deg, rgba(102,126,234,0.28) 0%, rgba(118,75,162,0.22) 100%)"
                              : "linear-gradient(135deg, rgba(102,126,234,0.18) 0%, rgba(118,75,162,0.14) 100%)",
                            backdropFilter: "blur(16px) saturate(180%)",
                            WebkitBackdropFilter: "blur(16px) saturate(180%)",
                            color: themeVars.fg,
                            borderRadius: "18px",
                            overflow: "hidden",
                            // ↓ ширина сужается при сворачивании
                            width: matchReasonCollapsed ? "fit-content" : "85vw",
                            maxWidth: matchReasonCollapsed ? "340px" : "85%",
                            transition: "max-width 0.32s cubic-bezier(0.22,1,0.36,1), width 0.32s cubic-bezier(0.22,1,0.36,1)",
                            boxShadow: activeTheme === "dark"
                              ? "0 4px 20px rgba(102,126,234,0.25), inset 0 1px 0 rgba(255,255,255,0.08)"
                              : "0 4px 20px rgba(102,126,234,0.18), inset 0 1px 0 rgba(255,255,255,0.70)",
                            border: activeTheme === "dark"
                              ? "1px solid rgba(120,140,255,0.28)"
                              : "1px solid rgba(102,126,234,0.25)",
                          }}
                        >
                          {/* ── Заголовок — весь кликабельный ── */}
                          <div
                            onClick={() => setMatchReasonCollapsed(v => !v)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: matchReasonCollapsed ? "10px 16px" : "12px 16px 4px",
                              gap: "8px",
                              cursor: "pointer",
                              userSelect: "none",
                            }}
                          >
                            <span style={{ fontWeight: 600, fontSize: "13px", opacity: 0.75, letterSpacing: "0.04em", textTransform: "uppercase" }}>
                              ✨ {matchReasonLabel}
                            </span>
                            <svg
                              className={`match-reason-chevron${matchReasonCollapsed ? " collapsed" : ""}`}
                              width="16" height="16" viewBox="0 0 12 12" fill="none"
                              style={{ flexShrink: 0, opacity: 0.55 }}
                            >
                              <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>

                          {/* ── Тело — сворачивается ── */}
                          <div
                            className={`match-reason-body${matchReasonCollapsed ? " collapsed" : ""}`}
                            style={{ maxHeight: matchReasonCollapsed ? "0px" : "400px" }}
                          >
                            <div style={{
                              padding: "4px 20px 16px",
                              fontSize: "14px",
                              lineHeight: "1.6",
                              textAlign: "center",
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                            }}>
                              <div style={{ marginBottom: selectedUser.compatibility_score ? "10px" : "0" }}>
                                {matchReasonText}
                              </div>
                              {selectedUser.compatibility_score && (
                                <div style={{ fontSize: "12px", opacity: 0.6, marginTop: "6px" }}>
                                  {matchReasonCompat}: {selectedUser.compatibility_score}%
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {/* ── Table Slot баннер — УБРАН отсюда (теперь под хедером) ── */}

                    {/* Фильтруем is_match_reason — старые -1 сообщения из кеша
                        не должны дублировать баннер выше */}
                    {(selectedUser.type === "support" ? messages : visibleMessages).map((msg) => {
                      // Для support-чата ориентир — sender_kind, для обычных — sender_id.
                      const isSupportChat = selectedUser.type === "support";
                      const isIncoming = isSupportChat
                        ? msg.sender_kind === "support"
                        : msg.sender_id === selectedUser.id;
                      const isSystemMessage = isSupportChat
                        ? msg.sender_kind === "system"
                        : msg.sender_id === 0;
                      return (
                        <div
                          key={msg.id}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: isSystemMessage
                              ? "center"
                              : (isIncoming ? "flex-start" : "flex-end"),
                            marginBottom: "24px",
                          }}
                        >
                          {isSystemMessage ? (
                            <div
                              style={{
                                background: activeTheme === "dark"
                                  ? "linear-gradient(135deg, rgba(102,126,234,0.28) 0%, rgba(118,75,162,0.22) 100%)"
                                  : "linear-gradient(135deg, rgba(102,126,234,0.18) 0%, rgba(118,75,162,0.14) 100%)",
                                backdropFilter: "blur(16px) saturate(180%)",
                                WebkitBackdropFilter: "blur(16px) saturate(180%)",
                                color: themeVars.fg,
                                borderRadius: "18px",
                                padding: "16px 20px",
                                maxWidth: "85%",
                                wordWrap: "break-word",
                                whiteSpace: "pre-wrap",
                                boxShadow: activeTheme === "dark"
                                  ? "0 4px 20px rgba(102,126,234,0.25), inset 0 1px 0 rgba(255,255,255,0.08)"
                                  : "0 4px 20px rgba(102,126,234,0.18), inset 0 1px 0 rgba(255,255,255,0.70)",
                                fontSize: "14px",
                                lineHeight: "1.6",
                                border: activeTheme === "dark"
                                  ? "1px solid rgba(120,140,255,0.28)"
                                  : "1px solid rgba(102,126,234,0.25)",
                                animation: "bubbleMorph 0.35s cubic-bezier(0.22,1,0.36,1) forwards",
                              }}
                            >
                              {msg.is_match_reason
                                ? (lang === "fr" ? msg.content_fr : msg.content_en) || msg.content
                                : msg.content}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                gap: "8px",
                                flexDirection: isIncoming ? "row" : "row-reverse",
                                maxWidth: "100%",
                              }}
                            >
                              {isIncoming && (
                                isSupportChat ? (
                                  <div style={{ width: "36px", height: "36px", flexShrink: 0, borderRadius: "50%", overflow: "hidden", background: "#fff" }}>
                                    <img src={support} alt="Support" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                  </div>
                                ) : (selectedUser?.id && typeof selectedUser.id === "number" && (
                                  <div style={{ width: "36px", height: "36px", flexShrink: 0 }}>
                                    <Avatar key={selectedUser.id} userId={selectedUser.id} size={36} username={selectedUser.username || selectedUser.email || ""} />
                                  </div>
                                ))
                              )}

                              <div
                                style={{
                                  background: isIncoming ? themeVars.chatUser : themeVars.gradient,
                                  color: isIncoming ? themeVars.fg : "#ffffff",
                                  WebkitTextFillColor: isIncoming ? "unset" : "#ffffff",
                                  borderRadius: "18px",
                                  padding: "12px 16px",
                                  maxWidth: isMobile ? "78%" : "45%",
                                  minWidth: isMobile ? "auto" : "180px",
                                  wordWrap: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "pre-wrap",
                                  boxShadow: isIncoming ? themeVars.aiBubbleShadow : themeVars.userBubbleShadow,
                                  border: isIncoming ? themeVars.aiBubbleBorder : "none",
                                  fontSize: "15px",
                                  lineHeight: "1.5",
                                  animation: "bubbleMorph 0.28s cubic-bezier(0.22,1,0.36,1) forwards",
                                }}
                              >
                                {isIncoming && (
                                  <div style={{ fontSize: "11px", opacity: 0.7, marginBottom: "4px", fontWeight: 600 }}>
                                    {isSupportChat ? (msg.sender_name || "Support") : (selectedUser.username || selectedUser.email)}
                                  </div>
                                )}
                                {msg.content}
                              </div>
                            </div>
                          )}

                          <div
                            style={{
                              fontSize: "11px",
                              opacity: 0.6,
                              marginTop: "4px",
                              marginLeft: isSystemMessage
                                ? "0"
                                : (isIncoming ? "12px" : "0"),
                              marginRight: isSystemMessage
                                ? "0"
                                : (isIncoming ? "0" : "12px"),
                            }}
                          >
                            {formatMessageTime(msg.timestamp)}
                          </div>
                        </div>
                      );
                    })}
                    <div ref={messagesEndRef} />
                  </>
                )}
              </div>

              <div
ref={attachmentMenuRef}
className={`chat-input-wrapper ${showAttachmentMenu ? 'menu-open' : ''}`}
style={{
  position: "absolute",
  bottom: isMobile
    ? `calc(env(safe-area-inset-bottom, 0px) + 8px + ${keyboardOffset}px)`
    : "16px",
  left: "50%",
  transform: "translateX(-50%)",
  width: isMobile ? "calc(100% - 10px)" : "min(75%, 880px)",
  maxWidth: "100%",
  padding: isMobile ? "0 4px" : "0 12px",
  zIndex: 100,
  pointerEvents: "none",
  boxSizing: "border-box",
  transition: "bottom 0.18s ease",
}}
>
{/* Кнопка удаления данных — только в чате с поддержкой */}
{selectedUser?.type === "support" && (
  <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px", pointerEvents: "auto" }}>
    {!showDeleteConfirm ? (
      <button
        onClick={() => setShowDeleteConfirm(true)}
        style={{
          padding: "9px 20px",
          borderRadius: "999px",
          border: "1px solid rgba(239,68,68,0.45)",
          background: "rgba(239,68,68,0.12)",
          color: "#ff7b7b",
          fontSize: "13px",
          fontWeight: 600,
          cursor: "pointer",
          backdropFilter: "blur(10px)",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(239,68,68,0.22)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(239,68,68,0.12)"; }}
      >
        🗑 {lang === "fr" ? "Supprimer mes données" : "Delete my data"}
      </button>
    ) : (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          background: themeVars.glassMenuBg,
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(239,68,68,0.35)",
          borderRadius: "999px",
          padding: "8px 16px",
        }}
      >
        <span style={{ color: themeVars.glassText, fontSize: "13px", fontWeight: 500 }}>
          {lang === "fr" ? "Confirmer la suppression ?" : "Confirm deletion?"}
        </span>
        <button
          onClick={handleDeleteAccount}
          style={{
            padding: "6px 16px",
            borderRadius: "999px",
            border: "none",
            background: "rgba(239,68,68,0.75)",
            color: "#fff",
            fontSize: "13px",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          {lang === "fr" ? "Oui, supprimer" : "Yes, delete"}
        </button>
        <button
          onClick={() => setShowDeleteConfirm(false)}
          style={{
            padding: "6px 14px",
            borderRadius: "999px",
            border: `1px solid ${themeVars.glassBorder}`,
            background: "transparent",
            color: themeVars.glassText,
            fontSize: "13px",
            cursor: "pointer",
          }}
        >
          {lang === "fr" ? "Annuler" : "Cancel"}
        </button>
      </div>
    )}
  </div>
)}
<div
  style={{
    position: "relative",
    padding: isMobile ? "8px 10px" : "10px 14px",
    borderRadius: isMobile ? "22px" : "999px",
    gap: isMobile ? "8px" : "12px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    pointerEvents: "auto",
    backdropFilter: "blur(20px) saturate(180%)",
    WebkitBackdropFilter: "blur(20px) saturate(180%)",
    background: themeVars.glassPanel,
    border: `1px solid ${themeVars.glassBorder}`,
    boxShadow: themeVars.glassShadow,
    color: themeVars.glassText,
  }}
>
  <button
    type="button"
    className="attachment-btn icon-btn-pop"
    onClick={(e) => {
      e.stopPropagation();
      if (!(selectedUser?.type === "ai" && showAiButtons)) {
        const willOpen = !showAttachmentMenu;
        setShowAttachmentMenu(willOpen);
        setShowSocialOptions(willOpen);
      }
    }}
    onMouseDown={(e) => { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; }}
    onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.35s cubic-bezier(0.34,1.56,0.64,1)"; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.2s ease"; }}
    onTouchStart={(e) => { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; }}
    onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.35s cubic-bezier(0.34,1.56,0.64,1)"; }}
    disabled={selectedUser?.type === "ai" && showAiButtons}
    style={{
      width: isMobile ? "36px" : "44px",
      height: isMobile ? "36px" : "44px",
      borderRadius: "50%",
      background: 'rgba(99, 102, 241, 0.5)', 
      color: "#fff",
      border: "none",
      fontSize: isMobile ? "18px" : "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      cursor: (selectedUser?.type === "ai" && showAiButtons) ? "not-allowed" : "pointer"
    }}
    title={lang === "fr" ? "Pièces jointes" : "Attachments"}
  >
    <IconAttach size={isMobile ? 20 : 24} color={themeVars.iconColor} />
  </button>
  
  <div
      style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: isMobile ? "calc(100% - 80px)" : "calc(100% - 100px)",
      }}
    >
      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage(e);
          }
        }}
        rows={1}
        placeholder={selectedUser?.type === "ai" && showAiButtons
          ? (lang === "fr" ? "Utilisez les boutons ci-dessous..." : "Use the buttons below...")
          : placeholderText}
        disabled={selectedUser?.type === "ai" && showAiButtons}
        style={{
          width: "100%",
          minHeight: isMobile ? "36px" : "44px",
          maxHeight: isMobile ? "100px" : "140px",
          border: "none",
          outline: "none",
          background: "transparent",
          color: themeVars.glassText,
          fontSize: isMobile ? "14px" : "15px",
          lineHeight: isMobile ? "1.38" : "1.45",
          resize: "none",
          padding: isMobile ? "8px 4px" : "10px 8px",
          opacity: selectedUser?.type === "ai" && showAiButtons ? 0.4 : 1,
          cursor: selectedUser?.type === "ai" && showAiButtons ? "not-allowed" : "text",
        }}
      />
    </div>

    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        sendMessage(e);
      }}
      onMouseDown={(e) => { if (text.trim()) { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; } }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.4s cubic-bezier(0.34,1.56,0.64,1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.2s ease"; }}
      onTouchStart={(e) => { if (text.trim()) { e.currentTarget.style.transform = "scale(0.80)"; e.currentTarget.style.transition = "transform 0.08s ease"; } }}
      onTouchEnd={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.transition = "transform 0.4s cubic-bezier(0.34,1.56,0.64,1)"; }}
      disabled={!text.trim() || (selectedUser?.type === "ai" && aiLoading) || (selectedUser?.type === "ai" && showAiButtons)}
      style={{
        width: isMobile ? "36px" : "44px",
        height: isMobile ? "36px" : "44px",
        borderRadius: "50%",
        background: text.trim()
          ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          : 'rgba(99, 102, 241, 0.5)',
        color: "#ffffff",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: isMobile ? "18px" : "20px",
        cursor: text.trim() ? "pointer" : "not-allowed",
        transition: "all 0.2s ease",
      }}
      className="icon-btn-send"
    >
      {aiLoading
        ? <span style={{ fontSize: isMobile ? "16px" : "18px" }}>⏳</span>
        : <IconSend size={isMobile ? 22 : 26} color={themeVars.iconColor} />
      }
    </button>
    
  </div>

  {/* Attachment Menu */}
  {showAttachmentMenu && (
      <div
        className="attachment-menu-container"
        style={{
          position: 'absolute',
          bottom: '100%',
          left: 0,
          right: 0,
          marginBottom: '8px',
          zIndex: 101,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          pointerEvents: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Блок с социальными кнопками (появляется сверху) */}
        {showSocialOptions && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              //justifyContent: 'space-between',
              alignItems: 'stretch',
              gap: '8px',
              padding: '12px 16px',
              borderRadius: '40px',
              background: themeVars.attachBg,
              border: `1px solid ${themeVars.glassBorder}`,
              boxShadow: themeVars.glassShadow,
              backdropFilter: 'blur(10px)',
              animation: 'slideDown 0.2s ease',
              marginBottom: '4px',
            }}  
          >

            {/* Соц. кнопки — генерируются из SOCIAL_BUTTONS_CONFIG */}
            {[SOCIAL_BUTTONS_CONFIG.slice(0, 4), SOCIAL_BUTTONS_CONFIG.slice(4)].map((row, rowIdx) => (
              <div key={rowIdx} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', width: '100%', alignItems: 'center', gap: '8px' }}>
                {row.map(({ network, icon, placeholder, labelFr }) => (
                  <button
                    key={network}
                    onClick={() => {
                      setSocialLinkModal({ network, label: labelFr && lang === "fr" ? labelFr : network, placeholder });
                      setSocialLinkValue(savedSocialLinks[network] || "");
                    }}
                    className="attachment-menu-btn social-btn"
                    style={{ width: 48, height: 48, background: themeVars.glassMenuBg, border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s ease', padding: 0, flexShrink: 0 }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99, 102, 241, 0.5)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = themeVars.glassMenuBg; }}
                    title={labelFr && lang === "fr" ? labelFr : network}
                  >
                    <img src={icon} alt={network} width={40} height={40} draggable={false} />
                  </button>
                ))}
              </div>
            ))}

          </div>
        )}

        {/* Основной блок с кнопками */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            padding: '12px 16px',
            borderRadius: '40px',
            background: themeVars.attachBg,
            border: `1px solid ${themeVars.glassBorder}`,
            boxShadow: themeVars.glassShadow,
            backdropFilter: 'blur(10px)',
          }}
        >

          {/* Кнопка Upload PDF */}
          <button
            onClick={() => {
              if (selectedUser?.type === "ai") {
                setShowPdfModal(true);
              } else {
                fileInputRef.current?.click();
              }
              setShowAttachmentMenu(false);
              setShowSocialOptions(false);
            }}
            className="attachment-menu-btn"
            style={{
              flex: 1,
              padding: '10px 20px',
              whiteSpace: 'nowrap',
              background: themeVars.glassMenuBg,
              border: 'none',
              borderRadius: '40px',
              color: themeVars.glassText,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              minWidth: 0,
              height: '48px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 0, 0, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = themeVars.glassMenuBg;
            }}
          >
            <span>📄</span>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {lang === "fr" ? "Upload PDF" : "Upload PDF"}
            </span>
          </button>

        </div>
      </div>
    )}
  
  {/* Стили для анимации */}
  <style jsx>{`
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    .attachment-menu-btn {
      transition: all 0.2s ease;
    }
    
    .attachment-menu-btn:hover {
      transform: translateY(-2px);
    }
    
    .attachment-menu-btn:active {
      transform: translateY(0);
    }
    
    /* Стили для круглых кнопок соцсетей */
    .social-btn {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    
    .social-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(111, 0, 255, 0.3);
    }
    
    .back-btn {
      background: rgba(102, 126, 234, 0.8) !important;
    }
    
    .back-btn:hover {
      background: rgba(102, 126, 234, 0.5) !important;
    }
  `}
  </style>
</div>

              {selectedUser.type === "ai" && showAiButtons && (
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: isMobile
                      ? `calc(${inputHeight}px + env(safe-area-inset-bottom, 0px) + ${keyboardOffset}px + 8px)`
                      : `calc(${inputHeight}px + 16px)`,
                    padding: isMobile ? "0 8px 4px" : "0 16px 8px",
                    zIndex: 50,
                    pointerEvents: "none",
                  }}
                >
                  <style>{`
                    .ai-action-btn {
                      transition: transform 0.18s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.18s ease, opacity 0.15s ease, filter 0.18s ease;
                      -webkit-tap-highlight-color: transparent;
                      transform: translateY(0) scale(1);
                    }
                    .ai-action-btn:not(:disabled):hover {
                      transform: translateY(-2px) scale(1.03);
                      box-shadow: 0 6px 20px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.12) !important;
                      filter: brightness(1.15);
                    }
                    .ai-action-btn:not(:disabled):active,
                    .ai-action-btn:not(:disabled).touching {
                      transform: translateY(1px) scale(0.96);
                      box-shadow: 0 1px 4px rgba(0,0,0,0.18) !important;
                      filter: brightness(0.92);
                      transition: transform 0.08s ease, box-shadow 0.08s ease, filter 0.08s ease;
                    }
                    .ai-action-btn:disabled {
                      cursor: not-allowed;
                    }
                  `}</style>
                  <AiActionButtons
                    lang={lang}
                    onStartMatch={startMatch}
                    onFindAnother={findAnotherMatch}
                    startDisabled={startMatchingDisabled}
                    loading={aiLoading}
                    matchingDone={matchingDone}
                    variant="glass"
                    isMobile={isMobile}
                    themeVars={themeVars}
                  />
                </div>
              )}
            </div>

            <input
              id="file-upload"
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) console.log("Selected file: ", file.name);
                e.target.value = null;
              }}
            />
          </div>
        </div>
      )}

      {/* Пустой экран при отсутствии выбранного чата (только на десктопе) */}
      {!selectedUser && !isMobile && (
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: themeVars.fg,
            opacity: 0.5,
            padding: "40px",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "360%",
              background: `${themeVars.border}20`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
              fontSize: "32px",
              opacity: 0.7,
            }}
          >
            💬
          </div>
          <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "8px" }}>
            {translations[lang]?.yourDialogs || "Your Dialogs"}
          </div>
          <div style={{ fontSize: "14px", opacity: 0.7 }}>
            {lang === "fr"
              ? "Sélectionnez une conversation pour commencer à discuter"
              : "Select a conversation to start messaging"}
          </div>
        </div>
      )}

      {/* === МОДАЛ ДЛЯ ВВОДА ССЫЛКИ НА СОЦСЕТЬ === */}
      {socialLinkModal && (
        <div
          onClick={() => { setSocialLinkModal(null); setSocialLinkValue(""); }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.55)',
            backdropFilter: 'blur(6px)',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: themeVars.glassMenuBg,
              border: `1px solid ${themeVars.glassBorder}`,
              borderRadius: '24px',
              padding: '28px 28px 24px',
              width: '90%',
              maxWidth: '420px',
              boxShadow: themeVars.glassShadow,
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ color: themeVars.glassText, fontWeight: 700, fontSize: '16px' }}>
                {lang === "fr" ? `Votre lien ${socialLinkModal.label}` : `Your ${socialLinkModal.label} link`}
              </span>
              <button
                onClick={() => { setSocialLinkModal(null); setSocialLinkValue(""); }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: themeVars.glassText,
                  opacity: 0.6,
                  fontSize: '20px',
                  cursor: 'pointer',
                  lineHeight: 1,
                  padding: '2px 6px',
                }}
              >×</button>
            </div>
            <input
              autoFocus
              type="text"
              value={socialLinkValue}
              onChange={(e) => setSocialLinkValue(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSocialLinkSubmit(); }}
              placeholder={socialLinkModal.placeholder}
              style={{
                background: themeVars.glassPanel,
                border: `1px solid ${themeVars.glassBorder}`,
                borderRadius: '14px',
                padding: '12px 16px',
                color: themeVars.glassText,
                fontSize: '14px',
                outline: 'none',
                width: '100%',
                boxSizing: 'border-box',
              }}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => { setSocialLinkModal(null); setSocialLinkValue(""); }}
                style={{
                  flex: 1,
                  padding: '11px',
                  borderRadius: '12px',
                  border: `1px solid ${themeVars.glassBorder}`,
                  background: themeVars.glassPanel,
                  color: themeVars.glassText,
                  fontSize: '14px',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >{lang === "fr" ? "Annuler" : "Cancel"}</button>
              <button
                onClick={handleSocialLinkSubmit}
                disabled={!socialLinkValue.trim()}
                style={{
                  flex: 1,
                  padding: '11px',
                  borderRadius: '12px',
                  border: 'none',
                  background: socialLinkValue.trim()
                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    : 'rgba(102,126,234,0.25)',
                  color: '#ffffff',
                  fontSize: '14px',
                  cursor: socialLinkValue.trim() ? 'pointer' : 'not-allowed',
                  fontWeight: 700,
                  transition: 'all 0.2s ease',
                }}
              >{lang === "fr" ? "Envoyer" : "Send"}</button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ ПОПАП ПРОФИЛЯ СОБЕСЕДНИКА ═══ */}
      {showUserProfile && selectedUser?.type === "user" && (
        <div
          onClick={() => { setShowUserProfile(false); setShowAvatarFull(false); }}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9998,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            animation: "profileOverlayIn 0.2s ease forwards",
            padding: isMobile ? "32px 12px 12px" : "24px",
            boxSizing: "border-box",
          }}
        >
          <style>{`
            @keyframes profileOverlayIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes profileCardIn {
              from { opacity: 0; transform: translateY(20px) scale(0.95); }
              to { opacity: 1; transform: translateY(0) scale(1); }
            }
            @keyframes avatarFullIn {
              from { opacity: 0; transform: scale(0.85); }
              to { opacity: 1; transform: scale(1); }
            }
            .profile-avatar-override * {
              border-radius: 0 !important;
            }
            .profile-avatar-override > * {
              width: 100% !important;
              height: 100% !important;
              display: block !important;
            }
            .profile-avatar-override img {
              border-radius: 0 !important;
              width: 100% !important;
              height: 100% !important;
              object-fit: cover !important;
              display: block !important;
            }
            .profile-section-divider {
              display: flex;
              align-items: center;
              gap: 12px;
              margin-bottom: 12px;
              flex-shrink: 0;
            }
            .profile-section-divider::before,
            .profile-section-divider::after {
              content: "";
              flex: 1;
              height: 1px;
              background: ${activeTheme === "dark" ? "rgba(140,160,255,0.16)" : "rgba(120,100,220,0.16)"};
            }
            .profile-section-divider span {
              font-size: 10px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 1.2px;
              color: ${activeTheme === "dark" ? "rgba(200,212,255,0.40)" : "rgba(80,60,160,0.40)"};
              white-space: nowrap;
              flex-shrink: 0;
            }
          `}</style>

          {/* ── Fullscreen avatar overlay ── */}
          {showAvatarFull && (
            <div
              onClick={(e) => { e.stopPropagation(); setShowAvatarFull(false); }}
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 10000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(0,0,0,0.88)",
                animation: "avatarFullIn 0.2s ease forwards",
                cursor: "zoom-out",
              }}
            >
              <div className="profile-avatar-override" style={{
                width: "min(90vw, 90vh)",
                height: "min(90vw, 90vh)",
                borderRadius: "0 !important",
              }}>
                <Avatar key={selectedUser.id} userId={selectedUser.id} size={800} username={selectedUser.username || selectedUser.email || ""} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
              </div>
              <button
                onClick={(e) => { e.stopPropagation(); setShowAvatarFull(false); }}
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  width: "44px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.20)",
                  borderRadius: "50%",
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: "22px",
                  fontWeight: 300,
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.22)"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; }}
              >✕</button>
            </div>
          )}

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              flexDirection: "column",
              borderRadius: "0px",
              width: isMobile ? "100%" : "460px",
              maxWidth: isMobile ? "420px" : "460px",
              height: isMobile ? "min(calc(100dvh - 16px), 640px)" : "calc(100vh - 150px)",
              overflow: "hidden",
              backdropFilter: "blur(48px) saturate(240%)",
              WebkitBackdropFilter: "blur(48px) saturate(240%)",
              background: activeTheme === "dark"
                ? "rgba(14, 18, 42, 0.86)"
                : "rgba(230, 226, 255, 0.88)",
              border: `1px solid ${activeTheme === "dark" ? "rgba(140,160,255,0.20)" : "rgba(120,100,220,0.20)"}`,
              boxShadow: activeTheme === "dark"
                ? "0 40px 100px rgba(0,0,0,0.70), 0 0 0 0.5px rgba(140,160,255,0.10)"
                : "0 40px 100px rgba(70,50,160,0.30), 0 0 0 0.5px rgba(120,100,220,0.12)",
              animation: "profileCardIn 0.26s cubic-bezier(0.22,1,0.36,1) forwards",
              position: "relative",
            }}
          >
            {/* ── Аватарка — кликабельная для fullscreen ── */}
            <div
              className="profile-avatar-override"
              onClick={() => setShowAvatarFull(true)}
              style={{
                width: "100%",
                aspectRatio: "1 / 1",
                maxHeight: isMobile ? "46vw" : "280px",
                overflow: "hidden",
                position: "relative",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: activeTheme === "dark" ? "#0e122a" : "#d8d4f8",
                cursor: "zoom-in",
              }}
            >
              <Avatar key={selectedUser.id} userId={selectedUser.id} size={460} username={selectedUser.username || selectedUser.email || ""} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />

              {/* Градиент снизу */}
              <div style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "50%",
                background: activeTheme === "dark"
                  ? "linear-gradient(to bottom, transparent, rgba(14,18,42,0.92))"
                  : "linear-gradient(to bottom, transparent, rgba(230,226,255,0.94))",
                pointerEvents: "none",
              }} />
            </div>

            {/* ── Username + all content — scrollable ── */}
            <div style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}>

            {/* ── Username bar ── */}
            <div style={{
              padding: "12px 18px 10px",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}>
              <div style={{
                fontWeight: 700,
                fontSize: "19px",
                letterSpacing: "-0.3px",
                color: activeTheme === "dark" ? "#eef0ff" : "#1a1060",
                lineHeight: 1.2,
                wordBreak: "break-word",
                flex: 1,
              }}>
                {selectedUser.username || selectedUser.email}
              </div>
            </div>

            {/* ── Sections ── */}
            <div style={{ padding: "0 18px 18px", display: "flex", flexDirection: "column" }}>

              {/* ── Match Rating section ── */}
              {selectedUser.match_id && (
                <>
                  <div className="profile-section-divider">
                    <span>{lang === "fr" ? "Évaluer ce match" : "Rate this match"}</span>
                  </div>
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "18px",
                    padding: "14px 10px 12px",
                    borderRadius: "16px",
                    background: activeTheme === "dark"
                      ? "rgba(102,126,234,0.09)"
                      : "rgba(102,126,234,0.06)",
                    border: `1px solid ${activeTheme === "dark" ? "rgba(120,140,255,0.14)" : "rgba(102,126,234,0.12)"}`,
                    flexShrink: 0,
                  }}>
                    {/* Stars row */}
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      {[1,2,3,4,5].map(star => {
                        const filled = (ratingHover ?? matchRating ?? 0) >= star;
                        return (
                          <button
                            key={star}
                            className={`star-btn${filled && !ratingHover && matchRating === star ? " star-active" : ""}`}
                            disabled={ratingLoading}
                            onMouseEnter={() => setRatingHover(star)}
                            onMouseLeave={() => setRatingHover(null)}
                            onClick={() => handleRateMatch(star)}
                            style={{ opacity: ratingLoading ? 0.5 : 1 }}
                          >
                            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                              style={{ transition: "transform 0.15s cubic-bezier(0.22,1,0.36,1), filter 0.15s ease",
                                filter: filled
                                  ? "drop-shadow(0 2px 6px rgba(255,196,0,0.55))"
                                  : "none",
                                transform: ratingHover === star ? "scale(1.22) translateY(-2px)" : "scale(1)",
                              }}
                            >
                              <path
                                d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                                fill={filled
                                  ? (ratingHover
                                    ? "#ffd700"
                                    : (matchRating >= star ? "#ffc400" : "#ffd700"))
                                  : (activeTheme === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.10)")}
                                stroke={filled
                                  ? (ratingHover ? "#ffaa00" : "#e6a800")
                                  : (activeTheme === "dark" ? "rgba(255,255,255,0.20)" : "rgba(0,0,0,0.16)")}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                        );
                      })}
                    </div>

                    {/* Status label */}
                    <div style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      minHeight: "18px",
                      color: ratingJustSaved
                        ? (activeTheme === "dark" ? "#86efac" : "#16a34a")
                        : (activeTheme === "dark" ? "rgba(200,212,255,0.50)" : "rgba(80,60,160,0.45)"),
                      animation: ratingJustSaved ? "ratingBadgePulse 0.4s ease" : "none",
                      transition: "color 0.25s ease",
                    }}>
                      {ratingJustSaved
                        ? (lang === "fr" ? "✓ Évaluation enregistrée" : "✓ Rating saved")
                        : matchRating
                          ? (ratingHover
                              ? ["", "★", "★★", "★★★", "★★★★", "★★★★★"][ratingHover]
                              : (lang === "fr" ? `Votre note : ${matchRating}/5` : `Your rating: ${matchRating}/5`))
                          : (lang === "fr" ? "Cliquez pour évaluer" : "Click to rate")}
                    </div>
                  </div>
                </>
              )}

              {/* ── Social Links section ── */}
              {Object.keys(partnerSocialLinks).length > 0 && (<>
                <div className="profile-section-divider">
                  <span>{lang === "fr" ? "Liens sociaux" : "Social links"}</span>
                </div>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "16px", flexShrink: 0 }}>
                  {Object.entries(partnerSocialLinks).map(([network, url]) => {
                    const iconMap = {
                      telegram: telegramIcon,
                      instagram: instagramIcon,
                      linkedin: linkedinIcon,
                      facebook: facebookIcon,
                      whatsapp: whatsappIcon,
                      email: emailIcon,
                      phone: phoneIcon,
                      outlook: outlookIcon,
                    };
                    const icon = iconMap[network.toLowerCase()];
                    const href = network.toLowerCase() === "phone"
                      ? `tel:${url}`
                      : network.toLowerCase() === "email"
                        ? `mailto:${url}`
                        : url.startsWith("http") ? url : `https://${url}`;
                    return (
                      <a
                        key={network}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={`${network}: ${url}`}
                        onClick={e => e.stopPropagation()}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "44px",
                          height: "44px",
                          borderRadius: "14px",
                          background: activeTheme === "dark"
                            ? "rgba(140,160,255,0.10)"
                            : "rgba(120,100,220,0.08)",
                          border: `1px solid ${activeTheme === "dark" ? "rgba(140,160,255,0.22)" : "rgba(120,100,220,0.18)"}`,
                          transition: "transform 0.15s ease, box-shadow 0.15s ease",
                          textDecoration: "none",
                          flexShrink: 0,
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = "scale(1.12)";
                          e.currentTarget.style.boxShadow = activeTheme === "dark"
                            ? "0 4px 16px rgba(140,160,255,0.25)"
                            : "0 4px 16px rgba(100,80,200,0.20)";
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = "";
                          e.currentTarget.style.boxShadow = "";
                        }}
                      >
                        {icon
                          ? <img src={icon} alt={network} style={{ width: "24px", height: "24px" }} />
                          : <span style={{ fontSize: "12px", fontWeight: 700, color: activeTheme === "dark" ? "#c8d4ff" : "#4a3090" }}>{network[0].toUpperCase()}</span>
                        }
                      </a>
                    );
                  })}
                </div>
              </>)}

              {/* ── Match Reason section ── */}
              {selectedUser.match_reason && (<>
                <div className="profile-section-divider">
                  <span>{lang === "fr" ? "Raison du match" : "Match reason"}</span>
                </div>
                <div style={{
                  fontSize: "13px",
                  lineHeight: 1.65,
                  color: activeTheme === "dark" ? "rgba(200,212,255,0.72)" : "rgba(45,30,110,0.65)",
                  fontStyle: "italic",
                  marginBottom: "16px",
                  padding: "10px 13px",
                  borderRadius: "12px",
                  flexShrink: 0,
                  background: activeTheme === "dark"
                    ? "rgba(102,126,234,0.10)"
                    : "rgba(102,126,234,0.07)",
                  border: `1px solid ${activeTheme === "dark" ? "rgba(120,140,255,0.16)" : "rgba(102,126,234,0.14)"}`,
                }}>
                  {selectedUser.match_reason}
                </div>
              </>)}

              {/* ── About User section — fills remaining space, scrollable ── */}
              {selectedUser.about ? (<>
                <div className="profile-section-divider">
                  <span>{lang === "fr" ? "À propos" : "About user"}</span>
                </div>
                <div style={{
                  fontSize: "14px",
                  lineHeight: 1.65,
                  color: activeTheme === "dark" ? "rgba(200,212,255,0.82)" : "rgba(45,30,110,0.76)",
                  flex: 1,
                  minHeight: "40px",
                }}>
                  {selectedUser.about}
                </div>
              </>) : !selectedUser.match_reason && Object.keys(partnerSocialLinks).length === 0 ? (
                <div style={{
                  fontSize: "13px",
                  fontStyle: "italic",
                  color: activeTheme === "dark" ? "rgba(200,212,255,0.28)" : "rgba(100,80,180,0.36)",
                }}>
                  {lang === "fr" ? "Aucune description" : "No description yet"}
                </div>
              ) : null}
            </div>{/* end sections padding */}
            </div>{/* end scrollable */}

            {/* ── Кнопка закрыть — более заметная ── */}
            <button
              onClick={() => { setShowUserProfile(false); setShowAvatarFull(false); }}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                width: "38px",
                height: "38px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(0,0,0,0.50)",
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                border: "1.5px solid rgba(255,255,255,0.22)",
                borderRadius: "50%",
                cursor: "pointer",
                color: "#ffffff",
                fontSize: "20px",
                fontWeight: 300,
                lineHeight: 1,
                transition: "all 0.15s ease",
                zIndex: 2,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(220,60,60,0.70)";
                e.currentTarget.style.borderColor = "rgba(255,120,120,0.50)";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(0,0,0,0.50)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.22)";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >✕</button>
          </div>
        </div>
      )}

      <MessageAnimations theme={activeTheme} />
    </div>
  );
}
